webpackJsonp([58],{

/***/ "+Rc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/krl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "0XWP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/knowdiabetes.b5245e7.png";

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2KHa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__ = __webpack_require__("atVG");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6aa529_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__ = __webpack_require__("Nwy1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6aa529_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5Q+W":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./App": [
		"M93x"
	],
	"./App.vue": [
		"M93x"
	],
	"./assets/css/magnifier.css": [
		"gJP/",
		4
	],
	"./assets/css/main.css": [
		"CuRo",
		2
	],
	"./assets/css/mainB.css": [
		"Hzte",
		1
	],
	"./assets/images/admin-icon.svg": [
		"R0tV",
		56
	],
	"./assets/images/analytics-icon.svg": [
		"gaDJ",
		55
	],
	"./assets/images/analyticsboard.svg": [
		"rR+j"
	],
	"./assets/images/android.svg": [
		"LuwU",
		54
	],
	"./assets/images/app-store.svg": [
		"M5fD",
		53
	],
	"./assets/images/backend.svg": [
		"NBJa",
		52
	],
	"./assets/images/backendwhite.svg": [
		"8hai"
	],
	"./assets/images/banner-gfx-blue.svg": [
		"/mfR",
		51
	],
	"./assets/images/banner-gfx.svg": [
		"Z1fh",
		50
	],
	"./assets/images/banner-slide.svg": [
		"gTfg",
		49
	],
	"./assets/images/casual-dark-large.jpg": [
		"qa5M",
		48
	],
	"./assets/images/casual-dark.png": [
		"+kF5",
		47
	],
	"./assets/images/casual-light-large.jpg": [
		"6wVn",
		46
	],
	"./assets/images/casual-light.png": [
		"OXBq"
	],
	"./assets/images/clientapps.svg": [
		"m8ch"
	],
	"./assets/images/cross.svg": [
		"VC5H",
		45
	],
	"./assets/images/dashboard-slide (copy).svg": [
		"YxAv",
		44
	],
	"./assets/images/dashboard-slide.svg": [
		"9ms9",
		43
	],
	"./assets/images/gfx-blue.svg": [
		"UMYF",
		42
	],
	"./assets/images/gfx-bot-blue.svg": [
		"zn3l",
		41
	],
	"./assets/images/gfx-bot.svg": [
		"ExfC"
	],
	"./assets/images/gfx-dash-bot-blue.svg": [
		"MUfx",
		40
	],
	"./assets/images/gfx-dash-bot.svg": [
		"cj/f",
		39
	],
	"./assets/images/gfx-dash-mid-blue.svg": [
		"/YaY",
		38
	],
	"./assets/images/gfx-dash-mid.svg": [
		"AxnV",
		37
	],
	"./assets/images/gfx-f-bot-blue.svg": [
		"Xp4J",
		36
	],
	"./assets/images/gfx-f-bot.svg": [
		"FKnI",
		35
	],
	"./assets/images/gfx-small-blue.svg": [
		"u7CD",
		34
	],
	"./assets/images/gfx-small.svg": [
		"Dz47",
		33
	],
	"./assets/images/gfx.svg": [
		"+4o1",
		32
	],
	"./assets/images/gfx4-blue.svg": [
		"bwk1",
		31
	],
	"./assets/images/gfx4.svg": [
		"JHgH",
		30
	],
	"./assets/images/icons/VOD.svg": [
		"/wxl",
		29
	],
	"./assets/images/icons/admin-icon.svg": [
		"NIt2"
	],
	"./assets/images/icons/analytics-icon.svg": [
		"NMNL"
	],
	"./assets/images/icons/drm.svg": [
		"N13/"
	],
	"./assets/images/icons/drm_security.svg": [
		"ATNA",
		28
	],
	"./assets/images/icons/instant-icon.svg": [
		"mOkF"
	],
	"./assets/images/icons/livevideo.svg": [
		"UuJc"
	],
	"./assets/images/icons/modes-icon.svg": [
		"Oppg"
	],
	"./assets/images/icons/monetization.svg": [
		"OOdf"
	],
	"./assets/images/icons/notifications-icon.svg": [
		"V0ik"
	],
	"./assets/images/icons/reliable-icon.svg": [
		"bb4/",
		27
	],
	"./assets/images/icons/social-icon.svg": [
		"YzmF"
	],
	"./assets/images/icons/streaming-icon.svg": [
		"aGEH"
	],
	"./assets/images/instant-icon.svg": [
		"Ca5k",
		26
	],
	"./assets/images/knowdiabetes.png": [
		"0XWP"
	],
	"./assets/images/lattu-logo.png": [
		"LFdq"
	],
	"./assets/images/loader.gif": [
		"x4IX",
		25
	],
	"./assets/images/loader1.gif": [
		"OlGi",
		24
	],
	"./assets/images/loading.gif": [
		"F7NO",
		23
	],
	"./assets/images/logo_white.svg": [
		"vX6J"
	],
	"./assets/images/mobiotics-logo-horizontal.svg": [
		"/krl"
	],
	"./assets/images/modern-dark-large.jpg": [
		"mTID",
		22
	],
	"./assets/images/modern-dark.png": [
		"7uIX",
		21
	],
	"./assets/images/modern-dark_bak.png": [
		"2s4t",
		20
	],
	"./assets/images/modern-light-large.jpg": [
		"cOLk",
		19
	],
	"./assets/images/modern-light.png": [
		"woOV"
	],
	"./assets/images/modern-light_bak.png": [
		"ScJP",
		18
	],
	"./assets/images/modes-icon.svg": [
		"p0YP",
		17
	],
	"./assets/images/notifications-icon.svg": [
		"Wx6j",
		16
	],
	"./assets/images/purple_slide.svg": [
		"/cgy",
		15
	],
	"./assets/images/purple_slide1.svg": [
		"gWYq",
		14
	],
	"./assets/images/reliable-icon.svg": [
		"F3br",
		13
	],
	"./assets/images/sampleimage.svg": [
		"HgLU",
		12
	],
	"./assets/images/social-icon.svg": [
		"3UzA",
		11
	],
	"./assets/images/streaming-icon.svg": [
		"/74Y",
		10
	],
	"./assets/images/tick-blue.svg": [
		"bYXl",
		9
	],
	"./assets/images/tick.svg": [
		"hQsS",
		8
	],
	"./assets/images/v-lite-white-logo.svg": [
		"aUqx"
	],
	"./assets/images/vLiteLogo.png": [
		"zxL4",
		7
	],
	"./assets/images/vlive.png": [
		"MiBM"
	],
	"./assets/images/vlive@2x.png": [
		"ZDQv",
		6
	],
	"./assets/images/vlive@3x.png": [
		"c+KN",
		5
	],
	"./assets/js/Event": [
		"nHYM"
	],
	"./assets/js/Event.js": [
		"nHYM"
	],
	"./assets/js/Magnifier": [
		"VL+T"
	],
	"./assets/js/Magnifier.js": [
		"VL+T"
	],
	"./assets/js/config": [
		"vgQg"
	],
	"./assets/js/config.js": [
		"vgQg"
	],
	"./assets/js/helpers": [
		"2pwR",
		0
	],
	"./assets/js/helpers.js": [
		"2pwR",
		0
	],
	"./components/Dashboard": [
		"TGvd"
	],
	"./components/Dashboard.vue": [
		"TGvd"
	],
	"./components/Democonfirm": [
		"6MUd"
	],
	"./components/Democonfirm.vue": [
		"6MUd"
	],
	"./components/Emailverify": [
		"KCOl"
	],
	"./components/Emailverify.vue": [
		"KCOl"
	],
	"./components/Failed": [
		"zweM"
	],
	"./components/Failed.vue": [
		"zweM"
	],
	"./components/HelloWorld": [
		"gORT"
	],
	"./components/HelloWorld.vue": [
		"gORT"
	],
	"./components/Home": [
		"lO7g"
	],
	"./components/Home.vue": [
		"lO7g"
	],
	"./components/Reqdemo": [
		"JIAy"
	],
	"./components/Reqdemo.vue": [
		"JIAy"
	],
	"./components/Success": [
		"2KHa"
	],
	"./components/Success.vue": [
		"2KHa"
	],
	"./components/Test": [
		"ua3t"
	],
	"./components/Test.vue": [
		"ua3t"
	],
	"./main": [
		"NHnr"
	],
	"./main.js": [
		"NHnr"
	],
	"./router": [
		"YaEn"
	],
	"./router/": [
		"YaEn"
	],
	"./router/index": [
		"YaEn"
	],
	"./router/index.js": [
		"YaEn"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5Q+W";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "6MUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Democonfirm_vue__ = __webpack_require__("epRE");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330beb6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Democonfirm_vue__ = __webpack_require__("nAHX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Democonfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330beb6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Democonfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8hai":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "A8UF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-component"},[_c('div',{attrs:{"id":"headerelement"}},[(_vm.showfixedheader)?_c('fixed-header',{attrs:{"fixed":_vm.isFixed},on:{"update:fixed":function($event){_vm.isFixed=$event}}},[_c('nav',{staticClass:"navbar",class:{ 'is-light-home': _vm.isFixed, 'is-primary-home': !_vm.isFixed }},[_c('container',[(_vm.normaldevice)?_c('header',[_c('div',{staticClass:"inner",staticStyle:{"padding-top":"20px"}},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#howitwork'),expression:"'#howitwork'"}],attrs:{"href":"#"}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#features'),expression:"'#features'"}],attrs:{"href":"#"}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])]),_vm._v(" "),_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],staticClass:"btn-head banner-head-get-btn raise banner-head-red-btn",attrs:{"type":"button"}},[_vm._v("SUBSCRIBE")])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('header',[_c('div',{staticClass:"inner-sm"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('button',{staticClass:"btn-hamb",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"})]),_vm._v(" "),_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],staticClass:"btn-head banner-head-get-btn raise banner-head-red-btn",attrs:{"type":"button"}},[_vm._v("SUBSCRIBE")])])],1)],1)]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner landing-banner"},[_c('container',[(_vm.normaldevice)?_c('header',[_c('div',{staticClass:"inner"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#howitwork'),expression:"'#howitwork'"}],attrs:{"href":"#"}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#features'),expression:"'#features'"}],attrs:{"href":"#"}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('header',[_c('div',{staticClass:"inner-sm"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('button',{staticClass:"btn-hamb",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"})])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebarVisible),expression:"sidebarVisible"}],staticClass:"sidebar"},[_c('div',{staticClass:"menus"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#howitwork'),expression:"'#howitwork'"}],attrs:{"href":"#"},on:{"click":_vm.toggleSidebar}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#features'),expression:"'#features'"}],attrs:{"href":"#"},on:{"click":_vm.toggleSidebar}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"},on:{"click":_vm.toggleSidebar}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"},on:{"click":_vm.toggleSidebar}},[_vm._v("BLOG")])])])]),_vm._v(" "),_c('button',{staticClass:"btn-close-sidebar",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"2.5","name":"times"}})],1)])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"white-text"},[_vm._v("DIY Video SAAS Platform")]),_vm._v(" "),_c('h2',{staticClass:"white-text"},[_c('div',{},[_vm._v("\n                        Build your own\n                        "),_c('div',{staticClass:"rotating-words"},[_c('span',[_c('strong',[_vm._v("E-Learning")])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Video OTT")])])])]),_vm._v(" "),_c('div',{},[_vm._v("\n                            Platform like\n                            "),_c('div',{staticClass:"rotating-words1"},[_c('span',[_c('strong',[_vm._v("Khan Academy™")]),_vm._v(" and "),_c('strong',[_vm._v("Udemy™")]),_vm._v(" in 24 hours")]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Netflix™")]),_vm._v(" and "),_c('strong',[_vm._v("Hotstar™")]),_vm._v(" in 24 hours")])])])]),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"zindex101",attrs:{"size":"7/12"}},[_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],staticClass:"btn banner-get-btn raise",attrs:{"type":"button"}},[_vm._v("SUBSCRIBE")]),_vm._v(" "),_c('button',{staticClass:"btn banner-get-btn-landing uppercase raise",attrs:{"type":"button"},on:{"click":function($event){return _vm.navigateToDemoPage()}}},[_vm._v("CHECK DEMO")])]),_vm._v(" "),_c('grid-item',{staticClass:"v-middle zindex101 relative",attrs:{"size":"5/12"}},[_c('div',{staticClass:"trophy-image"})])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"banner",class:_vm.landbanslide})],1),_vm._v(" "),_c('div',{attrs:{"id":"remaingele"}},[_c('div',{staticClass:"vl-what-is-it-div",attrs:{"id":"vl-what-is-it"}},[_c('container',{staticClass:"vl-how-works"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:" left-align-text",attrs:{"size":"8/12"}},[_c('h1',[_vm._v("What is it?")])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/12"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:" left-align-text",attrs:{"size":"8/12"}},[_c('p',[_c('strong',[_vm._v("vLite™")]),_vm._v(" is the leading DIY Video SAAS platform for entertainment and education. Now launch your E-Learning or Entertainment OTT solution in 24 hours with branded native apps on "),_c('strong',[_vm._v("iOS, Android")]),_vm._v(" and "),_c('strong',[_vm._v("Web.")])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/12"}})],1),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:" left-align-text",attrs:{"size":"8/12"}},[_c('p',[_vm._v("MSOs, LCOs, Content Owners and "),_c('strong',[_vm._v("Youtube™")]),_vm._v(" stars - Launch your own video OTT solution like "),_c('strong',[_vm._v("Netflix™, Hulu™ or Hotstar™")]),_vm._v(" within few hours. Support both Live and VOD content as needed.")])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/12"}})],1)],1),_vm._v(" "),_c('container',[_c('grid',{attrs:{"horizontal":"center"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3.3/12"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("8hai")}}),_vm._v(" "),_c('p',{staticClass:"vl-icon-disc"},[_vm._v("Easy Management")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3.3/12"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("rR+j")}}),_vm._v(" "),_c('p',{staticClass:"vl-icon-disc"},[_vm._v("Realtime Data")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3.3/12"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("m8ch")}}),_vm._v(" "),_c('p',{staticClass:"vl-icon-disc"},[_vm._v("Native Apps")])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/12"}})],1)],1),_vm._v(" "),_c('container',{staticClass:"vl-how-works"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:" left-align-text",attrs:{"size":"8/12"}},[_c('p',[_vm._v("Universities, colleges, schools, coaching institutes and corporate trainers - Launch your own E-Learning platform like "),_c('strong',[_vm._v("Khan Academy™, Udemy™ or Coursera™")]),_vm._v(" within few hours.")])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/12"}})],1),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:" left-align-text",attrs:{"size":"8/12"}},[_c('p',[_vm._v("Built on reliable,secure cloud infrastructure, "),_c('strong',[_vm._v("vLite™")]),_vm._v(" provides easy delivery, management and monetization options for your live/entertainment/education content.")])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/12"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"vl-wrks"},[_c('div',{class:_vm.workrect},[_c('container',[_c('grid',{attrs:{"horizontal":"center"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:"work-rectangle-pos white-text center",attrs:{"size":"3/12"}},[_c('p',{class:_vm.workrectcount,attrs:{"id":"ban-count-start"}},[_c('countTo',{ref:"example1",attrs:{"startVal":60000,"endVal":80000,"duration":3000}}),_vm._v(" "),_c('span',{class:_vm.workrecttext},[_vm._v("Viewers")])],1)]),_vm._v(" "),_c('grid-item',{staticClass:"work-rectangle-pos white-text center",attrs:{"size":"3/12"}},[_c('p',{class:_vm.workrectcount},[_c('countTo',{ref:"example2",attrs:{"startVal":50,"endVal":500,"duration":3000}}),_vm._v(" "),_c('span',{class:_vm.workrecttext},[_vm._v("Hours of Content ")])],1)]),_vm._v(" "),_c('grid-item',{staticClass:"work-rectangle-pos white-text center",attrs:{"size":"3/12"}},[_c('p',{class:_vm.workrectcount},[_c('countTo',{ref:"example3",attrs:{"startVal":30000,"endVal":50000,"duration":3000}}),_vm._v(" "),_c('span',{class:_vm.workrecttext},[_vm._v("Minutes Watched")])],1)]),_vm._v(" "),(_vm.bannerspace)?_c('grid-item',{attrs:{"size":"2/12"}}):_vm._e()],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"wrk-rect-gap"}),_vm._v(" "),(_vm.normaldevice)?_c('div',{staticClass:"vl-key-feature",attrs:{"id":"features"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"vl-key-feature-contain"},[_c('container',[_c('grid',{staticClass:"min-height-260",attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"vl-key-feature-head img-responsive",attrs:{"src":__webpack_require__("Oppg"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v("MOOC and Entertainment")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Select your mode between E-Learning and Entertainment based on use case.")])]),_vm._v(" "),_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("mOkF"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v(" iOS, Android, Web Apps")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Select from available templates and themes. Branded customized native apps on iOS,Android and Web.")])]),_vm._v(" "),_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("UuJc"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v(" Live and VOD")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Video on Demand (VOD) support by default. Live streaming supported for Entertainment mode.")])]),_vm._v(" "),_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("N13/"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v("D R M*")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Secure your content using Digital Rights Management (DRM) module. Optional feature for enterprise grade content protection.")])])],1),_vm._v(" "),_c('grid',{staticClass:"min-height-260",attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("OOdf"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v(" Monetization Options*")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Monetize your content/course through video ads or transactional payment options.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("V0ik"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v("User Notifications")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Engage with your users through targeted PUSH and Mail Notifications. Managed from console.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("NMNL"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v("Real Time Analytics")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Track users and usage through platform and Google Analytics in real time.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("YzmF"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v("Social Integration")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Share content on FB, Google and Twitter. Sign Up with FB and Google. Out of the box.")])])],1),_vm._v(" "),_c('grid',{staticClass:"min-height-260",attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("aGEH"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v("Adaptive Streaming")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Adaptive bitrate streaming at multiple resolutions using DASH and HLS protocols. Pure HTML5 secure player for Web.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("NIt2"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont white-text"},[_vm._v("Intuitive Console")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont"},[_vm._v("Course/Content and User Management and Reporting through an easy intuitive vendor console.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"3/12"}})],1),_vm._v(" "),_c('div',{staticClass:"white-text center vl-key-feat-bot-info"},[_vm._v("*Coming soon")])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('div',{staticClass:"vl-key-feature",attrs:{"id":"features"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"vl-key-feature-contain"},[_c('container',[_c('grid',{staticClass:"min-height-260",attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"vl-key-feature-head img-responsive",attrs:{"src":__webpack_require__("Oppg"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v("MOOC and Entertainment")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Select your mode between E-Learning and Entertainment based on use case.")])]),_vm._v(" "),_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("mOkF"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v(" iOS, Android, Web Apps")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Select from available templates and themes. Branded customized native apps on iOS,Android and Web.")])]),_vm._v(" "),_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("UuJc"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v(" Live and VOD")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Video on Demand (VOD) support by default. Live streaming supported for Entertainment mode.")])])],1),_vm._v(" "),_c('grid',{staticClass:"min-height-260",attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{staticClass:"min-height-265 center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("N13/"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v("D R M*")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Secure your content using Digital Rights Management (DRM) module. Optional feature for enterprise grade content protection.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("OOdf"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v(" Monetization Options*")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Monetize your content/course through video ads or transactional payment options.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("V0ik"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v("User Notifications")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Engage with your users through targeted PUSH and Mail Notifications. Managed from console.")])])],1),_vm._v(" "),_c('grid',{staticClass:"min-height-260",attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{staticClass:"center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("NMNL"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v("Real Time Analytics")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Track users and usage through platform and Google Analytics in real time.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("YzmF"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v("Social Integration")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Share content on FB, Google and Twitter. Sign Up with FB and Google. Out of the box.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("aGEH"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v("Adaptive Streaming")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Adaptive bitrate streaming at multiple resolutions using DASH and HLS protocols. Pure HTML5 secure player for Web.")])])],1),_vm._v(" "),_c('grid',{staticClass:"min-height-260",attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{staticClass:"center",staticStyle:{"width":"33%"},attrs:{"size":"4/12"}},[_c('label',{staticClass:"img-responsive vl-key-feature-head"}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"})]),_vm._v(" "),_c('grid-item',{staticClass:"center",staticStyle:{"width":"33%"},attrs:{"size":"4/12"}},[_c('img',{staticClass:"img-responsive vl-key-feature-head",attrs:{"src":__webpack_require__("NIt2"),"alt":"feat-logo"}}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"},[_vm._v("Intuitive Console")]),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"},[_vm._v("Course/Content and User Management and Reporting through an easy intuitive vendor console.")])]),_vm._v(" "),_c('grid-item',{staticClass:"center",staticStyle:{"width":"33%"},attrs:{"size":"4/12"}},[_c('label',{staticClass:"img-responsive vl-key-feature-head"}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-cont-sm white-text"}),_vm._v(" "),_c('p',{staticClass:"vl-key-feature-sub-cont-sm"})])],1),_vm._v(" "),_c('div',{staticClass:"white-text center vl-key-feat-bot-info"},[_vm._v("*Coming soon")])],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vl-how-works-div",attrs:{"id":"howitwork"}},[_c('container',{staticClass:" vl-how-works",attrs:{"id":"howitwork"}},[_c('h1',{staticClass:"vl-how-works-title"},[_vm._v("How It Works")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"left-text right-align-text",attrs:{"size":"8/12"}},[_c('h2',{staticClass:"yellow"},[_vm._v("Subscribe with your info")]),_vm._v(" "),_c('p',[_vm._v("Select your "),_c('strong',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],staticStyle:{"color":"#878787","font-weight":"500"},attrs:{"href":"#"}},[_vm._v("plan")])]),_vm._v(", specify platform requirement as MOOC or Entertainment, upload few details like logo, app name, description, contact, social links, app template and theme and subscribe.")])]),_vm._v(" "),_c('grid-item',{staticClass:"triangle-blue triangle-left",attrs:{"size":"4/12"}},[_c('span',{staticClass:"triangle-number"},[_vm._v("1")])])],1)],1),_vm._v(" "),_c('container',{staticClass:"vl-how-works"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"right"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:"triangle-purple triangle-right",staticStyle:{"padding-top":"76px"},attrs:{"size":"2/12"}},[_c('span',{staticClass:"triangle-number"},[_vm._v("2")])]),_vm._v(" "),_c('grid-item',{staticClass:"left-text left-align-text",attrs:{"size":"8/12"}},[_c('h2',{staticClass:"yellow right-text"},[_vm._v("Get customized iOS, Android\n                        and Web apps in 24 hours")]),_vm._v(" "),_c('p',[_vm._v("Your account gets activated in few hours post verification. You shall get branded iOS, Android and Web (if applicable) apps within 24 business hours. Our support team shall help you get started as needed. ")])])],1)],1),_vm._v(" "),_c('container',{staticClass:"vl-how-works left-text"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"left-text right-align-text",attrs:{"size":"8/12"}},[_c('h2',{staticClass:"yellow"},[_vm._v("Upload content, test\n                            and go live!\n                        ")]),_vm._v(" "),_c('p',[_vm._v("Upload video content and metadata including poster, title, description and      tags using our easy,intuitive vendor console. All your content is secure and reliable on our AWS managed cloud. Verify the apps for content and data. Go live once you are ready!\n                        ")])]),_vm._v(" "),_c('grid-item',{staticClass:"triangle-yellow triangle-left",attrs:{"size":"4/12"}},[_c('span',{staticClass:"triangle-number"},[_vm._v("3")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"vl-plans",attrs:{"id":"plans"}},[_c('h1',{staticClass:"plan-text vl-title vl-title-key-plan"},[_vm._v("Plans")]),_vm._v(" "),_c('div',{staticClass:"center min-height-9"},[_c('span',{staticClass:"plan-switch-title"},[_vm._v("Select mode based on your use case")]),_vm._v(" "),_c('div',{staticClass:"center m-top-20 m-bottom-20"},[_c('span',[_c('label',{staticClass:"control control--radio plan-chk-label",on:{"click":function($event){return _vm.changelistdata('MOOC')}}},[_vm._v("MOOC\n                        "),_c('input',{attrs:{"type":"radio","name":"type","id":"mooc-plan-chk","value":"MOOC","checked":"checked"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"20px"}},[_c('label',{staticClass:"control control--radio plan-chk-label",on:{"click":function($event){return _vm.changelistdata('LITE')}}},[_vm._v("Entertainment\n                        "),_c('input',{attrs:{"type":"radio","name":"type","id":"lite-plan-chk","value":"LITE"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])])]),_vm._v(" "),_c('div',{staticClass:"vl-feat-box-contain"},[_c('container',[_c('grid',{staticStyle:{"flex-flow":"wrap"},attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},_vm._l((_vm.planData),function(plandata,index){return _c('grid-item',{key:plandata.planid,attrs:{"size":"4/12"}},[_c('div',{class:[ _vm.plan , 'vl-plbox-'+((index%3)+1), (index===1) ? 'box-active':''],attrs:{"id":'vl-plan-box' + (index+1)},on:{"mouseenter":function($event){return _vm.appendActiveClass(index+1)},"click":function($event){return _vm.appendActiveClass(index+1)}}},[_c('div',{staticClass:"vl-plan-head"},[_c('h1',[_vm._v(_vm._s(plandata.planname))]),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(plandata.yearlyprice/100 - plandata.yearlydiscountedprice/100)+" off")])]),_vm._v(" "),_c('div',{staticClass:"vl-plan-box-cont"},[_c('div',{staticClass:"m-top-25"},[_c('span',{staticClass:"curr-strike inline-blk"},[_vm._v("$"+_vm._s(plandata.yearlyprice/100))]),_vm._v(" "),_c('h3',{staticClass:"vl-plbox-amnt inline-blk"},[_vm._v("$"+_vm._s(plandata.yearlydiscountedprice/100))])]),_vm._v(" "),_c('p',{staticClass:"text-light center p-left-0 m-top-0"},[_vm._v("Annually")]),_vm._v(" "),_c('p',{staticClass:"pl-hgl-amt center p-left-0"},[_vm._v("Monthly "),_c('span',[_vm._v("$"+_vm._s(plandata.monthlydiscountedprice/100))])]),_vm._v(" "),_c('div',{class:_vm.planhighlightbox},[_c('p',{staticClass:"m-0 vl-plan-box-cont-hightlight"},[_c('span',{staticClass:"vl-plbox-instxt"},[_vm._v(_vm._s((plandata.monthlywatchseconds/60).toLocaleString()))]),_vm._v(" watching minutes/month")]),_vm._v(" "),_c('p',{staticClass:"m-0 p-top-14 vl-plan-box-cont-hightlight"},[_c('span',{staticClass:"vl-plbox-instxt"},[_vm._v(_vm._s((plandata.totalduration/3600).toLocaleString()))]),_vm._v(" hours of content")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:((plandata.maxchannelsactive > 0) && (_vm.mode=='LITE')),expression:"(plandata.maxchannelsactive > 0) && (mode=='LITE')"}],staticClass:"m-0 p-top-14 vl-plan-box-cont-hightlight"},[_c('span',{staticClass:"vl-plbox-instxt"},[_vm._v(_vm._s((plandata.maxchannelsactive).toLocaleString()))]),_vm._v(" Live Channels**")])]),_vm._v(" "),_vm._l((_vm.listdataarr),function(listdata,index1){return _c('div',{key:index1},[_c('p',{staticClass:"m-0 p-top-10 vl-plan-box-cont-unhightlight vl-rltv"},[_c('span',{staticClass:"tick-list",class:[ (_vm.listdataarrvals[index1][index] >= 1) ? 'tick-list':'cross-list']},[_c('label',{directives:[{name:"show",rawName:"v-show",value:((listdata=='Live Channels***') && (_vm.listdataarrvals[index1][index] >= 1)),expression:"(listdata=='Live Channels***') && (listdataarrvals[index1][index] >= 1)"}]},[_vm._v(_vm._s(_vm.listdataarrvals[index1][index])+" - ")]),_vm._v(_vm._s(listdata))])])])})],2),_vm._v(" "),_c('div',{staticClass:"vl-planbox-btns"},[_c('button',{staticClass:"btn vl-btn vl-plan-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.navigateToDashboard(index)}}},[_vm._v("Subscribe")])])])])}),1),_vm._v(" "),_c('grid',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"horizontal":"middle center"}},[_c('grid-item',{attrs:{"size":"1/12"}}),_vm._v(" "),_c('grid-item',{staticClass:"center",attrs:{"size":"10/12"}},[_c('span',{staticClass:"plan-info-data center"},[_vm._v("* Coming soon \t    \t"),(_vm.entviewdiv)?_c('span',[_vm._v("**Live channel Feeds to be provided by customer or partner. Contact sales@mobiotics.com for more details.")]):_vm._e()])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"1/12"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"vl-vlive"},[_c('container',{staticStyle:{"padding":"3em 2em 8em 2em"}},[_c('grid',{staticStyle:{"justify-content":"center","align-items":"center"},attrs:{"horizontal":"middle center"}},[_c('grid-item',{staticClass:"center"},[_c('div',{staticClass:"vlive-div"},[_c('p',{staticClass:"vlive vlive-bold m-0"},[_vm._v("You are an enterprise with thousands of hours of content, hundreds of live channels and need to cater to millions of subscribers?")])]),_vm._v(" "),_c('div',{staticClass:"vlive-div"},[_c('p',{staticClass:"vlive m-0"},[_vm._v(" Need custom UI/UX Apps on multiple device platforms? Need custom analytics and reports?")])]),_vm._v(" "),_c('div',{staticClass:"vlive-div"},[_c('p',{staticClass:"vlive m-0"},[_vm._v(" You can checkout our   "),_c('img',{staticClass:"v-middle",staticStyle:{"width":"24px"},attrs:{"src":__webpack_require__("MiBM")}}),_vm._v(" "),_c('strong',[_vm._v("vLive Enterprise Platform")])])])])],1),_vm._v(" "),_c('div',{staticClass:"v-middle center"},[_c('button',{staticClass:"btn banner-get-btn raise v1-plans-checknow",attrs:{"type":"button"}},[_vm._v("CHECK NOW")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"vl-feature-cust relative"},[_c('h1',{staticClass:"white-text vl-title vl-title-cust"},[_vm._v("Featured Customer")]),_vm._v(" "),_c('div',{staticClass:"vl-feat-box-contain"},[_c('container',[_c('grid',{attrs:{"horizontal":"middle","rwd":{compact: 'stack-reverse'}}},[_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"vl-feat-box"},[_c('div',{staticClass:"vl-feat-head"},[_c('a',{attrs:{"href":"https://lattukids.com","target":"_blank"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__("LFdq"),"alt":"feat-logo"}})])]),_vm._v(" "),_c('div',{staticClass:"vl-feat-box-cont"},[_c('p',[_vm._v(" The fast growing kids entertainment and learning platform chose vLite™ for its flexibility and ease of use. With iOS, Anrdoid and Web Apps Lattukids is able to reach out to kids across the world.")])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"vl-feat-box"},[_c('div',{staticClass:"vl-feat-head"},[_c('a',{attrs:{"href":"http://knowdiabetes.tv","target":"_blank"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__("0XWP"),"alt":"feat-logo"}})])]),_vm._v(" "),_c('div',{staticClass:"vl-feat-box-cont"},[_c('p',[_vm._v("kNOwDiabetes is the first e-Health channel in Malayalam. Aimed at creating awareness about diabetes among patients, high risk indivdiuals and care takers - this initiative by Medical Trust Hospital, Kulanada, Kerala chose vLIte™ platform and could go live fast.")])])])])],1)],1)],1)]),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-color"},[_c('container',[_c('grid',[_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-left"},[_c('div',{staticClass:" logo-opacity"},[_c('img',{staticClass:"v-middle",staticStyle:{"width":"20%"},attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_vm._v("© Copyright "),_c('label',{attrs:{"id":"copyrightyear"}}),_c('a',{attrs:{"href":"https://www.mobiotics.com","target":"_blank"}},[_c('img',{staticClass:"v-middle foot-cmp-logo",staticStyle:{"width":"8em"},attrs:{"src":__webpack_require__("/krl")}})])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-mid"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://www.facebook.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"facebook"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://plus.google.com/106588943035549674608/posts')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.5","name":"google-plus"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://twitter.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"twitter"}})],1)])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-right f-right"},[_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms Of Use")])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])],1)],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vl-title"},[_c('h1',{staticClass:"white-text vl-title-key-feat"},[_vm._v("Key Features")]),_vm._v(" "),_c('h2',{staticClass:"white-text center vl-sub-key-title"},[_vm._v("Leading video features in a flexible, cost effective package")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vl-title"},[_c('h1',{staticClass:"white-text vl-title-key-feat"},[_vm._v("Key Features")]),_vm._v(" "),_c('h2',{staticClass:"white-text center vl-sub-key-title"},[_vm._v("Leading video features in a flexible, cost effective package")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("O0jz");
function injectStyle (ssrContext) {
  __webpack_require__("tbYJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ExfC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjQwcHgiIGhlaWdodD0iMjkwcHgiIHZpZXdCb3g9IjAgMCAzMDggMzcwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NyAoNDUzOTYpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmdmeDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIwMGxhbmRpbmciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04Mi4wMDAwMDAsIC03NDcuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJnZngiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzNi4wMDAwMDAsIDkzMi4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTIzNi4wMDAwMDAsIC05MzIuMDAwMDAwKSB0cmFuc2xhdGUoODIuMDAwMDAwLCA3NDcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iMS1zbWFsbCIgZmlsbD0iI0VGMzA3RSIgcG9pbnRzPSIyMzcuNTE3OTg2IDE5MS4zNjg5OCAyMzcuNTE3OTg2IDEwMS43NjgxNzMgMzA4IDE0Ni41Njg1NzYiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSIyLW1lZGl1bSIgZmlsbD0iI0ZGQ0EzNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQzLjE0Mzg4NSwgMTA1LjMwNDA0MSkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTQzLjE0Mzg4NSwgLTEwNS4zMDQwNDEpICIgcG9pbnRzPSI2MC4zMDkzNTI1IDIxMC42MDgwODIgNjAuMzA5MzUyNSAwIDIyNS45Nzg0MTcgMTA1LjMwNDA0MSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IjMtbGFyZ2UiIGZpbGw9IiMzQkQ3REMiIHBvaW50cz0iMC42ODYwMTI3NzMgMzcwIDAuNjg2MDEyNzczIDgzLjU5NTI4NDkgMjI1Ljk3ODQxNyAyMjYuNzk3NjQyIj48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to__ = __webpack_require__("WBHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fixed_header__ = __webpack_require__("DAFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fixed_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_fixed_header__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _require = __webpack_require__("vgQg"),
    Config = _require.Config;



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            sidebarVisible: false,
            plans: [],
            planboxIndex: 2,
            plan: 'vl-plan-box',
            plan1: ['vl-plan-box', 'vl-plbox-1'],
            plan2: ['vl-plan-box', 'vl-plbox-2', 'box-active'],
            plan3: ['vl-plan-box', 'vl-plbox-3'],
            workrect: 'works-rectangle',
            workrectcount: 'wrk-rect-count',
            workrecttext: 'wrk-rect-text',
            apibaseurl: '',
            vendorportalurl: '',
            test: [{ 0: 1, 1: 1, 2: 1 }, { 0: 0, 1: 0, 2: 0 }],
            moocArrayVal: [[1, 1, 1], [0, 0, 1], [1, 1, 1], [1, 1, 1], [0, 1, 1], [0, 1, 1], [0, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1], [0, 0, 1]],
            liteArrayVal: [[1, 1, 1], [0, 0, 1], [1, 1, 1], [0, 1, 1], [0, 1, 1], [0, 0, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1], [0, 0, 1]],
            moocArray: ["iOS and Andriod Apps", "Web App with SSL", "Secure Sign Up and Authentication", "Course Credit and Questionnaire", "Course Level Management", "Institute Management", "Course Payments*", "Google Analytics and Dashboard", "Course and Progress Reporting", "Business Hour Email Support", "24*7 Reliable SASS", "Free Bussiness Consulting"],
            liteArray: ["iOS and Andriod Apps", "Web App with SSL", "Optional Signup and Authentication", "Payments Support*", "Ad Monetization Support*", "DRM Support*", "Google Analytics and Dashboard", "Business Hour Email Support", "24x7 Reliable SAAS ", "Free Business Consulting"],
            listdataarr: [],
            listdataarrvals: [],
            bannerspace: false,
            landbanslide: 'landing-banner-slide-syb',
            normaldevice: true,
            smalldevice: false,
            isFixed: false,
            showfixedheader: false,
            entviewdiv: false,
            mode: 'MOOC',
            planhighlightbox: ['vl-plan-highlight-box'],
            theme: 'B'

        };
    },

    components: { countTo: __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default.a, 'fixed-header': __WEBPACK_IMPORTED_MODULE_1_vue_fixed_header___default.a },
    computed: {
        planData: function planData() {
            return this.plans;
        }
    },
    created: function created() {
        // console.log('on load event');
        this.screenResize();
        //    console.log(this.$route.query.mode);
        if (this.$route.query.mode) {
            var mod = this.$route.query.mode;
            if (mod.toUpperCase() == 'LITE') {
                this.mode = 'LITE';
                this.planhighlightbox = ['vl-plan-highlight-box', 'vl-plan-highlight-box-light'];
            }
        }
        //    VueScrollTo.scrollTo('#plans')
    },
    mounted: function mounted() {
        var divpos = this.$route.params.divid;
        if (divpos) {
            console.log('==============>' + divpos);
            this.$scrollTo('#' + divpos);
        }

        // Setting Config URLs
        var con = new Config();
        this.apibaseurl = con.getApiUrl();
        this.vendorportalurl = con.getPortalUrl();
        //Loading Plan info
        var hurl = this.apibaseurl + '/vendor/v1/plan?plantype=LITE';
        var payload = {};
        var protocol = window.location.protocol;
        this.$http({ url: hurl, payload: payload, method: 'GET' }).then(function (response) {
            // console.log('Success!:', response.data);
            var data = response.data.data;
            var sorted = data.sort(function (a, b) {
                return a.yearlydiscountedprice.localeCompare(b.yearlydiscountedprice);
            });
            this.plans = sorted;
        }, function (response) {
            console.log('Error!:', response.data);
        });
        this.listdataarr = this.moocArray;
        this.listdataarrvals = this.moocArrayVal;
        console.log(this.mode);
        if (this.mode == 'LITE') {
            document.getElementById("lite-plan-chk").checked = true;
            this.listdataarr = this.liteArray;
            this.listdataarrvals = this.liteArrayVal;
            this.entviewdiv = true;
        }

        //hero text toggle
        // console.log(document.getElementById("udemy").className.split(" ").indexOf("is-hidden"));
        // console.log(document.getElementById("neflix").className.split(" ").indexOf("is-hidden"));
        // setInterval(function(){
        //     var s1 = document.getElementById("udemy");
        //     var s2 = document.getElementById("neflix");
        //
        //     if(document.getElementById("udemy").className.split(" ").indexOf("is-hidden") >= 0) {
        //         console.log('inside');
        //           if(s1.className.split(" ").indexOf("is-hidden") >= 0) {
        //               s1.classList.remove("is-hidden");
        //           }
        //           s1.className += "is-visible";
        //
        //           if(s2.className.split(" ").indexOf("is-visible") >= 0) {
        //               s2.classList.remove("is-visible");
        //           }
        //           s2.className += "is-hidden";
        //       }
        //
        //       else{
        //           if(s2.className.split(" ").indexOf("is-hidden") >= 0) {
        //               s2.classList.remove("is-hidden");
        //           }
        //           s2.className += "is-visible";
        //
        //           if(s1.className.split(" ").indexOf("is-visible") >= 0) {
        //               s1.classList.remove("is-visible");
        //           }
        //           s1.className += "is-hidden";
        //       }
        //
        // },5000);
        var self = this;
        var cflag = 1;

        window.addEventListener('scroll', function (e) {
            if (cflag) {
                if (document.gambitGalleryIsInView(document.querySelector('#ban-count-start'))) {
                    if (cflag) {
                        self.$refs.example1.start();
                        self.$refs.example2.start();
                        self.$refs.example3.start();
                        cflag = 0;
                    }
                }
            }

            var wheight = window.pageYOffset;
            var x = document.querySelector('#headerelement').clientHeight;
            // console.log(wheight+'  '+x);
            var tlimit = x + 120;
            if (x < wheight) {
                self.showfixedheader = true;
                // console.log('show f header');
            } else {
                self.showfixedheader = false;
                // console.log('show n header');
            }
        });

        document.gambitGalleryIsInView = function (el) {
            if (el) {
                var viewport = {};
                viewport.top = window.pageYOffset;
                viewport.bottom = viewport.top + window.innerHeight;

                var bounds = {};
                bounds.top = el.getBoundingClientRect().top + window.pageYOffset;
                bounds.bottom = bounds.top + el.clientHeight;

                return bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom || bounds.top <= viewport.bottom && bounds.top >= viewport.top;
            }
        };

        var thisYear = new Date().getFullYear();
        document.getElementById('copyrightyear').innerHTML = thisYear;
    },

    watch: {
        '$mq.resize': 'screenResize'
    },
    methods: {
        toggleSidebar: function toggleSidebar() {
            this.sidebarVisible = !this.sidebarVisible;
        },
        screenResize: function screenResize() {
            var scsize = screen.width;
            if (scsize >= 1500) {
                this.workrect = ['works-rectangle'];
                this.workrectcount = 'wrk-rect-count';
                this.workrecttext = 'wrk-rect-text';
                this.bannerspace = false;
                this.landbanslide = 'landing-banner-slide-syb';
                this.normaldevice = true;
                this.smalldevice = false;
            }if (scsize <= 1499 && scsize >= 1366) {
                this.workrect = ['works-rectangle'];
                this.workrectcount = 'wrk-rect-count';
                this.workrecttext = 'wrk-rect-text';
                this.bannerspace = false;
                this.landbanslide = 'landing-banner-slide-syb';
                this.normaldevice = true;
                this.smalldevice = false;
                // this.workrectcount = 'wrk-rect-count-40';
                // this.workrecttext = 'wrk-rect-text-18';
            } else if (scsize <= 1365 && scsize >= 1200) {
                this.workrect = ['works-rectangle'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerspace = false;
                this.landbanslide = 'landing-banner-slide-syb';
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 1199 && scsize >= 960) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerspace = true;
                this.landbanslide = 'landing-banner-slide-syb-small';
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 959 && scsize >= 768) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerspace = true;
                this.landbanslide = 'landing-banner-slide-syb-small';
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 767 && scsize >= 601) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerspace = true;
                this.landbanslide = 'landing-banner-slide-syb-small';
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 600 && scsize >= 481) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerspace = true;
                this.landbanslide = 'landing-banner-slide-syb-small';
                this.normaldevice = false;
                this.smalldevice = true;
            } else if (scsize <= 480) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerspace = true;
                this.landbanslide = 'landing-banner-slide-syb-small';
                this.normaldevice = false;
                this.smalldevice = true;
            }
        },

        changelistdata: function changelistdata(type) {
            if (type == 'LITE') {
                this.listdataarr = this.liteArray;
                this.listdataarrvals = this.liteArrayVal;
                this.entviewdiv = true;
                this.mode = 'LITE';
                this.planhighlightbox = ['vl-plan-highlight-box', 'vl-plan-highlight-box-light'];
                // console.log('LITE');
            } else {
                this.listdataarr = this.moocArray;
                this.listdataarrvals = this.moocArrayVal;
                this.entviewdiv = false;
                this.mode = 'MOOC';
                this.planhighlightbox = ['vl-plan-highlight-box'];
                // console.log('MOOC');
            }
        },
        navigateToDashboard: function navigateToDashboard(index) {
            var priorplan = '';
            console.log(this.plans.length);
            console.log(index);
            if (this.plans.length > index + 1) {
                priorplan = this.plans[index + 1];
            }

            var inputElements = document.getElementsByName("type");
            var seltype = "MOOC";
            for (var i = 0; inputElements[i]; ++i) {
                if (inputElements[i].checked) {
                    seltype = inputElements[i].value;
                }
            }
            this.$router.push({ name: 'Dashboard', params: { plandata: this.plans[index], priorplan: priorplan, seltype: seltype } });
            //this.$router.push('Dashboard', params: { plandata:  this.plans});
        },
        redirectToVlive: function redirectToVlive() {
            this.$ga.event({
                eventCategory: 'VLITE_REDIRECT',
                eventAction: 'Redirect',
                eventLabel: 'REDIRECT',
                eventValue: 1
            });
            var retrievedObject = localStorage.getItem('themeObject');
            var resobj = JSON.parse(retrievedObject);
            var theme = new Date(resobj.number);
            var ver = 'A';
            if (theme % 2 != 0) {
                ver = 'B';
            }
            // GTM Code starts
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'VLITE_REDIRECT',
                'EventCategory': 'VLITE_HOME',
                'EventAction': 'HOME',
                'EventLabel': 'VLITE_HOME',
                'EventValue': 1,
                'Version': ver
            });
            // End of GTM Code
        },
        openNewTab: function openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        },
        openSocialNewTab: function openSocialNewTab(surl) {
            window.open(surl, '_blank');
        },
        navigateToDemoPage: function navigateToDemoPage() {
            this.$router.push({ name: 'Reqdemo' });
        },
        scroll: function scroll(element) {
            document.getElementById(element).scrollIntoView();
            //var ele = document.getElementById(element);
            //window.scrollTo(ele.offsetLeft,ele.offsetTop);
        },

        appendActiveClass: function appendActiveClass(id) {
            // console.log("enter:"+id);
            var des = document.getElementById("vl-plan-box" + id);
            if (!document.getElementById("vl-plan-box" + id).className.split(" ").indexOf("box-active") >= 0) {
                des.className += " box-active";
            }

            if (id != this.planboxIndex) {
                var sou = document.getElementById("vl-plan-box" + this.planboxIndex);
                if (document.getElementById("vl-plan-box" + this.planboxIndex).className.split(" ").indexOf("box-active") >= 0) {
                    sou.classList.remove("box-active");
                }
                //sou.className = sou.className.replace( /(?:^|\s)box-active(?!\S)/ , '' )
                this.planboxIndex = id;
            }
        }
    }
});

/***/ }),

/***/ "H2i2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"instructions1"}},[_c('video',{staticClass:"video-js vjs-default-skin",attrs:{"id":"my_video_1","width":"640px","height":"360px","controls":"","preload":"none","poster":"https://vpremieretest.mobiotics.com/demoassets/entertainment.jpg","data-setup":"{ \"aspectRatio\":\"640:267\", \"playbackRates\": [1, 1.5, 2] }"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JIAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reqdemo_vue__ = __webpack_require__("nMd3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5506a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reqdemo_vue__ = __webpack_require__("QvAK");
function injectStyle (ssrContext) {
  __webpack_require__("KYWn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reqdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5506a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reqdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KCOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emailverify_vue__ = __webpack_require__("SNPV");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70d4744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emailverify_vue__ = __webpack_require__("iXMG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emailverify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70d4744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emailverify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KYWn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LFdq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lattu-logo.d0ae072.png";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3184963f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+Rc9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3184963f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MiBM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "N13/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe__ = __webpack_require__("7aeP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_stripe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query__ = __webpack_require__("l3dv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_fixed_header__ = __webpack_require__("DAFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_fixed_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_fixed_header__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = false;

// asynchronous stripe-checkout
__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "EATb")).then(function (checkout) {
    var options = {
        //key: 'pk_test_ki5Bhv3Birs9hckwDsK5TkF8',
        key: 'pk_live_8ZXJbhQOsPmJ3Hyxv25F5bAa',
        image: 'https://cdn.meme.am/images/100x100/15882140.jpg',
        locale: 'auto',
        currency: 'USD',
        billingAddress: true,
        panelLabel: 'Subscribe {{amount}}'
    };
    checkout.default.install(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */], options);
});

// Stripe checkout
// import VueStripeCheckout from 'vue-stripe-checkout';
// const options = {
//     key: 'pk_test_AALXrZZqOiiBkI5iuxh9hAd6',
//     image: 'https://cdn.meme.am/images/100x100/15882140.jpg',
//     locale: 'auto',
//     currency: 'USD',
//     billingAddress: true,
//     panelLabel: 'Subscribe {{amount}}'
// }
// Vue.use(VueStripeCheckout, options);

//validation

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */].Validator.extend('passphrase', {
    getMessage: function getMessage(field) {
        return 'Sorry dude, wrong pass phrase.';
    },
    validate: function validate(value) {
        return value.toUpperCase() == 'Demogorgon'.toUpperCase();
    }
});
__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */].Validator.extend('verify_password', {
    getMessage: function getMessage(field) {
        return 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)';
    },
    validate: function validate(value) {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(value);
    }
});

var VueScrollTo = __webpack_require__("bm7V");

// Vue.use(VueScrollTo)

// You can also pass in the default options
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueScrollTo, {
    container: "body",
    duration: 1000,
    easing: "ease",
    offset: -80,
    cancelable: true,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

// media query

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_v_media_query___default.a);

//fixed header


// import './assets/css/mainB.css'
// import './assets/css/main.css'
// import './assets/css/progress.css'
// import './assets/js/helpers.js'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
    id: 'UA-112199711-1',
    // id: 'UA-120712909-1',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["default"]
});

var themeobj = {};
if (localStorage.getItem("themeObject") === null) {
    var randomnumber = Math.floor(Math.random() * (9 - 1 + 1)) + 1;
    // console.log(randomnumber);

    var now = new Date();
    // console.log(now);
    var twoHoursLater = new Date(now.getTime() + 2 * 1000 * 60 * 60);
    // console.log(twoHoursLater);

    themeobj = { 'number': randomnumber, 'date': twoHoursLater };
    localStorage.setItem('themeObject', JSON.stringify(themeobj));
} else {
    var retrievedObject = localStorage.getItem('themeObject');
    var resobj = JSON.parse(retrievedObject);
    themeobj = resobj;
    var exp = new Date(resobj.date);
    var current = new Date();
    if (exp < current) {
        var randomnumber = 0;
        var now = new Date();
        // console.log(now);
        var twoHoursLater = new Date(now.getTime() + 2 * 1000 * 60 * 60);
        // console.log(twoHoursLater)

        if (resobj.number === null) {
            // Expired theme case
            randomnumber = Math.floor(Math.random() * (4 + 1));
            // console.log(randomnumber);
        } else {
            if (resobj.number > 10) {
                randomnumber = Math.floor(Math.random() * (4 + 1));
            } else {
                randomnumber = parseInt(resobj.number) + 1;
            }
        }

        var themeobj = { 'number': randomnumber, 'date': twoHoursLater };
        localStorage.setItem('themeObject', JSON.stringify(themeobj));
    }
}

console.log(themeobj);
var file = '';
if (themeobj.number % 2 == 0) {
    file = './assets/css/main.css';
} else {
    file = './assets/css/mainB.css';
}

// if ( module.hot ) {
//   import(`${file}`).then(data=> {
//     return data;
//   });
// }
// import './assets/css/mainB.css';

__webpack_require__("5Q+W")("" + file).then(function (res) {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_2__router__["default"],
        template: '<App/>',
        components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["default"] }
    });
});

/***/ }),

/***/ "NIt2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjdweCIgaGVpZ2h0PSI0NXB4IiB2aWV3Qm94PSIwIDAgNjcgNDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA0OC4xICg0NzI1MCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+RjExOUZBODItNTQ4MS00QURFLThDQjEtNDNFNkI0NDY3NUU5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSIwMGxhbmRpbmdfdXBkYXRlZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzNzcuMDAwMDAwLCAtMjQyMi4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0icGFnZSIgZmlsbD0iI0ZGRkZGRiI+CiAgICAgICAgICAgIDxnIGlkPSJ0b3A0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjE5NS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJmZWF0dXJlc3NlYyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzYxLjAwMDAwMCwgNjQuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImZlYXR1cmVzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMTMxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0icmF3MSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iZjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkwMC4wMDAwMDAsIDMyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJhZG1pbi1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTYuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjYyMzY0OCwgMC40NDIyNjQpIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00OC4wNTU2NTc1LDE0LjU0MzgxNDQgQzQ4Ljc5NzMzMDksMTMuMTYyMTQ3NCA0OS41NDA1NDUxLDExLjc4MDQ4MDQgNTAuMjg4ODk1NiwxMC4zODkwNjg5IEM0Ny43NDc0ODMsOS42OTgyMzU0NSA0NC43NDYzNzY3LDEwLjk5MDE1MDUgNDMuODkwNjc4OCwxMy43OTcwNzgzIEM0Mi45NDA5ODc2LDE2LjkxMjc1MjcgNDQuNTIwODk1NywyMC4wNDU4NjQ2IDQ3LjQ2MTM5NDMsMjAuODAyODU4MSBDNTAuMzQ5NTAzMywyMS41NDYwMDQyIDUzLjUyMTEzMjgsMjAuMDI3NDAxNCA1NC4wMjI0MzAxLDE3LjYxMTI3OTIgQzUyLjQ1OTQ3MTYsMTcuNDA3NjcwNSA1MC45MDExMzU3LDE3LjE5NTg1NTkgNDkuMzQwMjMxNywxNy4wMDM1MzA0IEM0Ny43MzM2MTUyLDE2LjgwNjA3NjEgNDcuMjkwMzU3NSwxNS45Njk1ODggNDguMDU1NjU3NSwxNC41NDM4MTQ0IiBpZD0iRmlsbC0xIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNTEuMTg0ODEwMywxNC40OTU3MDczIEM1Mi4yOTYyOTMxLDE0LjYzNTIwNzUgNTMuMzAwOTQyMSwxNC43NjEzNzMxIDU0LjQwMjY2NjEsMTQuODk5MzM0NiBDNTQuMjM0MTk3MywxMy41NTcxNTg1IDUzLjc1MDg3NjksMTIuNDgwMTM1MiA1Mi43NjIxNTAzLDExLjU1NDkyMSBDNTIuMjIyMzMxMywxMi41NjExNjg0IDUxLjcxOTQ5MzIsMTMuNDk5MjA0NCA1MS4xODQ4MTAzLDE0LjQ5NTcwNzMiIGlkPSJGaWxsLTMiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00OC45MzAxNTQxLDIzLjczMDEwNDggQzQ0LjYyMTg3NDIsMjMuNjUzNjg3NCA0MC44MjIwODIzLDE5Ljc1NTM3NjEgNDAuODkzOTg5NiwxNS40ODUyMzUzIEM0MC45NjY5MjQzLDExLjIwMTI0NzEgNDQuODMzNDg3NCw3LjQyNTUxMTIzIDQ5LjA5MTQzMjEsNy40ODA5MDA5OSBDNTMuNjA3MjE2Miw3LjQ4NzA1NTQxIDU3LjIwNjY5NDcsMTEuNTU0NjEzMyA1Ny4xNzc5MzE4LDE1LjYzOTA5NTggQzU3LjE0NzExNDMsMTkuOTY5NzU1IDUzLjIyNjEwNzEsMjMuODA2MDA5MyA0OC45MzAxNTQxLDIzLjczMDEwNDggTTU3LjA4MTM3MDQsMjkuNTM5MzYzMSBDNTYuODg4NzYxNCwzMC4xMzQyOTAyIDU2LjM3NTEzNzEsMzAuNDU4NDIyOSA1NS41NjM2MTA5LDMwLjQ2MDk4NzMgQzUzLjM4OTk1MzIsMzAuNDY3NjU0NiA1MS4yMTYyOTU1LDMwLjQ2MzAzODggNDkuMDQyNjM3OCwzMC40NjMwMzg4IEM0Ni44NDc0MDc5LDMwLjQ2MzAzODggNDQuNjUyMTc4LDMwLjQ4OTcwNzkgNDIuNDU3OTc1NCwzMC40NDE0OTgzIEM0Mi4wMTIxNDk2LDMwLjQzMTc1MzggNDEuNTAwMDY2MiwzMC4yMzI3NjA5IDQxLjE0NzcyLDI5Ljk1NjgzNzggQzQwLjcxMjE2NjcsMjkuNjE2MjkzMyA0MC43MDk1OTg1LDI5LjA0NjQ5NjcgNDAuOTI4OTE2MSwyOC41NDM4ODU5IEM0MS4xNzU5NjkzLDI3Ljk3OTczMDggNDEuNjU1MTgwNywyNy43MzA5ODk4IDQyLjI2Mjc5ODIsMjcuNzI5OTY0IEM0NC40MzU5NDIyLDI3LjcyNjg4NjggNDYuNjA5NTk5OSwyNy43MjYzNzM5IDQ4Ljc4MzI1NzYsMjcuNzI2MzczOSBDNTEuMDYzNzQ5MSwyNy43MjYzNzM5IDUzLjM0MzcyNywyNy43MjAyMTk1IDU1LjYyMzcwNDksMjcuNzMyMDE1NSBDNTYuNzEzMTAxOSwyNy43Mzc2NTcgNTcuMzg3NDkwNSwyOC41OTIwOTU1IDU3LjA4MTM3MDQsMjkuNTM5MzYzMSBNNTUuNTU5NTAxOSwzNS44OTc5MDMzIEM1MS4xNDg0OTcxLDM1Ljg5ODQxNjIgNDYuNzM4MDA2LDM1Ljg5OTk1NDggNDIuMzI3MDAxMiwzNS44OTQ4MjYxIEM0MS4zMzgyNzQ2LDM1Ljg5MzI4NzUgNDAuNzQ3MDkzMSwzNS4yOTk4OTg5IDQwLjgyMDAyNzgsMzQuNDE0Njg4NCBDNDAuODgxNjYyNywzMy42NzIwNTUyIDQxLjQyNjYxOCwzMy4xOTc2NTIxIDQyLjI2NTg3OTksMzMuMTk1MDg3OCBDNDQuNTI0Nzk5MiwzMy4xODczOTQ3IDQ2Ljc4MzIwNDksMzMuMTkyNTIzNCA0OS4wNDIxMjQyLDMzLjE5MjUyMzQgQzUxLjIxNTI2ODMsMzMuMTkyNTIzNCA1My4zODg5MjU5LDMzLjE5MDQ3MiA1NS41NjIwNywzMy4xOTM1NDkyIEM1Ni41NDcyMDEyLDMzLjE5NDU3NDkgNTcuMTQzMDA1MywzMy43MDg5ODE3IDU3LjE0NDAzMjYsMzQuNTQ0NDQ0MSBDNTcuMTQ1MDU5OCwzNS4zNzY4MjkyIDU2LjUzOTQ5NjksMzUuODk3MzkwNCA1NS41NTk1MDE5LDM1Ljg5NzkwMzMgTTM1LjM0Njg0ODEsMzQuMzUxMDkyNyBDMzUuMzQ0NzkzNiwzNS40MTc4NTg2IDM0LjU0OTcwMzMsMzYuMTAzMDUwNiAzMy42MjgyNjE1LDM1Ljg1Nzg5OTYgQzMyLjk4MDU4MTMsMzUuNjg1NTc1OCAzMi42MzE4MzA1LDM1LjE3NDI0NjIgMzIuNjMwMjg5NiwzNC4zNDA4MzU0IEMzMi42MjUxNTM0LDMxLjIxMzM2NSAzMi42MjgyMzUxLDI4LjA4NTg5NDYgMzIuNjI4MjM1MSwyNC45NTg0MjQyIEMzMi42MjgyMzUxLDI0LjUxMTIwMzEgMzIuNjI4MjM1MSwyNC4wNjQ0OTQ5IDMyLjYyNzIwNzksMjMuNjE3Nzg2NiBDMzIuNjI2MTgwNiwyMC4wNjQ2MzU2IDMyLjYyMDUzMDgsMTYuNTExNDg0NiAzMi42Mjk3NzYsMTIuOTU4ODQ2NCBDMzIuNjMyODU3OCwxMS44NTkyNTcgMzMuMzk4MTU3OCwxMS4yMDYzNzU3IDM0LjMzMzk4MTIsMTEuNDYyODA5OCBDMzUuMDExOTY1MSwxMS42NDg0NjgxIDM1LjM0OTkyOTksMTIuMTY0NDEzNiAzNS4zNTA0NDM1LDEzLjAzMjY5OTUgQzM1LjM1MTk4NDQsMTYuMzk0NTUwNiAzNS4zNTE0NzA3LDE5Ljc1NTg4OSAzNS4zNTE0NzA3LDIzLjExNzc0MDEgQzM1LjM1MDk1NzEsMjYuODYyMTkxIDM1LjM1MzAxMTYsMzAuNjA2NjQxOSAzNS4zNDY4NDgxLDM0LjM1MTA5MjcgTTI5Ljg4MzQyNzMsMjcuNzEwNDc1IEwyOS44ODEzNzI4LDI3LjcxMDQ3NSBDMjkuODgxMzcyOCwyOS45MDI0NzM4IDI5Ljg4NDk2ODIsMzIuMDkzOTU5NyAyOS44NzkzMTgzLDM0LjI4NTQ0NTYgQzI5Ljg3Njc1MDIsMzUuMjk4MzYwMyAyOS4zODk4MzQ1LDM1Ljg3ODkyNzIgMjguNTU1NzA4NywzNS44OTM4MDAzIEMyNy42OTY0MTU0LDM1LjkwOTE4NjQgMjcuMTY2MzU1MiwzNS4zMDE5NTA0IDI3LjE2NTMyOCwzNC4yNzcyMzk3IEMyNy4xNjI3NTk5LDI5Ljg5NDI2NzkgMjcuMTYyNzU5OSwyNS41MTEyOTYxIDI3LjE2NjM1NTIsMjEuMTI4MzI0MyBDMjcuMTY2ODY4OCwyMC4zMzIzNTI4IDI3LjQ5MzAyMDIsMTkuODQ3MTc5NSAyOC4xMjYzMTg5LDE5LjY0NzE2MDkgQzI4LjY5ODQ5NjMsMTkuNDY2MTE4NCAyOS4zNDAwMTI5LDE5LjY0ODY5OTUgMjkuNjMwMjEwNiwyMC4xNzI4NTA4IEMyOS43OTUwODQsMjAuNDcwODI3MiAyOS44Njk1NTk1LDIwLjg1MzkzOTggMjkuODcyNjQxMiwyMS4xOTk2MTMgQzI5Ljg5MzY5OTgsMjMuMzcwMDcxMyAyOS44ODM0MjczLDI1LjU0MDUyOTYgMjkuODgzNDI3MywyNy43MTA0NzUgTTI0LjQ0ODI1NTksMzQuMzg5NTU3OSBDMjQuNDQzNjMzMywzNS4zMTI3MjA2IDIzLjg4MzI2OTIsMzUuODk0ODI2MSAyMy4wNjk2ODg1LDM1Ljg5MzI4NzUgQzIyLjI2MjI3MTIsMzUuODkyMjYxNyAyMS43MTc4Mjk1LDM1LjMwNDAwMTkgMjEuNzA3MDQzNCwzNC4zNzM2NTg5IEMyMS42OTI2NjIsMzMuMDU2MTAwNSAyMS43MDM0NDgxLDMxLjczODAyOTIgMjEuNzA0NDc1MywzMC40MTk5NTc4IEMyMS43MDQ5ODg5LDI5LjEwMjM5OTQgMjEuNjk3Nzk4MiwyNy43ODQzMjgxIDIxLjcwODA3MDcsMjYuNDY2NzY5NiBDMjEuNzEyMTc5NywyNS44OTY0NjAxIDIxLjkzNzE0NzEsMjUuNDI5MjM3MiAyMi40NzIzNDM1LDI1LjE2NjY0ODcgQzIyLjk1MDUyNzcsMjQuOTMxNzU1IDIzLjQ4MzE1NiwyNC45MTA3Mjc0IDIzLjg0MjY5MjksMjUuMjg5NzM3IEMyNC4xMzgwMjY4LDI1LjYwMDUzNTIgMjQuNDIwMDA2NSwyNi4wNzU0NTExIDI0LjQyNzcxMDksMjYuNDgyNjY4NSBDMjQuNDc5MDczMywyOS4xMTcyNzI2IDI0LjQ2MjEyMzcsMzEuNzUzOTI4MSAyNC40NDgyNTU5LDM0LjM4OTU1NzkgTTE3LjYxODA4MSwzNS44OTYzNjQ3IEMxNi44MDM5ODY3LDM1Ljg5MzgwMDMgMTYuMjc2NDk0NiwzNS4zMDE0Mzc1IDE2LjI3NDQ0MDEsMzQuMzcwNTgxNyBDMTYuMjcwMzMxMSwzMi42MDUyODkzIDE2LjI3MzQxMjgsMzAuODQwNTA5OCAxNi4yNzM5MjY1LDI5LjA3NTIxNzQgQzE2LjI3NDk1MzcsMjcuMzMwOTUyNSAxNi4yNzAzMzExLDI1LjU4NzcxMzUgMTYuMjc2NDk0NiwyMy44NDM0NDg3IEMxNi4yODAwOSwyMi44ODk1MTM4IDE2Ljc4MTM4NzIsMjIuMzIxMjU1OCAxNy42MDQyMTMyLDIyLjMwOTk3MjcgQzE4LjQ1MzIzNCwyMi4yOTgxNzY3IDE4Ljk4Mjc4MDYsMjIuODgwNzk1IDE4Ljk4NDMyMTUsMjMuODYwODg2MiBDMTguOTg5OTcxMywyNy4zNjk5MzA1IDE4Ljk5MDQ4NSwzMC44Nzg5NzQ5IDE4Ljk4NTM0ODcsMzQuMzg4MDE5MiBDMTguOTg0MzIxNSwzNS4zMDA5MjQ3IDE4LjQyOTA5MzcsMzUuODk4OTI5IDE3LjYxODA4MSwzNS44OTYzNjQ3IE0xMy41MjI5NTUyLDM0LjU2NTk4NDUgQzEzLjQ5NTczMzEsMzUuMzYyOTgxNyAxMi45MjU2MTAyLDM1Ljg5Njg3NzUgMTIuMTc5MzE0MiwzNS44OTYzNjQ3IEMxMS40Mzc2NDA5LDM1Ljg5NTg1MTggMTAuODU3NzU5MSwzNS4zNTExODU4IDEwLjgxMzA3MzgsMzQuNTc1MjE2MSBDMTAuNzg1ODUxNywzNC4xMDkwMTg5IDEwLjgwNzkzNzYsMzMuNjQwMjU3NCAxMC44MDc0MjM5LDMzLjE3MjUyMTYgQzEwLjgwNjM5NjcsMzIuNzI1ODEzMyAxMC43ODg0MTk4LDMyLjI3ODA3OTQgMTAuODEwNTA1NywzMS44MzIzOTY5IEMxMC44NTE1OTU2LDMxLjAxNTkxMDcgMTEuNDMxOTkxLDMwLjQ1OTQ0ODcgMTIuMjAxNDAwMSwzMC40NzE3NTc1IEMxMi45NDYxNTUyLDMwLjQ4MzU1MzUgMTMuNDk2MjQ2NywzMS4wMTM4NTkyIDEzLjUyMzk4MjQsMzEuODIzNjc4MSBDMTMuNTU0Nzk5OSwzMi43MzcwOTY0IDEzLjU1Mzc3MjYsMzMuNjUzMDc5MSAxMy41MjI5NTUyLDM0LjU2NTk4NDUgTTY1LjI1OTI5NTIsNS4wNjczNDMxNSBDNjQuNjY3NjAwMSwyLjgyMjAwNjA5IDYzLjI4MzM4MjgsMS4zMTkzMDIyMSA2MS4wMTc3ODY0LDAuNzQ2NDI4NDA2IEM2MC4yMjgzNDYsMC41NDY5MjI2NjkgNTkuMzc4Mjk3OSwwLjUyMjgxNzg2MyA1OC41NTU5ODU2LDAuNTIyMzA0OTk0IEM0MS4wMzUyMzYzLDAuNTEwNTA5MDI1IDIzLjUxMzk3MzQsMC41MTIwNDc2MyA1Ljk5MzIyNDE2LDAuNTE1MTI0ODM5IEMyLjU3ODEzNjc1LDAuNTE2MTUwNTc2IDAuMDAxMjg0MDYwNTQsMy4wODgxODQ3IDAuMDAwNzcwNDM2MzI0LDYuNDk1MTY4MjggQy0wLjAwMTc5NzY4NDc2LDE3LjEzNzE4MzggMC4wMDEyODQwNjA1NCwyNy43NzkxOTk0IDAuMDA2NDIwMzAyNywzOC40MjEyMTQ5IEMwLjAwNzQ0NzU1MTEzLDQxLjY4OTcyNDEgMi4zODc1ODIxNyw0NC4wNjYzNTU0IDUuNjU1MjU5NDMsNDQuMDY2ODY4MyBDMjMuNjg3NTc4NCw0NC4wNjg5MTk4IDQxLjcxOTg5NzQsNDQuMDY4OTE5OCA1OS43NTI3Myw0NC4wNjc4OTQgQzYyLjU0MDE2ODYsNDQuMDY3ODk0IDY0LjYzOTM1MDgsNDIuNDAxNTg1MiA2NS4yODg1NzE4LDM5LjY4OTAyNTIgQzY1LjMxNzMzNDcsMzkuNTY4NTAxMSA2NS4zNzIyOTI1LDM5LjQ1NDEzMTUgNjUuNDE1NDM3LDM5LjMzNjY4NDcgTDY1LjQxNTQzNyw1LjYxNDU3MzU0IEM2NS4zNjMwNDczLDUuNDMxOTkyNDYgNjUuMzA3NTc1OSw1LjI1MDQzNzExIDY1LjI1OTI5NTIsNS4wNjczNDMxNSIgaWQ9IkZpbGwtNSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "NMNL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzZweCIgaGVpZ2h0PSI2MHB4IiB2aWV3Qm94PSIwIDAgNzYgNjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA0OC4xICg0NzI1MCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+QUQyOTIyRkMtQkI5MC00OTk2LUIzMEYtMDkzOTdERTYxMjQ1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSIwMGxhbmRpbmdfdXBkYXRlZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3My4wMDAwMDAsIC0yNzI3LjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJwYWdlIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPGcgaWQ9InRvcDQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAyMTk1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9ImZlYXR1cmVzc2VjIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNjEuMDAwMDAwLCA2NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iZmVhdHVyZXMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxMzEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJyYXcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMzAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImY1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMzcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImFuYWx5dGljcy1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTIuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzOC4wMDAwMDAsIDMwLjAwMDAwMCkgcm90YXRlKC0zNjAuMDAwMDAwKSB0cmFuc2xhdGUoLTM4LjAwMDAwMCwgLTMwLjAwMDAwMCkgIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03My45NzA3MzI0LDU1Ljc2NzUwNDUgTDcxLjEzMTk1NjYsNTUuNzY4MDUgTDcxLjEzMTk1NjYsMi4wNDU4MjI3MyBDNzEuMTMxOTU2NiwwLjkxNjA1IDcwLjIyMzYwNzgsLTQuMDkwOTA5MDllLTA1IDY5LjEwMzA4MTEsLTQuMDkwOTA5MDllLTA1IEM2Ny45ODI1NTQ0LC00LjA5MDkwOTA5ZS0wNSA2Ny4wNzQyMDU3LDAuOTE1OTEzNjM2IDY3LjA3NDIwNTcsMi4wNDU4MjI3MyBMNjcuMDc0MjA1Nyw1NS43NjkwMDQ1IEw2My4xMzM1NjUxLDU1Ljc2OTgyMjcgTDYzLjEzMzU2NTEsMTAuMDM2MTg2NCBDNjMuMTMzNTY1MSw4LjkwNjQxMzY0IDYyLjIyNTIxNjQsNy45OTAzMjI3MyA2MS4xMDQ2ODk3LDcuOTkwMzIyNzMgQzU5Ljk4NDI5ODIsNy45OTAzMjI3MyA1OS4wNzU2NzksOC45MDYyNzcyNyA1OS4wNzU2NzksMTAuMDM2MTg2NCBMNTkuMDc1Njc5LDU1Ljc3MDUwNDUgTDU1LjEyMjQ2MTksNTUuNzcxMzIyNyBMNTUuMTIyNDYxOSwyNi42NzU1NSBDNTUuMTIyNDYxOSwyNS41NDU3NzczIDU0LjIxNDExMzIsMjQuNjI5Njg2NCA1My4wOTM1ODY1LDI0LjYyOTY4NjQgQzUxLjk3MzA1OTgsMjQuNjI5Njg2NCA1MS4wNjQ3MTEsMjUuNTQ1NjQwOSA1MS4wNjQ3MTEsMjYuNjc1NTUgTDUxLjA2NDcxMSw1NS43NzIxNDA5IEw0Ni45MjU2ODYxLDU1Ljc3Mjk1OTEgTDQ2LjkyNTY4NjEsMzQuNjEwNDEzNiBDNDYuOTI1Njg2MSwzMy40ODA2NDA5IDQ2LjAxNzMzNzQsMzIuNTY0NTUgNDQuODk2ODEwNywzMi41NjQ1NSBDNDMuNzc2Mjg0LDMyLjU2NDU1IDQyLjg2ODM0MDksMzMuNDgwNjQwOSA0Mi44NjgzNDA5LDM0LjYxMDQxMzYgTDQyLjg2ODM0MDksNTUuNzczNzc3MyBMMzguNTkxMTA5Niw1NS43NzQ3MzE4IEwzOC41OTExMDk2LDMyLjQ0MzE4NjQgQzM4LjU5MTEwOTYsMzEuMzEzNDEzNiAzNy42ODI3NjA5LDMwLjM5NzMyMjcgMzYuNTYyMjM0MiwzMC4zOTczMjI3IEMzNS40NDE4NDI3LDMwLjM5NzMyMjcgMzQuNTMzMzU4NywzMS4zMTMyNzczIDM0LjUzMzM1ODcsMzIuNDQzMTg2NCBMMzQuNTMzMzU4Nyw1NS43NzU1NSBMMzAuMjk0NjY4Myw1NS43NzYyMzE4IEwzMC4yOTQ2NjgzLDQwLjU5NzMyMjcgQzMwLjI5NDY2ODMsMzkuNDY3NTUgMjkuMzg2MzE5NiwzOC41NTE0NTkxIDI4LjI2NTc5MjksMzguNTUxNDU5MSBDMjcuMTQ1MjY2MiwzOC41NTE0NTkxIDI2LjIzNjkxNzQsMzkuNDY3NDEzNiAyNi4yMzY5MTc0LDQwLjU5NzMyMjcgTDI2LjIzNjkxNzQsNTUuNzc3MzIyNyBMMjIuMzk4MTA2LDU1Ljc3ODE0MDkgTDIyLjM5ODEwNiw0OC4yNzY3NzczIEMyMi4zOTgxMDYsNDcuMTQ3MDA0NSAyMS40ODk3NTczLDQ2LjIzMDkxMzYgMjAuMzY5MjMwNiw0Ni4yMzA5MTM2IEMxOS4yNDg3MDM5LDQ2LjIzMDkxMzYgMTguMzQwMzU1Miw0Ny4xNDY4NjgyIDE4LjM0MDM1NTIsNDguMjc2Nzc3MyBMMTguMzQwMzU1Miw1NS43Nzg4MjI3IEwxNC45OTQwNTYyLDU1Ljc3OTUwNDUgTDE0Ljk5NDA1NjIsNDYuOTEzMDA0NSBDMTQuOTk0MDU2Miw0NS43ODMyMzE4IDE0LjA4NTcwNzUsNDQuODY3MTQwOSAxMi45NjUxODA4LDQ0Ljg2NzE0MDkgQzExLjg0NDY1NDEsNDQuODY3MTQwOSAxMC45MzYzMDUzLDQ1Ljc4MzA5NTUgMTAuOTM2MzA1Myw0Ni45MTMwMDQ1IEwxMC45MzYzMDUzLDU1Ljc4MDQ1OTEgTDguNzg5MzcyOTUsNTUuNzgwODY4MiBDNy42NjkxMTY3Myw1NS43ODExNDA5IDYuNzYwOTAzMiw1Ni42OTcwOTU1IDYuNzYxMDM4NDMsNTcuODI3MTQwOSBDNi43NjExNzM2Nyw1OC45NTcwNSA3LjY2OTc5Mjg4LDU5Ljg3MjczMTggOC43OTAzMTk1Nyw1OS44NzI1OTU1IEw0NC42MzE4OTI1LDU5Ljg2NTIzMTggQzQ0LjcxODcxMSw1OS44NzY2ODY0IDQ0LjgwNjg4MTksNTkuODg0NTk1NSA0NC44OTY5NDU5LDU5Ljg4NDU5NTUgQzQ0Ljk4NzI4MDQsNTkuODg0NTk1NSA0NS4wNzU0NTEyLDU5Ljg3NjU1IDQ1LjE2MjY3NTQsNTkuODY1MDk1NSBMNjkuMDk4NDgzMyw1OS44NjA0NTkxIEM2OS4wOTk4MzU2LDU5Ljg2MDQ1OTEgNjkuMTAxMzIzMSw1OS44NjA3MzE4IDY5LjEwMjgxMDcsNTkuODYwNzMxOCBDNjkuMTA0Mjk4Miw1OS44NjA3MzE4IDY5LjEwNTY1MDUsNTkuODYwNDU5MSA2OS4xMDcyNzMzLDU5Ljg2MDQ1OTEgTDczLjk3MTEzODEsNTkuODU5MzY4MiBDNzUuMDkxNTI5NSw1OS44NTkwOTU1IDc1Ljk5OTg3ODMsNTguOTQzMDA0NSA3NS45OTk2MDc4LDU3LjgxMzA5NTUgQzc1Ljk5OTg3ODMsNTYuNjgzMDUgNzUuMDkxMjU5MSw1NS43NjcyMzE4IDczLjk3MDczMjQsNTUuNzY3NTA0NSIgaWQ9IkZpbGwtMSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTE3LjQzOTYxOTksMjEuMTMwNTQwOSBDMTcuNDM4NjczMywyMS4xNzM3NjgyIDE3LjQzMjMxNzQsMjEuMjE2OTk1NSAxNy40MjYzNjczLDIxLjI2MDM1OTEgQzE3LjQyMjAzOTksMjEuMjkyNjc3MyAxNy40MjAxNDY2LDIxLjMyNTk1IDE3LjQxMjg0NDEsMjEuMzU3ODU5MSBDMTcuNDA1NTQxNiwyMS4zOTExMzE4IDE3LjM5MzEwMDQsMjEuNDIzODU5MSAxNy4zODI0MTcxLDIxLjQ1NzEzMTggQzE3LjM2OTcwNTMsMjEuNDk3MjIyNyAxNy4zNTc4MDUsMjEuNTM3MzEzNiAxNy4zNDExNzE1LDIxLjU3NTA4NjQgQzE3LjMzODA2MTIsMjEuNTgxNzY4MiAxNy4zMzY5Nzk0LDIxLjU4ODcyMjcgMTcuMzM0MTM5NSwyMS41OTUyNjgyIEMxNy4zMDk1Mjc0LDIxLjY0ODE3NzMgMTcuMjgwOTkzNiwyMS42OTc4MTM2IDE3LjI0OTg5MDQsMjEuNzQ0NzIyNyBDMTcuMjQ3ODYxOSwyMS43NDc0NSAxNy4yNDUyOTI1LDIxLjc1MDMxMzYgMTcuMjQzMjY0MSwyMS43NTMxNzczIEMxNy4yMDc2OTgyLDIxLjgwNTk1IDE3LjE2NzEyODgsMjEuODUzNjc3MyAxNy4xMjQ1MzEsMjEuODk4NTQwOSBDMTcuMTEyNzY1OCwyMS45MTA4MTM2IDE3LjEwMDU5NSwyMS45MjE4NTkxIDE3LjA4ODAxODUsMjEuOTMzNTg2NCBDMTcuMDUwNTU5NCwyMS45Njk1ODY0IDE3LjAxMTA3MTksMjIuMDAyNzIyNyAxNi45NjkxNTAyLDIyLjAzMjcyMjcgQzE2Ljk1NjE2OCwyMi4wNDIyNjgyIDE2Ljk0MzcyNjcsMjIuMDUyMDg2NCAxNi45MzAyMDM2LDIyLjA2MTIyMjcgQzE2Ljg3NjM4MTUsMjIuMDk2Njc3MyAxNi44MTk4NTQ4LDIyLjEyNzkwNDUgMTYuNzYxMTY0NCwyMi4xNTM2NzczIEMxNi43NDg0NTI3LDIyLjE1OTI2ODIgMTYuNzM1MiwyMi4xNjI2NzczIDE2LjcyMjIxNzgsMjIuMTY3ODU5MSBDMTYuNjcyNzIzMSwyMi4xODcyMjI3IDE2LjYyMjQxNzEsMjIuMjAzMTc3MyAxNi41NzA0ODgzLDIyLjIxNTQ1IEMxNi41NTE5NjE2LDIyLjIxOTgxMzYgMTYuNTMzNTcwMSwyMi4yMjM5MDQ1IDE2LjUxNDYzNzcsMjIuMjI3MzEzNiBDMTYuNDQ3OTY4NywyMi4yMzk1ODY0IDE2LjM4MDYyMzUsMjIuMjQ4MDQwOSAxNi4zMTIzMzE3LDIyLjI0ODA0MDkgQzE2LjI5ODUzODEsMjIuMjQ4MDQwOSAxNi4yODQ0NzQsMjIuMjQzODEzNiAxNi4yNzA1NDUyLDIyLjI0MzI2ODIgQzE2LjIwNTA5MzIsMjIuMjQwNjc3MyAxNi4xNDAzMTc0LDIyLjIzNTYzMTggMTYuMDc3OTc1OCwyMi4yMjIxMzE4IEMxNi4wNTg1MDI1LDIyLjIxNzkwNDUgMTYuMDM5NDM0OSwyMi4yMDkzMTM2IDE2LjAxOTgyNjMsMjIuMjAzOTk1NSBDMTUuOTYxODEyMSwyMi4xODgwNDA5IDE1LjkwNTAxNDksMjIuMTcwNDUgMTUuODUwNzg3MiwyMi4xNDU5MDQ1IEMxNS44NDQ3MDE4LDIyLjE0Mjc2ODIgMTUuODM4MjEwNywyMi4xNDIyMjI3IDE1LjgzMTk5LDIyLjEzOTM1OTEgTDkuNTc2NzMwMjUsMTkuMTY0MTc3MyBDOS4wMTMyMjEzNSwxOC44OTYzNTkxIDguNzcxODMzNDUsMTguMjE4MjIyNyA5LjAzNzQyNzc2LDE3LjY0OTk5NTUgQzkuMzAzMTU3MywxNy4wODIwNDA5IDkuOTc1NjYyNjMsMTYuODM4MDg2NCAxMC41MzkxNzE1LDE3LjEwNjA0MDkgTDE1LjE4NDkwODIsMTkuMzE1MTMxOCBMMTUuMTg0OTA4Miw5LjQ5NjEzMTgyIEMxNS4xODQ5MDgyLDguODY3OTA0NTUgMTUuNjg5OTk3Miw4LjM1ODQ1IDE2LjMxMzAwNzgsOC4zNTg0NSBDMTYuOTM2MTUzNyw4LjM1ODQ1IDE3LjQ0MTM3NzksOC44Njc5MDQ1NSAxNy40NDEzNzc5LDkuNDk2MTMxODIgTDE3LjQ0MTM3NzksMjEuMTEwMDg2NCBMMTcuNDQxNTEzMiwyMS4xMTAwODY0IEMxNy40NDE1MTMyLDIxLjExNjc2ODIgMTcuNDM5NjE5OSwyMS4xMjM1ODY0IDE3LjQzOTYxOTksMjEuMTMwNTQwOSBNMTYuMzEzMDA3OCwyLjY2OTQ5NTQ1IEM3LjMwMzYyNzA1LDIuNjY5NDk1NDUgNS40MDkyNTI2N2UtMDUsMTAuMDM0NDk1NSA1LjQwOTI1MjY3ZS0wNSwxOS4xMTkwNDA5IEM1LjQwOTI1MjY3ZS0wNSwyOC4yMDM1ODY0IDcuMzAzNjI3MDUsMzUuNTY5NDA0NSAxNi4zMTMwMDc4LDM1LjU2OTQwNDUgQzI1LjMyMjM4ODYsMzUuNTY5NDA0NSAzMi42MjY1MDI1LDI4LjIwMzg1OTEgMzIuNjI2NTAyNSwxOS4xMTkwNDA5IEMzMi42MjY1MDI1LDEwLjAzNDA4NjQgMjUuMzIyMzg4NiwyLjY2OTQ5NTQ1IDE2LjMxMzAwNzgsMi42Njk0OTU0NSIgaWQ9IkZpbGwtNCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "Nwy1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-component",attrs:{"id":"success"}},[_c('div',{staticClass:"banner success-banner"},[_c('container',[_c('header',[_c('div',{staticClass:"inner"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"pointer logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("aUqx")}}),_c('span',{staticClass:"logo-text"},[_vm._v("vLite")])])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"white-text"},[_vm._v("Congratulations!")]),_vm._v(" "),_c('h2',{staticClass:"white-text"},[_vm._v("Your vendor ID is "+_vm._s(_vm.vendorid))]),_vm._v(" "),_c('grid',{staticClass:"vl-rltv",attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"zindex101",attrs:{"size":"8/12"}},[_c('h3',{staticClass:"banner-text-normal white-text"},[_vm._v("A verification mail has been sent to "),_c('strong',[_vm._v(_vm._s(_vm.email))]),_vm._v(".")]),_vm._v(" "),_c('h4',{staticClass:"banner-text-normal white-text"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('button',{class:_vm.buttonclass,attrs:{"type":"button"},on:{"click":function($event){return _vm.resendVerificationMail()}}},[_vm._v("RESEND VERIFICATION MAIL")])]),_vm._v(" "),_c('grid-item',{staticClass:"v-middle right zindex101 vl-bnr-top-ico",attrs:{"size":"4/12"}},[_c('img',{staticClass:"v-middle right width60",attrs:{"src":__webpack_require__("ExfC")}})])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"success-basic"},[_c('container',[_c('p',{staticClass:"center success-p"},[_vm._v("Please follow the link in mail to verify.")]),_vm._v(" "),_c('p',{staticClass:"center success-p"},[_vm._v("Post verification - your "),_c('strong',[_vm._v(_vm._s(_vm.planData.planname))]),_vm._v(" plan shall be activated and  you shall receive details to sign in to vendor console and upload content.")]),_vm._v(" "),_c('p',{staticClass:"center success-p"},[_vm._v("You shall receive iOS, Android and Web Apps in next 24 hours. ")]),_vm._v(" "),_c('p',{staticClass:"center success-p"},[_vm._v("Please test and let us know when you ready to go live.")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('div',{staticClass:"success-back-color blk-pad"},[_c('container',[_c('p',{staticClass:"center success-help m-0"},[_vm._v("Need Help?")]),_vm._v(" "),_c('p',{staticClass:"center success-p m-0 p-top-10"},[_vm._v("Please contact us at "),_c('strong',[_vm._v("vlitesupport@mobiotics.com")])]),_vm._v(" "),_c('p',{staticClass:"center success-p m-0 p-top-10"},[_vm._v("citing your vendor id "),_c('strong',[_vm._v("("+_vm._s(_vm.vendorid)+")")]),_vm._v(" for any help.")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-color"},[_c('container',[_c('grid',[_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-left"},[_c('div',{staticClass:" logo-opacity"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",staticStyle:{"width":"20%"},attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_vm._v("© Copyright "),_c('label',{attrs:{"id":"copyrightyear"}}),_c('a',{attrs:{"href":"https://www.mobiotics.com","target":"_blank"}},[_c('img',{staticClass:"v-middle foot-cmp-logo",attrs:{"src":__webpack_require__("/krl")}})])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-mid"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://www.facebook.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"facebook"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://plus.google.com/106588943035549674608/posts')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.5","name":"google-plus"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://twitter.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"twitter"}})],1)])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-right f-right"},[_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms Of Use")])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])],1)],1)],1)]),_vm._v(" "),_c('container',[(_vm.loaderStatus)?_c('div',{staticClass:"dash-loader",attrs:{"id":"dash-loader"}},[_c('div',{staticClass:"dash-loader-img"},[_c('svg',{staticClass:"lds-spin",staticStyle:{"background":"none"},attrs:{"width":"100px","height":"100px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('g',{attrs:{"transform":"translate(80,50)"}},[_c('g',{attrs:{"transform":"rotate(0)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"1","transform":"scale(1.045 1.045)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.8333333333333334s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.8333333333333334s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(59.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.8333333333333334","transform":"scale(1.06167 1.06167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.6666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.6666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(35.00000000000001,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(119.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.6666666666666666","transform":"scale(1.07833 1.07833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.5s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.5s"}})],1)])]),_c('g',{attrs:{"transform":"translate(20,50.00000000000001)"}},[_c('g',{attrs:{"transform":"rotate(180)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"0.5","transform":"scale(1.095 1.095)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.3333333333333333s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.3333333333333333s"}})],1)])]),_c('g',{attrs:{"transform":"translate(34.999999999999986,24.019237886466847)"}},[_c('g',{attrs:{"transform":"rotate(239.99999999999997)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.3333333333333333","transform":"scale(1.01167 1.01167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.16666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.16666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,24.019237886466843)"}},[_c('g',{attrs:{"transform":"rotate(300.00000000000006)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.16666666666666666","transform":"scale(1.02833 1.02833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"0s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"0s"}})],1)])])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O0jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OOdf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "OXBq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/casual-light.2ba08fe.png";

/***/ }),

/***/ "Oppg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "QvAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-component"},[_c('div',{attrs:{"id":"headerelement"}},[(_vm.showfixedheader)?_c('fixed-header',{attrs:{"fixed":_vm.isFixed},on:{"update:fixed":function($event){_vm.isFixed=$event}}},[_c('nav',{staticClass:"navbar",class:{ 'is-light-vli': _vm.isFixed, 'is-primary-vli': !_vm.isFixed }},[_c('container',[(_vm.normaldevice)?_c('header',[_c('div',{staticClass:"inner",staticStyle:{"padding-top":"20px"}},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])]),_vm._v(" "),_c('button',{staticClass:"btn-head banner-head-get-btn raise banner-head-vil-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("SUBSCRIBE")])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('header',[_c('div',{staticClass:"inner-sm"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('button',{staticClass:"btn-hamb",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"})]),_vm._v(" "),_c('button',{staticClass:"btn-head banner-head-get-btn raise banner-head-vil-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("SUBSCRIBE")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebarVisible),expression:"sidebarVisible"}],staticClass:"sidebar"},[_c('div',{staticClass:"menus"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])]),_vm._v(" "),_c('button',{staticClass:"btn-close-sidebar",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"2.5","name":"times"}})],1)])],1)]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner dashboard-banner"},[_c('container',[(_vm.normaldevice)?_c('header',[_c('div',{staticClass:"inner"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"pointer logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('header',[_c('div',{staticClass:"inner-sm"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('button',{staticClass:"btn-hamb",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"})]),_vm._v(" "),_c('button',{staticClass:"btn-head banner-head-get-btn raise banner-head-vil-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("SUBSCRIBE")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebarVisible),expression:"sidebarVisible"}],staticClass:"sidebar"},[_c('div',{staticClass:"menus"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])]),_vm._v(" "),_c('button',{staticClass:"btn-close-sidebar",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"2.5","name":"times"}})],1)])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"white-text"},[_vm._v("Try out our Demo")]),_vm._v(" "),_c('h2',{staticClass:"white-text"},[_vm._v("Watch demo video, download demo apps or request for a live demo")]),_vm._v(" "),_c('grid',{staticClass:"vl-rltv",attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"zindex101",attrs:{"size":"8/12"}},[_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#watchvideo'),expression:"'#watchvideo'"}],staticClass:"btn banner-demo-get-btn uppercase raise",attrs:{"type":"button"}},[_vm._v("Watch Video")]),_vm._v(" "),_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#livedemo'),expression:"'#livedemo'"}],staticClass:"btn banner-get-btn-demo uppercase raise",attrs:{"type":"button"}},[_vm._v("Live Demo")])]),_vm._v(" "),_c('grid-item',{staticClass:"v-middle right zindex101 vl-bnr-top-ico",attrs:{"size":"4/12"}},[_c('div',{staticClass:"top-right-gfx"})])],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"6em"}},[_c('container',{staticClass:"vl-how-works vl-what-is-it-div",attrs:{"id":"demotemplate"}},[_c('h1',[_vm._v("Casual Template")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"left-text right-align-text",attrs:{"size":"8/12"}},[_c('h2',{staticClass:"yellow"},[_vm._v("MOOC Demo")]),_vm._v(" "),_c('p',[_vm._v("Try out vLite™ MOOC Demo in causal template. You can select light or dark theme from the app.")]),_vm._v(" "),_c('div',{staticClass:"right download-icons-right"},[_c('a',{attrs:{"href":"https://d1l9nk38qfix2.cloudfront.net/demo/vLite_Casual_MOOC_v3.apk","download":""}},[_c('div',{staticClass:"store-icon store-icon-left",on:{"click":function($event){return _vm.demoAppDownload('Casual','MOOC','Andriod')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 200 60"}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"none","d":"M.777 1.041h152.032v58.851H.777z"}}),_vm._v(" "),_c('rect',{attrs:{"width":"198.873","height":"58.925","x":".777","y":".967","fill":"#000","rx":"7.366"}}),_vm._v(" "),_c('path',{attrs:{"d":"M192.285 2.146a6.187 6.187 0 0 1 6.187 6.187v44.194a6.187 6.187 0 0 1-6.187 6.187H8.143a6.187 6.187 0 0 1-6.187-6.187V8.333a6.187 6.187 0 0 1 6.187-6.187h184.142zm0-1.179H8.143A7.366 7.366 0 0 0 .777 8.333v44.194a7.366 7.366 0 0 0 7.366 7.365h184.142a7.366 7.366 0 0 0 7.365-7.365V8.333a7.366 7.366 0 0 0-7.365-7.366z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-width":".272","d":"M74.049 16.422a3.692 3.692 0 0 1-1.022 2.725 3.965 3.965 0 0 1-2.998 1.213 4.292 4.292 0 0 1-3.01-7.317 4.087 4.087 0 0 1 3.01-1.226 4.224 4.224 0 0 1 1.676.34c.493.2.932.512 1.28.913l-.721.723a2.725 2.725 0 0 0-2.235-.968 3.16 3.16 0 0 0-3.174 3.27 3.215 3.215 0 0 0 5.45 2.357c.419-.454.66-1.044.68-1.662H70.03v-.981h3.965c.037.202.055.408.055.613zM80.289 13.016H76.61v2.589h3.352v.98H76.61v2.59h3.679v1.008H75.52v-8.175h4.769zM84.758 20.183h-1.05v-7.167H81.42v-1.008H87.1v1.008h-2.343zM91.107 20.183v-8.175h1.049v8.175zM96.816 20.183h-1.05v-7.167h-2.288v-1.008h5.613v1.008h-2.275zM109.732 19.12a4.25 4.25 0 0 1-5.995 0 4.414 4.414 0 0 1 0-6.063 4.224 4.224 0 0 1 5.995 0 4.4 4.4 0 0 1 0 6.063zm-5.218-.681a3.147 3.147 0 0 0 4.441 0 3.488 3.48this.$router.push({ name: 'Success', params: { plandata: this.planData, vendorid: result.success, email: email }});8 0 0 0 0-4.687 3.147 3.147 0 0 0-4.441 0 3.488 3.488 0 0 0 0 4.687zM112.416 20.183v-8.175h1.28l3.98this.$router.push({ name: 'Success', params: { plandata: this.planData, vendorid: result.success, email: email }}); 6.363v-6.363h1.035v8.175h-1.09l-4.156-6.663v6.663z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M102.28 32.104a5.79 5.79 0 1 0 5.817 5.79 5.709 5.709 0 0 0-5.818-5.79zm0 9.306a3.515 3.515 0 1 1 3.27-3.515 3.352 3.352 0 0 1-3.27 3.515zm-12.686-9.306a5.79 5.79 0 1 0 5.805 5.79 5.709 5.709 0 0 0-5.818-5.79h.013zm0 9.306a3.515 3.515 0 1 1 3.257-3.515 3.352 3.352 0 0 1-3.27 3.515h.013zm-15.11-7.52v2.452h5.887a5.137 5.137 0 0 1-1.363 3.092 6.022 6.022 0 0 1-4.537 1.799 6.54 6.54 0 1 1 0-13.08 6.267 6.267 0 0 1 4.455 1.758l1.73-1.73a8.57 8.57 0 0 0-6.171-2.548 9.006 9.006 0 1 0 0 17.998 8.175 8.175 0 0 0 6.28-2.52 8.175 8.175 0 0 0 2.126-5.75 7.998 7.998 0 0 0-.136-1.54h-8.27v.068zm61.734 1.907a5.45 5.45 0 0 0-4.959-3.693 5.45 5.45 0 0 0-5.45 5.79 5.668 5.668 0 0 0 5.75 5.791 5.763 5.763 0 0 0 4.823-2.561l-1.976-1.363a3.31 3.31 0 0 1-2.847 1.608 2.943 2.943 0 0 1-2.807-1.757l7.753-3.202-.287-.613zm-7.902 1.934a3.175 3.175 0 0 1 3.025-3.379 2.248 2.248 0 0 1 2.152 1.227l-5.177 2.152zm-6.295 5.614h2.548V26.314h-2.548v17.03zm-4.169-9.946h-.095a4.087 4.087 0 0 0-3.052-1.363 5.804 5.804 0 0 0 0 11.595 3.951 3.951 0 0 0 3.052-1.363h.082v.94c0 2.221-1.186 3.407-3.093 3.407a3.202 3.202 0 0 1-2.916-2.058l-2.22.927a5.518 5.518 0 0 0 5.136 3.42c2.984 0 5.45-1.758 5.45-6.036V32.445h-2.344v.954zm-2.915 8.011a3.529 3.529 0 0 1 0-7.03 3.27 3.27 0 0 1 3.092 3.515 3.243 3.243 0 0 1-3.106 3.515h.014zm33.217-15.096h-6.09v17.03h2.547v-6.457h3.556a5.3 5.3 0 1 0-.013-10.573zm0 8.175h-3.556v-5.804h3.61a2.916 2.916 0 0 1 0 5.83l-.054-.026zm15.709-2.453a4.769 4.769 0 0 0-4.537 2.603l2.262.94a2.412 2.412 0 0 1 2.316-1.254 2.452 2.452 0 0 1 2.725 2.194v.177a5.627 5.627 0 0 0-2.657-.654c-2.439 0-4.905 1.362-4.905 3.829a3.938 3.938 0 0 0 4.224 3.746 3.583 3.583 0 0 0 3.27-1.635h.081v1.363h2.453V36.79c0-2.983-2.262-4.714-5.164-4.714l-.068-.04zm-.313 9.333a1.771 1.771 0 0 1-1.99-1.444c0-1.363 1.445-1.812 2.725-1.812.81-.02 1.61.178 2.317.572a3.08 3.08 0 0 1-2.984 2.725l-.068-.04zm14.483-8.924l-2.916 7.385h-.082l-3.024-7.385h-2.725l4.537 10.328-2.589 5.736h2.657l6.976-16.064H178.033zm-22.903 10.9h2.547V26.314h-2.547v17.03zM23.664 12.744a2.725 2.725 0 0 0-.626 1.907v30.138a2.725 2.725 0 0 0 .626 1.907l.096.096 16.88-16.868v-.408L23.76 12.648l-.096.096z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ADADAD","d":"M46.227 35.551l-5.586-5.627v-.408l5.586-5.627.123.068 6.69 3.801c1.907 1.077 1.907 2.848 0 3.938l-6.663 3.787-.15.068z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#C1C1C1","d":"M46.39 35.47l-5.75-5.75-16.976 16.976a2.22 2.22 0 0 0 2.834.082L46.404 35.47"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#DEDEDE","d":"M46.39 23.97L26.485 12.662a2.22 2.22 0 0 0-2.834.081L40.64 29.72l5.75-5.75z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M46.227 35.347l-19.742 11.24a2.275 2.275 0 0 1-2.725 0l-.096.096.096.095a2.262 2.262 0 0 0 2.725 0L46.39 35.47l-.163-.122z","opacity":".2"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M23.664 46.506a2.725 2.725 0 0 1-.626-1.908v.205a2.725 2.725 0 0 0 .626 1.907l.096-.095-.096-.11zM53.04 31.491l-6.813 3.856.123.123 6.69-3.788a2.384 2.384 0 0 0 1.362-1.962 2.534 2.534 0 0 1-1.363 1.771z","opacity":".12"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M26.485 12.853l26.554 15.096a2.534 2.534 0 0 1 1.363 1.771 2.384 2.384 0 0 0-1.363-1.962L26.485 12.662c-1.908-1.077-3.461-.177-3.461 2.003v.204c.04-2.194 1.567-3.093 3.46-2.016z","opacity":".25"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.popupoutsidecasmooc),expression:"popupoutsidecasmooc"}],staticClass:"inline-blk store-icon-left"},[_c('svg',{staticClass:"store-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 196 57"},on:{"click":function($event){return _vm.demoAppDownload('Casual','MOOC','IOS')}}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M189.937 57.36H6.17c-3.819 0-6.927-3.117-6.927-6.932V5.696c0-3.817 3.108-6.922 6.927-6.922h183.767c3.817 0 7.035 3.105 7.035 6.922v44.732c0 3.815-3.218 6.932-7.035 6.932z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M195.554 50.43c0 3.098-2.51 5.609-5.615 5.609H6.169c-3.103 0-5.622-2.51-5.622-5.61V5.694A5.624 5.624 0 0 1 6.17.077h183.767a5.616 5.616 0 0 1 5.616 5.617l.001 44.735z"}}),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M43.37 27.75c-.042-4.72 3.866-7.017 4.044-7.124-2.213-3.226-5.643-3.667-6.848-3.702-2.881-.304-5.676 1.724-7.144 1.724-1.496 0-3.756-1.695-6.192-1.645-3.134.048-6.067 1.863-7.675 4.68-3.319 5.747-.844 14.19 2.336 18.835 1.59 2.274 3.45 4.814 5.882 4.725 2.38-.098 3.27-1.518 6.142-1.518 2.845 0 3.68 1.518 6.161 1.46 2.555-.04 4.163-2.284 5.698-4.58C47.612 38 48.35 35.432 48.38 35.3c-.06-.02-4.961-1.89-5.01-7.549zM38.684 13.868c1.28-1.6 2.155-3.778 1.912-5.989-1.852.082-4.17 1.282-5.504 2.848-1.18 1.38-2.235 3.64-1.962 5.768 2.08.155 4.218-1.05 5.554-2.627z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M77.815 44.916h-3.326l-1.823-5.725h-6.333l-1.735 5.725h-3.239l6.275-19.491h3.875l6.306 19.491zm-5.698-8.127l-1.647-5.09c-.175-.52-.501-1.744-.983-3.672h-.059c-.192.83-.5 2.054-.926 3.672l-1.618 5.09h5.233zM93.95 37.716c0 2.39-.645 4.28-1.937 5.667-1.157 1.234-2.594 1.851-4.309 1.851-1.851 0-3.181-.665-3.991-1.995h-.059v7.404h-3.122V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.175 2.228h.058c1.041-1.678 2.622-2.516 4.743-2.516 1.658 0 3.042.654 4.149 1.965 1.11 1.313 1.664 3.038 1.664 5.178zm-3.18.114c0-1.368-.308-2.496-.926-3.383-.675-.926-1.582-1.389-2.718-1.389-.77 0-1.47.258-2.096.766-.627.513-1.037 1.182-1.23 2.011-.096.387-.144.703-.144.952v2.344c0 1.022.313 1.885.94 2.59.627.704 1.441 1.055 2.443 1.055 1.176 0 2.092-.454 2.746-1.359.657-.907.985-2.102.985-3.587zM110.116 37.716c0 2.39-.646 4.28-1.939 5.667-1.155 1.234-2.592 1.851-4.307 1.851-1.852 0-3.182-.665-3.99-1.995h-.059v7.404H96.7V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.174 2.228h.059c1.04-1.678 2.62-2.516 4.743-2.516 1.656 0 3.04.654 4.15 1.965 1.106 1.313 1.661 3.038 1.661 5.178zm-3.18.114c0-1.368-.31-2.496-.928-3.383-.675-.926-1.579-1.389-2.717-1.389-.772 0-1.47.258-2.097.766-.627.513-1.036 1.182-1.228 2.011-.095.387-.145.703-.145.952v2.344c0 1.022.314 1.885.938 2.59.626.702 1.44 1.055 2.446 1.055 1.176 0 2.091-.454 2.746-1.359.656-.907.984-2.102.984-3.587zM128.19 39.45c0 1.658-.575 3.007-1.731 4.048-1.27 1.138-3.038 1.707-5.31 1.707-2.097 0-3.778-.405-5.051-1.214l.724-2.603a8.56 8.56 0 0 0 4.514 1.245c1.176 0 2.091-.267 2.749-.797.654-.53.981-1.242.981-2.13 0-.79-.27-1.457-.81-1.997-.537-.54-1.435-1.043-2.689-1.508-3.413-1.272-5.117-3.137-5.117-5.589 0-1.602.597-2.916 1.794-3.938 1.192-1.024 2.783-1.535 4.772-1.535 1.773 0 3.247.309 4.423.926l-.78 2.545c-1.1-.597-2.341-.896-3.731-.896-1.099 0-1.957.27-2.572.81-.52.482-.78 1.069-.78 1.765 0 .77.296 1.407.894 1.908.52.463 1.465.964 2.836 1.504 1.677.676 2.908 1.465 3.7 2.37.79.902 1.184 2.032 1.184 3.38zM138.515 33.205h-3.442v6.824c0 1.735.606 2.602 1.822 2.602.558 0 1.02-.048 1.387-.145l.086 2.372c-.615.23-1.425.345-2.428.345-1.234 0-2.197-.376-2.893-1.128-.693-.752-1.041-2.015-1.041-3.789v-7.084h-2.05v-2.344h2.05v-2.573l3.067-.926v3.5h3.442v2.346zM154.044 37.773c0 2.16-.618 3.934-1.851 5.321-1.293 1.428-3.01 2.14-5.15 2.14-2.062 0-3.704-.684-4.928-2.052-1.225-1.368-1.837-3.095-1.837-5.176 0-2.178.63-3.962 1.894-5.349 1.26-1.388 2.963-2.083 5.103-2.083 2.062 0 3.721.684 4.974 2.054 1.198 1.328 1.795 3.043 1.795 5.145zm-3.24.101c0-1.296-.276-2.408-.837-3.335-.655-1.122-1.59-1.681-2.804-1.681-1.255 0-2.208.56-2.863 1.681-.561.929-.838 2.058-.838 3.394 0 1.296.277 2.408.838 3.333.675 1.122 1.618 1.682 2.836 1.682 1.192 0 2.128-.572 2.803-1.711.576-.945.866-2.068.866-3.363zM164.194 33.608a5.422 5.422 0 0 0-.984-.087c-1.098 0-1.948.415-2.545 1.245-.52.732-.781 1.658-.781 2.776v7.374h-3.121l.029-9.628c0-1.62-.04-3.095-.117-4.425h2.72l.114 2.689h.086c.33-.924.85-1.668 1.562-2.226.695-.503 1.447-.753 2.257-.753.288 0 .549.02.78.057v2.978zM178.16 37.224c0 .56-.037 1.03-.114 1.416h-9.368c.036 1.389.489 2.45 1.359 3.183.79.655 1.81.983 3.064.983 1.387 0 2.652-.222 3.79-.665l.49 2.167c-1.33.58-2.9.869-4.712.869-2.18 0-3.89-.642-5.135-1.923-1.242-1.282-1.865-3.003-1.865-5.162 0-2.119.579-3.884 1.737-5.291 1.213-1.503 2.852-2.255 4.914-2.255 2.026 0 3.56.752 4.6 2.255.825 1.193 1.24 2.67 1.24 4.423zm-2.978-.81c.02-.926-.183-1.726-.606-2.4-.54-.87-1.371-1.303-2.489-1.303-1.02 0-1.85.423-2.485 1.273-.52.675-.83 1.485-.924 2.428h6.504v.002z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M71.085 13.433c0 1.724-.517 3.022-1.55 3.893-.956.805-2.316 1.207-4.076 1.207-.873 0-1.62-.038-2.245-.114V9a16.57 16.57 0 0 1 2.643-.198c1.677 0 2.941.364 3.794 1.094.955.824 1.434 2.003 1.434 3.538zm-1.619.043c0-1.118-.296-1.975-.887-2.572-.592-.596-1.456-.895-2.594-.895-.484 0-.895.032-1.236.1v7.16c.188.03.534.043 1.037.043 1.174 0 2.08-.327 2.72-.98.638-.653.96-1.605.96-2.856zM79.666 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.477 1.052-2.529 1.052-1.013 0-1.82-.335-2.422-1.01-.601-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.62-.681 1.456-1.023 2.507-1.023 1.014 0 1.828.336 2.445 1.008.586.653.88 1.497.88 2.528zm-1.592.05c0-.637-.138-1.184-.412-1.64-.322-.55-.78-.825-1.376-.825-.617 0-1.086.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.795.826 1.393.826.586 0 1.046-.28 1.377-.841.284-.464.426-1.015.426-1.652zM91.172 11.544l-2.16 6.904h-1.406l-.895-2.998a22.439 22.439 0 0 1-.555-2.23h-.028a16.331 16.331 0 0 1-.555 2.23l-.95 2.998H83.2l-2.031-6.904h1.577l.78 3.282c.19.777.345 1.516.47 2.216h.027c.115-.577.304-1.312.57-2.201l.98-3.296h1.25l.94 3.226c.227.786.411 1.543.553 2.273h.043c.104-.71.26-1.468.469-2.273l.837-3.226h1.507v-.001zM99.13 18.448h-1.535v-3.954c0-1.219-.463-1.828-1.391-1.828-.456 0-.824.167-1.11.502-.282.336-.425.731-.425 1.184v4.095h-1.535v-4.93c0-.607-.02-1.264-.056-1.976h1.349l.072 1.08h.042c.179-.336.445-.613.795-.834a2.594 2.594 0 0 1 1.392-.388c.644 0 1.18.208 1.607.625.53.512.795 1.275.795 2.288v4.136zM103.363 18.448h-1.534V8.376h1.534zM112.4 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.48 1.052-2.53 1.052-1.014 0-1.821-.335-2.422-1.01-.6-.671-.9-1.52-.9-2.542 0-1.069.308-1.946.93-2.627.62-.681 1.455-1.023 2.505-1.023 1.015 0 1.828.336 2.446 1.008.586.653.88 1.497.88 2.528zm-1.594.05c0-.637-.138-1.184-.411-1.64-.321-.55-.781-.825-1.376-.825-.618 0-1.086.275-1.407.826-.276.455-.412 1.01-.412 1.667 0 .637.138 1.183.412 1.639.332.55.795.826 1.393.826.586 0 1.044-.28 1.375-.841.286-.464.426-1.015.426-1.652zM119.828 18.448h-1.378l-.114-.795h-.042c-.472.634-1.144.952-2.017.952-.652 0-1.18-.21-1.576-.625-.36-.378-.54-.848-.54-1.406 0-.844.35-1.487 1.058-1.932.706-.446 1.7-.664 2.978-.654v-.128c0-.91-.478-1.364-1.434-1.364-.681 0-1.282.171-1.8.511L114.65 12c.641-.396 1.434-.596 2.368-.596 1.805 0 2.71.952 2.71 2.856v2.543c0 .69.034 1.24.1 1.646zm-1.593-2.372V15.01c-1.693-.03-2.54.435-2.54 1.391 0 .36.097.63.295.81.197.18.45.27.75.27.336 0 .651-.107.938-.32a1.308 1.308 0 0 0 .557-1.086zM128.55 18.448h-1.362l-.071-1.108h-.043c-.435.843-1.176 1.265-2.217 1.265-.832 0-1.525-.327-2.074-.98-.55-.653-.823-1.501-.823-2.542 0-1.118.297-2.023.894-2.714.579-.645 1.288-.967 2.132-.967.927 0 1.575.312 1.945.937h.029V8.376h1.536v8.212c0 .673.018 1.292.055 1.86zm-1.59-2.911v-1.152c0-.199-.015-.36-.043-.483a1.748 1.748 0 0 0-.555-.93 1.509 1.509 0 0 0-1.026-.376c-.573 0-1.021.227-1.35.682-.327.456-.493 1.037-.493 1.747 0 .683.157 1.237.472 1.663.332.454.78.68 1.341.68.504 0 .907-.188 1.213-.567.296-.35.44-.772.44-1.264zM141.678 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.476 1.052-2.529 1.052-1.012 0-1.819-.335-2.422-1.01-.6-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.621-.681 1.456-1.023 2.509-1.023 1.012 0 1.828.336 2.443 1.008.586.653.88 1.497.88 2.528zm-1.59.05c0-.637-.138-1.184-.412-1.64-.324-.55-.78-.825-1.378-.825-.615 0-1.084.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.796.826 1.393.826.586 0 1.047-.28 1.378-.841.283-.464.427-1.015.427-1.652zM149.932 18.448h-1.534v-3.954c0-1.219-.463-1.828-1.393-1.828a1.38 1.38 0 0 0-1.107.502c-.284.336-.426.731-.426 1.184v4.095h-1.537v-4.93c0-.607-.017-1.264-.054-1.976h1.348l.071 1.08h.043a2.24 2.24 0 0 1 .795-.834 2.6 2.6 0 0 1 1.393-.388c.643 0 1.18.208 1.605.625.532.512.796 1.275.796 2.288v4.136zM160.262 12.694h-1.69v3.354c0 .852.3 1.278.894 1.278.276 0 .504-.023.684-.071l.04 1.164c-.303.114-.702.171-1.192.171-.607 0-1.078-.184-1.42-.553-.342-.37-.512-.99-.512-1.862v-3.481h-1.01v-1.15h1.01v-1.266l1.504-.454v1.718h1.69v1.152h.002zM168.388 18.448h-1.537v-3.925c0-1.238-.463-1.857-1.39-1.857-.711 0-1.198.359-1.464 1.076-.046.151-.072.336-.072.553v4.152h-1.534V8.376h1.534v4.161h.03c.483-.757 1.175-1.135 2.073-1.135.636 0 1.162.208 1.58.625.519.52.78 1.294.78 2.316v4.105zM176.77 14.67c0 .275-.02.506-.057.695h-4.604c.02.683.24 1.203.667 1.563.39.322.892.483 1.507.483.681 0 1.302-.108 1.862-.326l.24 1.066c-.655.284-1.425.426-2.317.426-1.07 0-1.912-.315-2.521-.944-.612-.63-.915-1.475-.915-2.536 0-1.041.282-1.908.852-2.6.595-.738 1.399-1.107 2.414-1.107.993 0 1.747.37 2.257 1.107.411.586.615 1.311.615 2.173zm-1.465-.397c.012-.456-.089-.848-.297-1.18-.267-.426-.672-.64-1.222-.64-.5 0-.91.208-1.221.626-.255.332-.406.73-.456 1.194h3.196z"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mooccasVisible),expression:"mooccasVisible"}],class:_vm.storebox,attrs:{"id":"mooccasualdiv"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mooccasVisiblecontent),expression:"mooccasVisiblecontent"}]},[_c('div',{class:_vm.storeclass},[_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter username")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"username","value":""}})]),_vm._v(" "),_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter your "),_c('span',{staticClass:"store-appleid"},[_vm._v("apple ID")]),_vm._v(" email")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"email","value":""}})])]),_vm._v(" "),_c('button',{staticClass:"btn store-ios-box-btn m-top-20",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.sendiospreflightreq('mooccasualdiv','MOOC','Casual')}}},[_vm._v("SUBMIT")]),_vm._v(" "),_c('button',{staticClass:"store-ios-close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeiosbox('Casual','MOOC','IOS')}}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"1.2","name":"times"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mooccasVisiblesuccess),expression:"mooccasVisiblesuccess"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("E6125A26-8AD7-469B-BDEE-FA9E4CBB678C@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -369.000000)"}},[_c('g',{attrs:{"id":"Group-16","transform":"translate(646.000000, 328.225339)"}},[_c('g',{attrs:{"id":"tick","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.8863524,23.0158289 L12.860692,23.0414893 L8.24524054,18.4260378 L10.7201344,15.9511439 L13.8221924,19.0532018 L23.2524496,9.62294461 L25.7273435,12.0978385 L13.8478528,23.9773293 L12.8863524,23.0158289 Z","id":"Combined-Shape","fill":"#3BD7DC"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Great!")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("You shall receive test flight details shortly at "+_vm._s(_vm.email))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mooccasVisibleerror),expression:"mooccasVisibleerror"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("D963B944-6D2B-4A9A-84CA-03380669B045@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -150.000000)"}},[_c('g',{attrs:{"id":"Group-16-Copy","transform":"translate(646.000000, 109.037198)"}},[_c('g',{attrs:{"id":"cross","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18.7498014,16.3836906 L23.4520998,21.085989 L20.9772059,23.5608829 L16.2749075,18.8585845 L11.5726091,23.5608829 L9.09771515,21.085989 L13.8000136,16.3836906 L9.09771515,11.6813922 L11.5726091,9.20649826 L16.2749075,13.9087967 L20.9772059,9.20649826 L23.4520998,11.6813922 L18.7498014,16.3836906 Z","id":"Combined-Shape","fill":"#EB506C"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Sorry")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Please Try again......")])])])])])]),_vm._v(" "),_c('grid-item',{staticClass:"triangle-blue triangle-left",attrs:{"size":"4/12"}},[_c('span',{staticClass:"triangle-number"},[_vm._v("1")])])],1)],1),_vm._v(" "),_c('container',{staticClass:"vl-how-works"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"right"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:"triangle-purple triangle-right",staticStyle:{"padding-top":"76px"},attrs:{"size":"2/12"}},[_c('span',{staticClass:"triangle-number"},[_vm._v("2")])]),_vm._v(" "),_c('grid-item',{staticClass:"left-text left-align-text",attrs:{"size":"8/12"}},[_c('h2',{staticClass:"yellow right-text"},[_vm._v("Entertainment Demo")]),_vm._v(" "),_c('p',[_vm._v("Try out vLite™ entertianment demo in causal template. You can select light or dark theme from the app.")]),_vm._v(" "),_c('div',{staticClass:"left download-icons-left"},[_c('a',{attrs:{"href":"https://d1l9nk38qfix2.cloudfront.net/demo/vLite_Casual_Entertainment_v3.apk","download":""}},[_c('div',{staticClass:"store-icon store-icon-right",on:{"click":function($event){return _vm.demoAppDownload('Casual','Entertainment','Andriod')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 200 60"}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"none","d":"M.777 1.041h152.032v58.851H.777z"}}),_vm._v(" "),_c('rect',{attrs:{"width":"198.873","height":"58.925","x":".777","y":".967","fill":"#000","rx":"7.366"}}),_vm._v(" "),_c('path',{attrs:{"d":"M192.285 2.146a6.187 6.187 0 0 1 6.187 6.187v44.194a6.187 6.187 0 0 1-6.187 6.187H8.143a6.187 6.187 0 0 1-6.187-6.187V8.333a6.187 6.187 0 0 1 6.187-6.187h184.142zm0-1.179H8.143A7.366 7.366 0 0 0 .777 8.333v44.194a7.366 7.366 0 0 0 7.366 7.365h184.142a7.366 7.366 0 0 0 7.365-7.365V8.333a7.366 7.366 0 0 0-7.365-7.366z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-width":".272","d":"M74.049 16.422a3.692 3.692 0 0 1-1.022 2.725 3.965 3.965 0 0 1-2.998 1.213 4.292 4.292 0 0 1-3.01-7.317 4.087 4.087 0 0 1 3.01-1.226 4.224 4.224 0 0 1 1.676.34c.493.2.932.512 1.28.913l-.721.723a2.725 2.725 0 0 0-2.235-.968 3.16 3.16 0 0 0-3.174 3.27 3.215 3.215 0 0 0 5.45 2.357c.419-.454.66-1.044.68-1.662H70.03v-.981h3.965c.037.202.055.408.055.613zM80.289 13.016H76.61v2.589h3.352v.98H76.61v2.59h3.679v1.008H75.52v-8.175h4.769zM84.758 20.183h-1.05v-7.167H81.42v-1.008H87.1v1.008h-2.343zM91.107 20.183v-8.175h1.049v8.175zM96.816 20.183h-1.05v-7.167h-2.288v-1.008h5.613v1.008h-2.275zM109.732 19.12a4.25 4.25 0 0 1-5.995 0 4.414 4.414 0 0 1 0-6.063 4.224 4.224 0 0 1 5.995 0 4.4 4.4 0 0 1 0 6.063zm-5.218-.681a3.147 3.147 0 0 0 4.441 0 3.488 3.488 0 0 0 0-4.687 3.147 3.147 0 0 0-4.441 0 3.488 3.488 0 0 0 0 4.687zM112.416 20.183v-8.175h1.28l3.98 6.363v-6.363h1.035v8.175h-1.09l-4.156-6.663v6.663z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M102.28 32.104a5.79 5.79 0 1 0 5.817 5.79 5.709 5.709 0 0 0-5.818-5.79zm0 9.306a3.515 3.515 0 1 1 3.27-3.515 3.352 3.352 0 0 1-3.27 3.515zm-12.686-9.306a5.79 5.79 0 1 0 5.805 5.79 5.709 5.709 0 0 0-5.818-5.79h.013zm0 9.306a3.515 3.515 0 1 1 3.257-3.515 3.352 3.352 0 0 1-3.27 3.515h.013zm-15.11-7.52v2.452h5.887a5.137 5.137 0 0 1-1.363 3.092 6.022 6.022 0 0 1-4.537 1.799 6.54 6.54 0 1 1 0-13.08 6.267 6.267 0 0 1 4.455 1.758l1.73-1.73a8.57 8.57 0 0 0-6.171-2.548 9.006 9.006 0 1 0 0 17.998 8.175 8.175 0 0 0 6.28-2.52 8.175 8.175 0 0 0 2.126-5.75 7.998 7.998 0 0 0-.136-1.54h-8.27v.068zm61.734 1.907a5.45 5.45 0 0 0-4.959-3.693 5.45 5.45 0 0 0-5.45 5.79 5.668 5.668 0 0 0 5.75 5.791 5.763 5.763 0 0 0 4.823-2.561l-1.976-1.363a3.31 3.31 0 0 1-2.847 1.608 2.943 2.943 0 0 1-2.807-1.757l7.753-3.202-.287-.613zm-7.902 1.934a3.175 3.175 0 0 1 3.025-3.379 2.248 2.248 0 0 1 2.152 1.227l-5.177 2.152zm-6.295 5.614h2.548V26.314h-2.548v17.03zm-4.169-9.946h-.095a4.087 4.087 0 0 0-3.052-1.363 5.804 5.804 0 0 0 0 11.595 3.951 3.951 0 0 0 3.052-1.363h.082v.94c0 2.221-1.186 3.407-3.093 3.407a3.202 3.202 0 0 1-2.916-2.058l-2.22.927a5.518 5.518 0 0 0 5.136 3.42c2.984 0 5.45-1.758 5.45-6.036V32.445h-2.344v.954zm-2.915 8.011a3.529 3.529 0 0 1 0-7.03 3.27 3.27 0 0 1 3.092 3.515 3.243 3.243 0 0 1-3.106 3.515h.014zm33.217-15.096h-6.09v17.03h2.547v-6.457h3.556a5.3 5.3 0 1 0-.013-10.573zm0 8.175h-3.556v-5.804h3.61a2.916 2.916 0 0 1 0 5.83l-.054-.026zm15.709-2.453a4.769 4.769 0 0 0-4.537 2.603l2.262.94a2.412 2.412 0 0 1 2.316-1.254 2.452 2.452 0 0 1 2.725 2.194v.177a5.627 5.627 0 0 0-2.657-.654c-2.439 0-4.905 1.362-4.905 3.829a3.938 3.938 0 0 0 4.224 3.746 3.583 3.583 0 0 0 3.27-1.635h.081v1.363h2.453V36.79c0-2.983-2.262-4.714-5.164-4.714l-.068-.04zm-.313 9.333a1.771 1.771 0 0 1-1.99-1.444c0-1.363 1.445-1.812 2.725-1.812.81-.02 1.61.178 2.317.572a3.08 3.08 0 0 1-2.984 2.725l-.068-.04zm14.483-8.924l-2.916 7.385h-.082l-3.024-7.385h-2.725l4.537 10.328-2.589 5.736h2.657l6.976-16.064H178.033zm-22.903 10.9h2.547V26.314h-2.547v17.03zM23.664 12.744a2.725 2.725 0 0 0-.626 1.907v30.138a2.725 2.725 0 0 0 .626 1.907l.096.096 16.88-16.868v-.408L23.76 12.648l-.096.096z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ADADAD","d":"M46.227 35.551l-5.586-5.627v-.408l5.586-5.627.123.068 6.69 3.801c1.907 1.077 1.907 2.848 0 3.938l-6.663 3.787-.15.068z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#C1C1C1","d":"M46.39 35.47l-5.75-5.75-16.976 16.976a2.22 2.22 0 0 0 2.834.082L46.404 35.47"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#DEDEDE","d":"M46.39 23.97L26.485 12.662a2.22 2.22 0 0 0-2.834.081L40.64 29.72l5.75-5.75z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M46.227 35.347l-19.742 11.24a2.275 2.275 0 0 1-2.725 0l-.096.096.096.095a2.262 2.262 0 0 0 2.725 0L46.39 35.47l-.163-.122z","opacity":".2"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M23.664 46.506a2.725 2.725 0 0 1-.626-1.908v.205a2.725 2.725 0 0 0 .626 1.907l.096-.095-.096-.11zM53.04 31.491l-6.813 3.856.123.123 6.69-3.788a2.384 2.384 0 0 0 1.362-1.962 2.534 2.534 0 0 1-1.363 1.771z","opacity":".12"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M26.485 12.853l26.554 15.096a2.534 2.534 0 0 1 1.363 1.771 2.384 2.384 0 0 0-1.363-1.962L26.485 12.662c-1.908-1.077-3.461-.177-3.461 2.003v.204c.04-2.194 1.567-3.093 3.46-2.016z","opacity":".25"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.popupoutsidecasent),expression:"popupoutsidecasent"}],staticClass:"inline-blk store-icon-right"},[_c('svg',{staticClass:"store-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 196 57"},on:{"click":function($event){return _vm.demoAppDownload('Casual','Entertainment','IOS')}}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M189.937 57.36H6.17c-3.819 0-6.927-3.117-6.927-6.932V5.696c0-3.817 3.108-6.922 6.927-6.922h183.767c3.817 0 7.035 3.105 7.035 6.922v44.732c0 3.815-3.218 6.932-7.035 6.932z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M195.554 50.43c0 3.098-2.51 5.609-5.615 5.609H6.169c-3.103 0-5.622-2.51-5.622-5.61V5.694A5.624 5.624 0 0 1 6.17.077h183.767a5.616 5.616 0 0 1 5.616 5.617l.001 44.735z"}}),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M43.37 27.75c-.042-4.72 3.866-7.017 4.044-7.124-2.213-3.226-5.643-3.667-6.848-3.702-2.881-.304-5.676 1.724-7.144 1.724-1.496 0-3.756-1.695-6.192-1.645-3.134.048-6.067 1.863-7.675 4.68-3.319 5.747-.844 14.19 2.336 18.835 1.59 2.274 3.45 4.814 5.882 4.725 2.38-.098 3.27-1.518 6.142-1.518 2.845 0 3.68 1.518 6.161 1.46 2.555-.04 4.163-2.284 5.698-4.58C47.612 38 48.35 35.432 48.38 35.3c-.06-.02-4.961-1.89-5.01-7.549zM38.684 13.868c1.28-1.6 2.155-3.778 1.912-5.989-1.852.082-4.17 1.282-5.504 2.848-1.18 1.38-2.235 3.64-1.962 5.768 2.08.155 4.218-1.05 5.554-2.627z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M77.815 44.916h-3.326l-1.823-5.725h-6.333l-1.735 5.725h-3.239l6.275-19.491h3.875l6.306 19.491zm-5.698-8.127l-1.647-5.09c-.175-.52-.501-1.744-.983-3.672h-.059c-.192.83-.5 2.054-.926 3.672l-1.618 5.09h5.233zM93.95 37.716c0 2.39-.645 4.28-1.937 5.667-1.157 1.234-2.594 1.851-4.309 1.851-1.851 0-3.181-.665-3.991-1.995h-.059v7.404h-3.122V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.175 2.228h.058c1.041-1.678 2.622-2.516 4.743-2.516 1.658 0 3.042.654 4.149 1.965 1.11 1.313 1.664 3.038 1.664 5.178zm-3.18.114c0-1.368-.308-2.496-.926-3.383-.675-.926-1.582-1.389-2.718-1.389-.77 0-1.47.258-2.096.766-.627.513-1.037 1.182-1.23 2.011-.096.387-.144.703-.144.952v2.344c0 1.022.313 1.885.94 2.59.627.704 1.441 1.055 2.443 1.055 1.176 0 2.092-.454 2.746-1.359.657-.907.985-2.102.985-3.587zM110.116 37.716c0 2.39-.646 4.28-1.939 5.667-1.155 1.234-2.592 1.851-4.307 1.851-1.852 0-3.182-.665-3.99-1.995h-.059v7.404H96.7V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.174 2.228h.059c1.04-1.678 2.62-2.516 4.743-2.516 1.656 0 3.04.654 4.15 1.965 1.106 1.313 1.661 3.038 1.661 5.178zm-3.18.114c0-1.368-.31-2.496-.928-3.383-.675-.926-1.579-1.389-2.717-1.389-.772 0-1.47.258-2.097.766-.627.513-1.036 1.182-1.228 2.011-.095.387-.145.703-.145.952v2.344c0 1.022.314 1.885.938 2.59.626.702 1.44 1.055 2.446 1.055 1.176 0 2.091-.454 2.746-1.359.656-.907.984-2.102.984-3.587zM128.19 39.45c0 1.658-.575 3.007-1.731 4.048-1.27 1.138-3.038 1.707-5.31 1.707-2.097 0-3.778-.405-5.051-1.214l.724-2.603a8.56 8.56 0 0 0 4.514 1.245c1.176 0 2.091-.267 2.749-.797.654-.53.981-1.242.981-2.13 0-.79-.27-1.457-.81-1.997-.537-.54-1.435-1.043-2.689-1.508-3.413-1.272-5.117-3.137-5.117-5.589 0-1.602.597-2.916 1.794-3.938 1.192-1.024 2.783-1.535 4.772-1.535 1.773 0 3.247.309 4.423.926l-.78 2.545c-1.1-.597-2.341-.896-3.731-.896-1.099 0-1.957.27-2.572.81-.52.482-.78 1.069-.78 1.765 0 .77.296 1.407.894 1.908.52.463 1.465.964 2.836 1.504 1.677.676 2.908 1.465 3.7 2.37.79.902 1.184 2.032 1.184 3.38zM138.515 33.205h-3.442v6.824c0 1.735.606 2.602 1.822 2.602.558 0 1.02-.048 1.387-.145l.086 2.372c-.615.23-1.425.345-2.428.345-1.234 0-2.197-.376-2.893-1.128-.693-.752-1.041-2.015-1.041-3.789v-7.084h-2.05v-2.344h2.05v-2.573l3.067-.926v3.5h3.442v2.346zM154.044 37.773c0 2.16-.618 3.934-1.851 5.321-1.293 1.428-3.01 2.14-5.15 2.14-2.062 0-3.704-.684-4.928-2.052-1.225-1.368-1.837-3.095-1.837-5.176 0-2.178.63-3.962 1.894-5.349 1.26-1.388 2.963-2.083 5.103-2.083 2.062 0 3.721.684 4.974 2.054 1.198 1.328 1.795 3.043 1.795 5.145zm-3.24.101c0-1.296-.276-2.408-.837-3.335-.655-1.122-1.59-1.681-2.804-1.681-1.255 0-2.208.56-2.863 1.681-.561.929-.838 2.058-.838 3.394 0 1.296.277 2.408.838 3.333.675 1.122 1.618 1.682 2.836 1.682 1.192 0 2.128-.572 2.803-1.711.576-.945.866-2.068.866-3.363zM164.194 33.608a5.422 5.422 0 0 0-.984-.087c-1.098 0-1.948.415-2.545 1.245-.52.732-.781 1.658-.781 2.776v7.374h-3.121l.029-9.628c0-1.62-.04-3.095-.117-4.425h2.72l.114 2.689h.086c.33-.924.85-1.668 1.562-2.226.695-.503 1.447-.753 2.257-.753.288 0 .549.02.78.057v2.978zM178.16 37.224c0 .56-.037 1.03-.114 1.416h-9.368c.036 1.389.489 2.45 1.359 3.183.79.655 1.81.983 3.064.983 1.387 0 2.652-.222 3.79-.665l.49 2.167c-1.33.58-2.9.869-4.712.869-2.18 0-3.89-.642-5.135-1.923-1.242-1.282-1.865-3.003-1.865-5.162 0-2.119.579-3.884 1.737-5.291 1.213-1.503 2.852-2.255 4.914-2.255 2.026 0 3.56.752 4.6 2.255.825 1.193 1.24 2.67 1.24 4.423zm-2.978-.81c.02-.926-.183-1.726-.606-2.4-.54-.87-1.371-1.303-2.489-1.303-1.02 0-1.85.423-2.485 1.273-.52.675-.83 1.485-.924 2.428h6.504v.002z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M71.085 13.433c0 1.724-.517 3.022-1.55 3.893-.956.805-2.316 1.207-4.076 1.207-.873 0-1.62-.038-2.245-.114V9a16.57 16.57 0 0 1 2.643-.198c1.677 0 2.941.364 3.794 1.094.955.824 1.434 2.003 1.434 3.538zm-1.619.043c0-1.118-.296-1.975-.887-2.572-.592-.596-1.456-.895-2.594-.895-.484 0-.895.032-1.236.1v7.16c.188.03.534.043 1.037.043 1.174 0 2.08-.327 2.72-.98.638-.653.96-1.605.96-2.856zM79.666 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.477 1.052-2.529 1.052-1.013 0-1.82-.335-2.422-1.01-.601-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.62-.681 1.456-1.023 2.507-1.023 1.014 0 1.828.336 2.445 1.008.586.653.88 1.497.88 2.528zm-1.592.05c0-.637-.138-1.184-.412-1.64-.322-.55-.78-.825-1.376-.825-.617 0-1.086.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.795.826 1.393.826.586 0 1.046-.28 1.377-.841.284-.464.426-1.015.426-1.652zM91.172 11.544l-2.16 6.904h-1.406l-.895-2.998a22.439 22.439 0 0 1-.555-2.23h-.028a16.331 16.331 0 0 1-.555 2.23l-.95 2.998H83.2l-2.031-6.904h1.577l.78 3.282c.19.777.345 1.516.47 2.216h.027c.115-.577.304-1.312.57-2.201l.98-3.296h1.25l.94 3.226c.227.786.411 1.543.553 2.273h.043c.104-.71.26-1.468.469-2.273l.837-3.226h1.507v-.001zM99.13 18.448h-1.535v-3.954c0-1.219-.463-1.828-1.391-1.828-.456 0-.824.167-1.11.502-.282.336-.425.731-.425 1.184v4.095h-1.535v-4.93c0-.607-.02-1.264-.056-1.976h1.349l.072 1.08h.042c.179-.336.445-.613.795-.834a2.594 2.594 0 0 1 1.392-.388c.644 0 1.18.208 1.607.625.53.512.795 1.275.795 2.288v4.136zM103.363 18.448h-1.534V8.376h1.534zM112.4 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.48 1.052-2.53 1.052-1.014 0-1.821-.335-2.422-1.01-.6-.671-.9-1.52-.9-2.542 0-1.069.308-1.946.93-2.627.62-.681 1.455-1.023 2.505-1.023 1.015 0 1.828.336 2.446 1.008.586.653.88 1.497.88 2.528zm-1.594.05c0-.637-.138-1.184-.411-1.64-.321-.55-.781-.825-1.376-.825-.618 0-1.086.275-1.407.826-.276.455-.412 1.01-.412 1.667 0 .637.138 1.183.412 1.639.332.55.795.826 1.393.826.586 0 1.044-.28 1.375-.841.286-.464.426-1.015.426-1.652zM119.828 18.448h-1.378l-.114-.795h-.042c-.472.634-1.144.952-2.017.952-.652 0-1.18-.21-1.576-.625-.36-.378-.54-.848-.54-1.406 0-.844.35-1.487 1.058-1.932.706-.446 1.7-.664 2.978-.654v-.128c0-.91-.478-1.364-1.434-1.364-.681 0-1.282.171-1.8.511L114.65 12c.641-.396 1.434-.596 2.368-.596 1.805 0 2.71.952 2.71 2.856v2.543c0 .69.034 1.24.1 1.646zm-1.593-2.372V15.01c-1.693-.03-2.54.435-2.54 1.391 0 .36.097.63.295.81.197.18.45.27.75.27.336 0 .651-.107.938-.32a1.308 1.308 0 0 0 .557-1.086zM128.55 18.448h-1.362l-.071-1.108h-.043c-.435.843-1.176 1.265-2.217 1.265-.832 0-1.525-.327-2.074-.98-.55-.653-.823-1.501-.823-2.542 0-1.118.297-2.023.894-2.714.579-.645 1.288-.967 2.132-.967.927 0 1.575.312 1.945.937h.029V8.376h1.536v8.212c0 .673.018 1.292.055 1.86zm-1.59-2.911v-1.152c0-.199-.015-.36-.043-.483a1.748 1.748 0 0 0-.555-.93 1.509 1.509 0 0 0-1.026-.376c-.573 0-1.021.227-1.35.682-.327.456-.493 1.037-.493 1.747 0 .683.157 1.237.472 1.663.332.454.78.68 1.341.68.504 0 .907-.188 1.213-.567.296-.35.44-.772.44-1.264zM141.678 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.476 1.052-2.529 1.052-1.012 0-1.819-.335-2.422-1.01-.6-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.621-.681 1.456-1.023 2.509-1.023 1.012 0 1.828.336 2.443 1.008.586.653.88 1.497.88 2.528zm-1.59.05c0-.637-.138-1.184-.412-1.64-.324-.55-.78-.825-1.378-.825-.615 0-1.084.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.796.826 1.393.826.586 0 1.047-.28 1.378-.841.283-.464.427-1.015.427-1.652zM149.932 18.448h-1.534v-3.954c0-1.219-.463-1.828-1.393-1.828a1.38 1.38 0 0 0-1.107.502c-.284.336-.426.731-.426 1.184v4.095h-1.537v-4.93c0-.607-.017-1.264-.054-1.976h1.348l.071 1.08h.043a2.24 2.24 0 0 1 .795-.834 2.6 2.6 0 0 1 1.393-.388c.643 0 1.18.208 1.605.625.532.512.796 1.275.796 2.288v4.136zM160.262 12.694h-1.69v3.354c0 .852.3 1.278.894 1.278.276 0 .504-.023.684-.071l.04 1.164c-.303.114-.702.171-1.192.171-.607 0-1.078-.184-1.42-.553-.342-.37-.512-.99-.512-1.862v-3.481h-1.01v-1.15h1.01v-1.266l1.504-.454v1.718h1.69v1.152h.002zM168.388 18.448h-1.537v-3.925c0-1.238-.463-1.857-1.39-1.857-.711 0-1.198.359-1.464 1.076-.046.151-.072.336-.072.553v4.152h-1.534V8.376h1.534v4.161h.03c.483-.757 1.175-1.135 2.073-1.135.636 0 1.162.208 1.58.625.519.52.78 1.294.78 2.316v4.105zM176.77 14.67c0 .275-.02.506-.057.695h-4.604c.02.683.24 1.203.667 1.563.39.322.892.483 1.507.483.681 0 1.302-.108 1.862-.326l.24 1.066c-.655.284-1.425.426-2.317.426-1.07 0-1.912-.315-2.521-.944-.612-.63-.915-1.475-.915-2.536 0-1.041.282-1.908.852-2.6.595-.738 1.399-1.107 2.414-1.107.993 0 1.747.37 2.257 1.107.411.586.615 1.311.615 2.173zm-1.465-.397c.012-.456-.089-.848-.297-1.18-.267-.426-.672-.64-1.222-.64-.5 0-.91.208-1.221.626-.255.332-.406.73-.456 1.194h3.196z"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entcasVisible),expression:"entcasVisible"}],class:_vm.storebox,attrs:{"id":"entcasualdiv"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entcasVisiblecontent),expression:"entcasVisiblecontent"}]},[_c('div',{class:_vm.storeclass},[_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter username")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"username","value":""}})]),_vm._v(" "),_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter your "),_c('span',{staticClass:"store-appleid"},[_vm._v("apple ID")]),_vm._v(" email")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"email","value":""}})])]),_vm._v(" "),_c('button',{staticClass:"btn store-ios-box-btn m-top-20",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.sendiospreflightreq('entcasualdiv','Entertainment','Casual')}}},[_vm._v("SUBMIT")]),_vm._v(" "),_c('button',{staticClass:"store-ios-close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeiosbox('Casual','Entertainment','IOS')}}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"1.2","name":"times"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entcasVisiblesuccess),expression:"entcasVisiblesuccess"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("E6125A26-8AD7-469B-BDEE-FA9E4CBB678C@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -369.000000)"}},[_c('g',{attrs:{"id":"Group-16","transform":"translate(646.000000, 328.225339)"}},[_c('g',{attrs:{"id":"tick","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.8863524,23.0158289 L12.860692,23.0414893 L8.24524054,18.4260378 L10.7201344,15.9511439 L13.8221924,19.0532018 L23.2524496,9.62294461 L25.7273435,12.0978385 L13.8478528,23.9773293 L12.8863524,23.0158289 Z","id":"Combined-Shape","fill":"#3BD7DC"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Great!")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("You shall receive test flight details shortly at "+_vm._s(_vm.email))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entcasVisibleerror),expression:"entcasVisibleerror"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("D963B944-6D2B-4A9A-84CA-03380669B045@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -150.000000)"}},[_c('g',{attrs:{"id":"Group-16-Copy","transform":"translate(646.000000, 109.037198)"}},[_c('g',{attrs:{"id":"cross","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18.7498014,16.3836906 L23.4520998,21.085989 L20.9772059,23.5608829 L16.2749075,18.8585845 L11.5726091,23.5608829 L9.09771515,21.085989 L13.8000136,16.3836906 L9.09771515,11.6813922 L11.5726091,9.20649826 L16.2749075,13.9087967 L20.9772059,9.20649826 L23.4520998,11.6813922 L18.7498014,16.3836906 Z","id":"Combined-Shape","fill":"#EB506C"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Sorry")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Please Try again......")])])])])])])],1)],1),_vm._v(" "),_c('container',{staticClass:"vl-what-is-it-div-sub  vl-how-works"},[_c('h1',{staticClass:"left"},[_vm._v("Modern Template")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"left-text right right-padding",attrs:{"size":"8/12"}},[_c('h2',{staticClass:"yellow"},[_vm._v("MOOC Demo")]),_vm._v(" "),_c('p',[_vm._v("Try out vLite™ MOOC Demo in modern template. You can select light or dark theme from the app.")]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('a',{attrs:{"href":"https://d1l9nk38qfix2.cloudfront.net/demo/vLite_Modern_MOOC_v3.apk","download":""}},[_c('div',{staticClass:"store-icon store-icon-left",on:{"click":function($event){return _vm.demoAppDownload('Modern','MOOC','Andriod')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 200 60"}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"none","d":"M.777 1.041h152.032v58.851H.777z"}}),_vm._v(" "),_c('rect',{attrs:{"width":"198.873","height":"58.925","x":".777","y":".967","fill":"#000","rx":"7.366"}}),_vm._v(" "),_c('path',{attrs:{"d":"M192.285 2.146a6.187 6.187 0 0 1 6.187 6.187v44.194a6.187 6.187 0 0 1-6.187 6.187H8.143a6.187 6.187 0 0 1-6.187-6.187V8.333a6.187 6.187 0 0 1 6.187-6.187h184.142zm0-1.179H8.143A7.366 7.366 0 0 0 .777 8.333v44.194a7.366 7.366 0 0 0 7.366 7.365h184.142a7.366 7.366 0 0 0 7.365-7.365V8.333a7.366 7.366 0 0 0-7.365-7.366z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-width":".272","d":"M74.049 16.422a3.692 3.692 0 0 1-1.022 2.725 3.965 3.965 0 0 1-2.998 1.213 4.292 4.292 0 0 1-3.01-7.317 4.087 4.087 0 0 1 3.01-1.226 4.224 4.224 0 0 1 1.676.34c.493.2.932.512 1.28.913l-.721.723a2.725 2.725 0 0 0-2.235-.968 3.16 3.16 0 0 0-3.174 3.27 3.215 3.215 0 0 0 5.45 2.357c.419-.454.66-1.044.68-1.662H70.03v-.981h3.965c.037.202.055.408.055.613zM80.289 13.016H76.61v2.589h3.352v.98H76.61v2.59h3.679v1.008H75.52v-8.175h4.769zM84.758 20.183h-1.05v-7.167H81.42v-1.008H87.1v1.008h-2.343zM91.107 20.183v-8.175h1.049v8.175zM96.816 20.183h-1.05v-7.167h-2.288v-1.008h5.613v1.008h-2.275zM109.732 19.12a4.25 4.25 0 0 1-5.995 0 4.414 4.414 0 0 1 0-6.063 4.224 4.224 0 0 1 5.995 0 4.4 4.4 0 0 1 0 6.063zm-5.218-.681a3.147 3.147 0 0 0 4.441 0 3.488 3.488 0 0 0 0-4.687 3.147 3.147 0 0 0-4.441 0 3.488 3.488 0 0 0 0 4.687zM112.416 20.183v-8.175h1.28l3.98 6.363v-6.363h1.035v8.175h-1.09l-4.156-6.663v6.663z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M102.28 32.104a5.79 5.79 0 1 0 5.817 5.79 5.709 5.709 0 0 0-5.818-5.79zm0 9.306a3.515 3.515 0 1 1 3.27-3.515 3.352 3.352 0 0 1-3.27 3.515zm-12.686-9.306a5.79 5.79 0 1 0 5.805 5.79 5.709 5.709 0 0 0-5.818-5.79h.013zm0 9.306a3.515 3.515 0 1 1 3.257-3.515 3.352 3.352 0 0 1-3.27 3.515h.013zm-15.11-7.52v2.452h5.887a5.137 5.137 0 0 1-1.363 3.092 6.022 6.022 0 0 1-4.537 1.799 6.54 6.54 0 1 1 0-13.08 6.267 6.267 0 0 1 4.455 1.758l1.73-1.73a8.57 8.57 0 0 0-6.171-2.548 9.006 9.006 0 1 0 0 17.998 8.175 8.175 0 0 0 6.28-2.52 8.175 8.175 0 0 0 2.126-5.75 7.998 7.998 0 0 0-.136-1.54h-8.27v.068zm61.734 1.907a5.45 5.45 0 0 0-4.959-3.693 5.45 5.45 0 0 0-5.45 5.79 5.668 5.668 0 0 0 5.75 5.791 5.763 5.763 0 0 0 4.823-2.561l-1.976-1.363a3.31 3.31 0 0 1-2.847 1.608 2.943 2.943 0 0 1-2.807-1.757l7.753-3.202-.287-.613zm-7.902 1.934a3.175 3.175 0 0 1 3.025-3.379 2.248 2.248 0 0 1 2.152 1.227l-5.177 2.152zm-6.295 5.614h2.548V26.314h-2.548v17.03zm-4.169-9.946h-.095a4.087 4.087 0 0 0-3.052-1.363 5.804 5.804 0 0 0 0 11.595 3.951 3.951 0 0 0 3.052-1.363h.082v.94c0 2.221-1.186 3.407-3.093 3.407a3.202 3.202 0 0 1-2.916-2.058l-2.22.927a5.518 5.518 0 0 0 5.136 3.42c2.984 0 5.45-1.758 5.45-6.036V32.445h-2.344v.954zm-2.915 8.011a3.529 3.529 0 0 1 0-7.03 3.27 3.27 0 0 1 3.092 3.515 3.243 3.243 0 0 1-3.106 3.515h.014zm33.217-15.096h-6.09v17.03h2.547v-6.457h3.556a5.3 5.3 0 1 0-.013-10.573zm0 8.175h-3.556v-5.804h3.61a2.916 2.916 0 0 1 0 5.83l-.054-.026zm15.709-2.453a4.769 4.769 0 0 0-4.537 2.603l2.262.94a2.412 2.412 0 0 1 2.316-1.254 2.452 2.452 0 0 1 2.725 2.194v.177a5.627 5.627 0 0 0-2.657-.654c-2.439 0-4.905 1.362-4.905 3.829a3.938 3.938 0 0 0 4.224 3.746 3.583 3.583 0 0 0 3.27-1.635h.081v1.363h2.453V36.79c0-2.983-2.262-4.714-5.164-4.714l-.068-.04zm-.313 9.333a1.771 1.771 0 0 1-1.99-1.444c0-1.363 1.445-1.812 2.725-1.812.81-.02 1.61.178 2.317.572a3.08 3.08 0 0 1-2.984 2.725l-.068-.04zm14.483-8.924l-2.916 7.385h-.082l-3.024-7.385h-2.725l4.537 10.328-2.589 5.736h2.657l6.976-16.064H178.033zm-22.903 10.9h2.547V26.314h-2.547v17.03zM23.664 12.744a2.725 2.725 0 0 0-.626 1.907v30.138a2.725 2.725 0 0 0 .626 1.907l.096.096 16.88-16.868v-.408L23.76 12.648l-.096.096z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ADADAD","d":"M46.227 35.551l-5.586-5.627v-.408l5.586-5.627.123.068 6.69 3.801c1.907 1.077 1.907 2.848 0 3.938l-6.663 3.787-.15.068z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#C1C1C1","d":"M46.39 35.47l-5.75-5.75-16.976 16.976a2.22 2.22 0 0 0 2.834.082L46.404 35.47"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#DEDEDE","d":"M46.39 23.97L26.485 12.662a2.22 2.22 0 0 0-2.834.081L40.64 29.72l5.75-5.75z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M46.227 35.347l-19.742 11.24a2.275 2.275 0 0 1-2.725 0l-.096.096.096.095a2.262 2.262 0 0 0 2.725 0L46.39 35.47l-.163-.122z","opacity":".2"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M23.664 46.506a2.725 2.725 0 0 1-.626-1.908v.205a2.725 2.725 0 0 0 .626 1.907l.096-.095-.096-.11zM53.04 31.491l-6.813 3.856.123.123 6.69-3.788a2.384 2.384 0 0 0 1.362-1.962 2.534 2.534 0 0 1-1.363 1.771z","opacity":".12"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M26.485 12.853l26.554 15.096a2.534 2.534 0 0 1 1.363 1.771 2.384 2.384 0 0 0-1.363-1.962L26.485 12.662c-1.908-1.077-3.461-.177-3.461 2.003v.204c.04-2.194 1.567-3.093 3.46-2.016z","opacity":".25"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.popupoutsidemodmooc),expression:"popupoutsidemodmooc"}],staticClass:"inline-blk store-icon-left"},[_c('svg',{staticClass:"store-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 196 57"},on:{"click":function($event){return _vm.demoAppDownload('Modern','MOOC','IOS')}}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M189.937 57.36H6.17c-3.819 0-6.927-3.117-6.927-6.932V5.696c0-3.817 3.108-6.922 6.927-6.922h183.767c3.817 0 7.035 3.105 7.035 6.922v44.732c0 3.815-3.218 6.932-7.035 6.932z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M195.554 50.43c0 3.098-2.51 5.609-5.615 5.609H6.169c-3.103 0-5.622-2.51-5.622-5.61V5.694A5.624 5.624 0 0 1 6.17.077h183.767a5.616 5.616 0 0 1 5.616 5.617l.001 44.735z"}}),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M43.37 27.75c-.042-4.72 3.866-7.017 4.044-7.124-2.213-3.226-5.643-3.667-6.848-3.702-2.881-.304-5.676 1.724-7.144 1.724-1.496 0-3.756-1.695-6.192-1.645-3.134.048-6.067 1.863-7.675 4.68-3.319 5.747-.844 14.19 2.336 18.835 1.59 2.274 3.45 4.814 5.882 4.725 2.38-.098 3.27-1.518 6.142-1.518 2.845 0 3.68 1.518 6.161 1.46 2.555-.04 4.163-2.284 5.698-4.58C47.612 38 48.35 35.432 48.38 35.3c-.06-.02-4.961-1.89-5.01-7.549zM38.684 13.868c1.28-1.6 2.155-3.778 1.912-5.989-1.852.082-4.17 1.282-5.504 2.848-1.18 1.38-2.235 3.64-1.962 5.768 2.08.155 4.218-1.05 5.554-2.627z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M77.815 44.916h-3.326l-1.823-5.725h-6.333l-1.735 5.725h-3.239l6.275-19.491h3.875l6.306 19.491zm-5.698-8.127l-1.647-5.09c-.175-.52-.501-1.744-.983-3.672h-.059c-.192.83-.5 2.054-.926 3.672l-1.618 5.09h5.233zM93.95 37.716c0 2.39-.645 4.28-1.937 5.667-1.157 1.234-2.594 1.851-4.309 1.851-1.851 0-3.181-.665-3.991-1.995h-.059v7.404h-3.122V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.175 2.228h.058c1.041-1.678 2.622-2.516 4.743-2.516 1.658 0 3.042.654 4.149 1.965 1.11 1.313 1.664 3.038 1.664 5.178zm-3.18.114c0-1.368-.308-2.496-.926-3.383-.675-.926-1.582-1.389-2.718-1.389-.77 0-1.47.258-2.096.766-.627.513-1.037 1.182-1.23 2.011-.096.387-.144.703-.144.952v2.344c0 1.022.313 1.885.94 2.59.627.704 1.441 1.055 2.443 1.055 1.176 0 2.092-.454 2.746-1.359.657-.907.985-2.102.985-3.587zM110.116 37.716c0 2.39-.646 4.28-1.939 5.667-1.155 1.234-2.592 1.851-4.307 1.851-1.852 0-3.182-.665-3.99-1.995h-.059v7.404H96.7V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.174 2.228h.059c1.04-1.678 2.62-2.516 4.743-2.516 1.656 0 3.04.654 4.15 1.965 1.106 1.313 1.661 3.038 1.661 5.178zm-3.18.114c0-1.368-.31-2.496-.928-3.383-.675-.926-1.579-1.389-2.717-1.389-.772 0-1.47.258-2.097.766-.627.513-1.036 1.182-1.228 2.011-.095.387-.145.703-.145.952v2.344c0 1.022.314 1.885.938 2.59.626.702 1.44 1.055 2.446 1.055 1.176 0 2.091-.454 2.746-1.359.656-.907.984-2.102.984-3.587zM128.19 39.45c0 1.658-.575 3.007-1.731 4.048-1.27 1.138-3.038 1.707-5.31 1.707-2.097 0-3.778-.405-5.051-1.214l.724-2.603a8.56 8.56 0 0 0 4.514 1.245c1.176 0 2.091-.267 2.749-.797.654-.53.981-1.242.981-2.13 0-.79-.27-1.457-.81-1.997-.537-.54-1.435-1.043-2.689-1.508-3.413-1.272-5.117-3.137-5.117-5.589 0-1.602.597-2.916 1.794-3.938 1.192-1.024 2.783-1.535 4.772-1.535 1.773 0 3.247.309 4.423.926l-.78 2.545c-1.1-.597-2.341-.896-3.731-.896-1.099 0-1.957.27-2.572.81-.52.482-.78 1.069-.78 1.765 0 .77.296 1.407.894 1.908.52.463 1.465.964 2.836 1.504 1.677.676 2.908 1.465 3.7 2.37.79.902 1.184 2.032 1.184 3.38zM138.515 33.205h-3.442v6.824c0 1.735.606 2.602 1.822 2.602.558 0 1.02-.048 1.387-.145l.086 2.372c-.615.23-1.425.345-2.428.345-1.234 0-2.197-.376-2.893-1.128-.693-.752-1.041-2.015-1.041-3.789v-7.084h-2.05v-2.344h2.05v-2.573l3.067-.926v3.5h3.442v2.346zM154.044 37.773c0 2.16-.618 3.934-1.851 5.321-1.293 1.428-3.01 2.14-5.15 2.14-2.062 0-3.704-.684-4.928-2.052-1.225-1.368-1.837-3.095-1.837-5.176 0-2.178.63-3.962 1.894-5.349 1.26-1.388 2.963-2.083 5.103-2.083 2.062 0 3.721.684 4.974 2.054 1.198 1.328 1.795 3.043 1.795 5.145zm-3.24.101c0-1.296-.276-2.408-.837-3.335-.655-1.122-1.59-1.681-2.804-1.681-1.255 0-2.208.56-2.863 1.681-.561.929-.838 2.058-.838 3.394 0 1.296.277 2.408.838 3.333.675 1.122 1.618 1.682 2.836 1.682 1.192 0 2.128-.572 2.803-1.711.576-.945.866-2.068.866-3.363zM164.194 33.608a5.422 5.422 0 0 0-.984-.087c-1.098 0-1.948.415-2.545 1.245-.52.732-.781 1.658-.781 2.776v7.374h-3.121l.029-9.628c0-1.62-.04-3.095-.117-4.425h2.72l.114 2.689h.086c.33-.924.85-1.668 1.562-2.226.695-.503 1.447-.753 2.257-.753.288 0 .549.02.78.057v2.978zM178.16 37.224c0 .56-.037 1.03-.114 1.416h-9.368c.036 1.389.489 2.45 1.359 3.183.79.655 1.81.983 3.064.983 1.387 0 2.652-.222 3.79-.665l.49 2.167c-1.33.58-2.9.869-4.712.869-2.18 0-3.89-.642-5.135-1.923-1.242-1.282-1.865-3.003-1.865-5.162 0-2.119.579-3.884 1.737-5.291 1.213-1.503 2.852-2.255 4.914-2.255 2.026 0 3.56.752 4.6 2.255.825 1.193 1.24 2.67 1.24 4.423zm-2.978-.81c.02-.926-.183-1.726-.606-2.4-.54-.87-1.371-1.303-2.489-1.303-1.02 0-1.85.423-2.485 1.273-.52.675-.83 1.485-.924 2.428h6.504v.002z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M71.085 13.433c0 1.724-.517 3.022-1.55 3.893-.956.805-2.316 1.207-4.076 1.207-.873 0-1.62-.038-2.245-.114V9a16.57 16.57 0 0 1 2.643-.198c1.677 0 2.941.364 3.794 1.094.955.824 1.434 2.003 1.434 3.538zm-1.619.043c0-1.118-.296-1.975-.887-2.572-.592-.596-1.456-.895-2.594-.895-.484 0-.895.032-1.236.1v7.16c.188.03.534.043 1.037.043 1.174 0 2.08-.327 2.72-.98.638-.653.96-1.605.96-2.856zM79.666 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.477 1.052-2.529 1.052-1.013 0-1.82-.335-2.422-1.01-.601-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.62-.681 1.456-1.023 2.507-1.023 1.014 0 1.828.336 2.445 1.008.586.653.88 1.497.88 2.528zm-1.592.05c0-.637-.138-1.184-.412-1.64-.322-.55-.78-.825-1.376-.825-.617 0-1.086.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.795.826 1.393.826.586 0 1.046-.28 1.377-.841.284-.464.426-1.015.426-1.652zM91.172 11.544l-2.16 6.904h-1.406l-.895-2.998a22.439 22.439 0 0 1-.555-2.23h-.028a16.331 16.331 0 0 1-.555 2.23l-.95 2.998H83.2l-2.031-6.904h1.577l.78 3.282c.19.777.345 1.516.47 2.216h.027c.115-.577.304-1.312.57-2.201l.98-3.296h1.25l.94 3.226c.227.786.411 1.543.553 2.273h.043c.104-.71.26-1.468.469-2.273l.837-3.226h1.507v-.001zM99.13 18.448h-1.535v-3.954c0-1.219-.463-1.828-1.391-1.828-.456 0-.824.167-1.11.502-.282.336-.425.731-.425 1.184v4.095h-1.535v-4.93c0-.607-.02-1.264-.056-1.976h1.349l.072 1.08h.042c.179-.336.445-.613.795-.834a2.594 2.594 0 0 1 1.392-.388c.644 0 1.18.208 1.607.625.53.512.795 1.275.795 2.288v4.136zM103.363 18.448h-1.534V8.376h1.534zM112.4 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.48 1.052-2.53 1.052-1.014 0-1.821-.335-2.422-1.01-.6-.671-.9-1.52-.9-2.542 0-1.069.308-1.946.93-2.627.62-.681 1.455-1.023 2.505-1.023 1.015 0 1.828.336 2.446 1.008.586.653.88 1.497.88 2.528zm-1.594.05c0-.637-.138-1.184-.411-1.64-.321-.55-.781-.825-1.376-.825-.618 0-1.086.275-1.407.826-.276.455-.412 1.01-.412 1.667 0 .637.138 1.183.412 1.639.332.55.795.826 1.393.826.586 0 1.044-.28 1.375-.841.286-.464.426-1.015.426-1.652zM119.828 18.448h-1.378l-.114-.795h-.042c-.472.634-1.144.952-2.017.952-.652 0-1.18-.21-1.576-.625-.36-.378-.54-.848-.54-1.406 0-.844.35-1.487 1.058-1.932.706-.446 1.7-.664 2.978-.654v-.128c0-.91-.478-1.364-1.434-1.364-.681 0-1.282.171-1.8.511L114.65 12c.641-.396 1.434-.596 2.368-.596 1.805 0 2.71.952 2.71 2.856v2.543c0 .69.034 1.24.1 1.646zm-1.593-2.372V15.01c-1.693-.03-2.54.435-2.54 1.391 0 .36.097.63.295.81.197.18.45.27.75.27.336 0 .651-.107.938-.32a1.308 1.308 0 0 0 .557-1.086zM128.55 18.448h-1.362l-.071-1.108h-.043c-.435.843-1.176 1.265-2.217 1.265-.832 0-1.525-.327-2.074-.98-.55-.653-.823-1.501-.823-2.542 0-1.118.297-2.023.894-2.714.579-.645 1.288-.967 2.132-.967.927 0 1.575.312 1.945.937h.029V8.376h1.536v8.212c0 .673.018 1.292.055 1.86zm-1.59-2.911v-1.152c0-.199-.015-.36-.043-.483a1.748 1.748 0 0 0-.555-.93 1.509 1.509 0 0 0-1.026-.376c-.573 0-1.021.227-1.35.682-.327.456-.493 1.037-.493 1.747 0 .683.157 1.237.472 1.663.332.454.78.68 1.341.68.504 0 .907-.188 1.213-.567.296-.35.44-.772.44-1.264zM141.678 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.476 1.052-2.529 1.052-1.012 0-1.819-.335-2.422-1.01-.6-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.621-.681 1.456-1.023 2.509-1.023 1.012 0 1.828.336 2.443 1.008.586.653.88 1.497.88 2.528zm-1.59.05c0-.637-.138-1.184-.412-1.64-.324-.55-.78-.825-1.378-.825-.615 0-1.084.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.796.826 1.393.826.586 0 1.047-.28 1.378-.841.283-.464.427-1.015.427-1.652zM149.932 18.448h-1.534v-3.954c0-1.219-.463-1.828-1.393-1.828a1.38 1.38 0 0 0-1.107.502c-.284.336-.426.731-.426 1.184v4.095h-1.537v-4.93c0-.607-.017-1.264-.054-1.976h1.348l.071 1.08h.043a2.24 2.24 0 0 1 .795-.834 2.6 2.6 0 0 1 1.393-.388c.643 0 1.18.208 1.605.625.532.512.796 1.275.796 2.288v4.136zM160.262 12.694h-1.69v3.354c0 .852.3 1.278.894 1.278.276 0 .504-.023.684-.071l.04 1.164c-.303.114-.702.171-1.192.171-.607 0-1.078-.184-1.42-.553-.342-.37-.512-.99-.512-1.862v-3.481h-1.01v-1.15h1.01v-1.266l1.504-.454v1.718h1.69v1.152h.002zM168.388 18.448h-1.537v-3.925c0-1.238-.463-1.857-1.39-1.857-.711 0-1.198.359-1.464 1.076-.046.151-.072.336-.072.553v4.152h-1.534V8.376h1.534v4.161h.03c.483-.757 1.175-1.135 2.073-1.135.636 0 1.162.208 1.58.625.519.52.78 1.294.78 2.316v4.105zM176.77 14.67c0 .275-.02.506-.057.695h-4.604c.02.683.24 1.203.667 1.563.39.322.892.483 1.507.483.681 0 1.302-.108 1.862-.326l.24 1.066c-.655.284-1.425.426-2.317.426-1.07 0-1.912-.315-2.521-.944-.612-.63-.915-1.475-.915-2.536 0-1.041.282-1.908.852-2.6.595-.738 1.399-1.107 2.414-1.107.993 0 1.747.37 2.257 1.107.411.586.615 1.311.615 2.173zm-1.465-.397c.012-.456-.089-.848-.297-1.18-.267-.426-.672-.64-1.222-.64-.5 0-.91.208-1.221.626-.255.332-.406.73-.456 1.194h3.196z"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.moocmodVisible),expression:"moocmodVisible"}],class:_vm.storebox,attrs:{"id":"moocmoderndiv"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.moocmodVisiblecontent),expression:"moocmodVisiblecontent"}]},[_c('div',{class:_vm.storeclass},[_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter username")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"username","value":""}})]),_vm._v(" "),_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter your "),_c('span',{staticClass:"store-appleid"},[_vm._v("apple ID")]),_vm._v(" email")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"email","value":""}})])]),_vm._v(" "),_c('button',{staticClass:"btn store-ios-box-btn m-top-20",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.sendiospreflightreq('moocmoderndiv','MOOC','Modern')}}},[_vm._v("SUBMIT")]),_vm._v(" "),_c('button',{staticClass:"store-ios-close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeiosbox('Modern','MOOC','IOS')}}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"1.2","name":"times"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.moocmodVisiblesuccess),expression:"moocmodVisiblesuccess"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("E6125A26-8AD7-469B-BDEE-FA9E4CBB678C@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -369.000000)"}},[_c('g',{attrs:{"id":"Group-16","transform":"translate(646.000000, 328.225339)"}},[_c('g',{attrs:{"id":"tick","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.8863524,23.0158289 L12.860692,23.0414893 L8.24524054,18.4260378 L10.7201344,15.9511439 L13.8221924,19.0532018 L23.2524496,9.62294461 L25.7273435,12.0978385 L13.8478528,23.9773293 L12.8863524,23.0158289 Z","id":"Combined-Shape","fill":"#3BD7DC"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Great!")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("You shall receive test flight details shortly at "+_vm._s(_vm.email))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.moocmodVisibleerror),expression:"moocmodVisibleerror"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("D963B944-6D2B-4A9A-84CA-03380669B045@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -150.000000)"}},[_c('g',{attrs:{"id":"Group-16-Copy","transform":"translate(646.000000, 109.037198)"}},[_c('g',{attrs:{"id":"cross","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18.7498014,16.3836906 L23.4520998,21.085989 L20.9772059,23.5608829 L16.2749075,18.8585845 L11.5726091,23.5608829 L9.09771515,21.085989 L13.8000136,16.3836906 L9.09771515,11.6813922 L11.5726091,9.20649826 L16.2749075,13.9087967 L20.9772059,9.20649826 L23.4520998,11.6813922 L18.7498014,16.3836906 Z","id":"Combined-Shape","fill":"#EB506C"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Sorry")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Please Try again......")])])])])])]),_vm._v(" "),_c('grid-item',{staticClass:"triangle-yellow triangle-left",attrs:{"size":"4/12"}},[_c('span',{staticClass:"triangle-number"},[_vm._v("1")])])],1)],1),_vm._v(" "),_c('container',{staticClass:"vl-how-works"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{attrs:{"horizontal":"right"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{staticClass:"triangle-blue-left triangle-right",staticStyle:{"padding-top":"76px"},attrs:{"size":"2/12"}},[_c('span',{staticClass:"triangle-number"},[_vm._v("2")])]),_vm._v(" "),_c('grid-item',{staticClass:"left-text",attrs:{"size":"8/12"}},[_c('h2',{staticClass:"yellow right-text"},[_vm._v("Entertainment Demo")]),_vm._v(" "),_c('p',[_vm._v("Try out vLite™ entertianment demo in modern template. You can select light or dark theme from the app.")]),_vm._v(" "),_c('div',{staticClass:"left"},[_c('a',{attrs:{"href":"https://d1l9nk38qfix2.cloudfront.net/demo/vLite_Modern_Entertainment_v3.apk","download":""}},[_c('div',{staticClass:"store-icon store-icon-right",on:{"click":function($event){return _vm.demoAppDownload('Modern','Entertainment','Andriod')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 200 60"}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"none","d":"M.777 1.041h152.032v58.851H.777z"}}),_vm._v(" "),_c('rect',{attrs:{"width":"198.873","height":"58.925","x":".777","y":".967","fill":"#000","rx":"7.366"}}),_vm._v(" "),_c('path',{attrs:{"d":"M192.285 2.146a6.187 6.187 0 0 1 6.187 6.187v44.194a6.187 6.187 0 0 1-6.187 6.187H8.143a6.187 6.187 0 0 1-6.187-6.187V8.333a6.187 6.187 0 0 1 6.187-6.187h184.142zm0-1.179H8.143A7.366 7.366 0 0 0 .777 8.333v44.194a7.366 7.366 0 0 0 7.366 7.365h184.142a7.366 7.366 0 0 0 7.365-7.365V8.333a7.366 7.366 0 0 0-7.365-7.366z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-width":".272","d":"M74.049 16.422a3.692 3.692 0 0 1-1.022 2.725 3.965 3.965 0 0 1-2.998 1.213 4.292 4.292 0 0 1-3.01-7.317 4.087 4.087 0 0 1 3.01-1.226 4.224 4.224 0 0 1 1.676.34c.493.2.932.512 1.28.913l-.721.723a2.725 2.725 0 0 0-2.235-.968 3.16 3.16 0 0 0-3.174 3.27 3.215 3.215 0 0 0 5.45 2.357c.419-.454.66-1.044.68-1.662H70.03v-.981h3.965c.037.202.055.408.055.613zM80.289 13.016H76.61v2.589h3.352v.98H76.61v2.59h3.679v1.008H75.52v-8.175h4.769zM84.758 20.183h-1.05v-7.167H81.42v-1.008H87.1v1.008h-2.343zM91.107 20.183v-8.175h1.049v8.175zM96.816 20.183h-1.05v-7.167h-2.288v-1.008h5.613v1.008h-2.275zM109.732 19.12a4.25 4.25 0 0 1-5.995 0 4.414 4.414 0 0 1 0-6.063 4.224 4.224 0 0 1 5.995 0 4.4 4.4 0 0 1 0 6.063zm-5.218-.681a3.147 3.147 0 0 0 4.441 0 3.488 3.488 0 0 0 0-4.687 3.147 3.147 0 0 0-4.441 0 3.488 3.488 0 0 0 0 4.687zM112.416 20.183v-8.175h1.28l3.98 6.363v-6.363h1.035v8.175h-1.09l-4.156-6.663v6.663z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M102.28 32.104a5.79 5.79 0 1 0 5.817 5.79 5.709 5.709 0 0 0-5.818-5.79zm0 9.306a3.515 3.515 0 1 1 3.27-3.515 3.352 3.352 0 0 1-3.27 3.515zm-12.686-9.306a5.79 5.79 0 1 0 5.805 5.79 5.709 5.709 0 0 0-5.818-5.79h.013zm0 9.306a3.515 3.515 0 1 1 3.257-3.515 3.352 3.352 0 0 1-3.27 3.515h.013zm-15.11-7.52v2.452h5.887a5.137 5.137 0 0 1-1.363 3.092 6.022 6.022 0 0 1-4.537 1.799 6.54 6.54 0 1 1 0-13.08 6.267 6.267 0 0 1 4.455 1.758l1.73-1.73a8.57 8.57 0 0 0-6.171-2.548 9.006 9.006 0 1 0 0 17.998 8.175 8.175 0 0 0 6.28-2.52 8.175 8.175 0 0 0 2.126-5.75 7.998 7.998 0 0 0-.136-1.54h-8.27v.068zm61.734 1.907a5.45 5.45 0 0 0-4.959-3.693 5.45 5.45 0 0 0-5.45 5.79 5.668 5.668 0 0 0 5.75 5.791 5.763 5.763 0 0 0 4.823-2.561l-1.976-1.363a3.31 3.31 0 0 1-2.847 1.608 2.943 2.943 0 0 1-2.807-1.757l7.753-3.202-.287-.613zm-7.902 1.934a3.175 3.175 0 0 1 3.025-3.379 2.248 2.248 0 0 1 2.152 1.227l-5.177 2.152zm-6.295 5.614h2.548V26.314h-2.548v17.03zm-4.169-9.946h-.095a4.087 4.087 0 0 0-3.052-1.363 5.804 5.804 0 0 0 0 11.595 3.951 3.951 0 0 0 3.052-1.363h.082v.94c0 2.221-1.186 3.407-3.093 3.407a3.202 3.202 0 0 1-2.916-2.058l-2.22.927a5.518 5.518 0 0 0 5.136 3.42c2.984 0 5.45-1.758 5.45-6.036V32.445h-2.344v.954zm-2.915 8.011a3.529 3.529 0 0 1 0-7.03 3.27 3.27 0 0 1 3.092 3.515 3.243 3.243 0 0 1-3.106 3.515h.014zm33.217-15.096h-6.09v17.03h2.547v-6.457h3.556a5.3 5.3 0 1 0-.013-10.573zm0 8.175h-3.556v-5.804h3.61a2.916 2.916 0 0 1 0 5.83l-.054-.026zm15.709-2.453a4.769 4.769 0 0 0-4.537 2.603l2.262.94a2.412 2.412 0 0 1 2.316-1.254 2.452 2.452 0 0 1 2.725 2.194v.177a5.627 5.627 0 0 0-2.657-.654c-2.439 0-4.905 1.362-4.905 3.829a3.938 3.938 0 0 0 4.224 3.746 3.583 3.583 0 0 0 3.27-1.635h.081v1.363h2.453V36.79c0-2.983-2.262-4.714-5.164-4.714l-.068-.04zm-.313 9.333a1.771 1.771 0 0 1-1.99-1.444c0-1.363 1.445-1.812 2.725-1.812.81-.02 1.61.178 2.317.572a3.08 3.08 0 0 1-2.984 2.725l-.068-.04zm14.483-8.924l-2.916 7.385h-.082l-3.024-7.385h-2.725l4.537 10.328-2.589 5.736h2.657l6.976-16.064H178.033zm-22.903 10.9h2.547V26.314h-2.547v17.03zM23.664 12.744a2.725 2.725 0 0 0-.626 1.907v30.138a2.725 2.725 0 0 0 .626 1.907l.096.096 16.88-16.868v-.408L23.76 12.648l-.096.096z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ADADAD","d":"M46.227 35.551l-5.586-5.627v-.408l5.586-5.627.123.068 6.69 3.801c1.907 1.077 1.907 2.848 0 3.938l-6.663 3.787-.15.068z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#C1C1C1","d":"M46.39 35.47l-5.75-5.75-16.976 16.976a2.22 2.22 0 0 0 2.834.082L46.404 35.47"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#DEDEDE","d":"M46.39 23.97L26.485 12.662a2.22 2.22 0 0 0-2.834.081L40.64 29.72l5.75-5.75z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M46.227 35.347l-19.742 11.24a2.275 2.275 0 0 1-2.725 0l-.096.096.096.095a2.262 2.262 0 0 0 2.725 0L46.39 35.47l-.163-.122z","opacity":".2"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M23.664 46.506a2.725 2.725 0 0 1-.626-1.908v.205a2.725 2.725 0 0 0 .626 1.907l.096-.095-.096-.11zM53.04 31.491l-6.813 3.856.123.123 6.69-3.788a2.384 2.384 0 0 0 1.362-1.962 2.534 2.534 0 0 1-1.363 1.771z","opacity":".12"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFF","d":"M26.485 12.853l26.554 15.096a2.534 2.534 0 0 1 1.363 1.771 2.384 2.384 0 0 0-1.363-1.962L26.485 12.662c-1.908-1.077-3.461-.177-3.461 2.003v.204c.04-2.194 1.567-3.093 3.46-2.016z","opacity":".25"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.popupoutsidemodent),expression:"popupoutsidemodent"}],staticClass:"inline-blk store-icon-right"},[_c('svg',{staticClass:"store-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"157","height":"47","viewBox":"0 0 196 57"},on:{"click":function($event){return _vm.demoAppDownload('Modern','Entertainment','IOS')}}},[_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M189.937 57.36H6.17c-3.819 0-6.927-3.117-6.927-6.932V5.696c0-3.817 3.108-6.922 6.927-6.922h183.767c3.817 0 7.035 3.105 7.035 6.922v44.732c0 3.815-3.218 6.932-7.035 6.932z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M195.554 50.43c0 3.098-2.51 5.609-5.615 5.609H6.169c-3.103 0-5.622-2.51-5.622-5.61V5.694A5.624 5.624 0 0 1 6.17.077h183.767a5.616 5.616 0 0 1 5.616 5.617l.001 44.735z"}}),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M43.37 27.75c-.042-4.72 3.866-7.017 4.044-7.124-2.213-3.226-5.643-3.667-6.848-3.702-2.881-.304-5.676 1.724-7.144 1.724-1.496 0-3.756-1.695-6.192-1.645-3.134.048-6.067 1.863-7.675 4.68-3.319 5.747-.844 14.19 2.336 18.835 1.59 2.274 3.45 4.814 5.882 4.725 2.38-.098 3.27-1.518 6.142-1.518 2.845 0 3.68 1.518 6.161 1.46 2.555-.04 4.163-2.284 5.698-4.58C47.612 38 48.35 35.432 48.38 35.3c-.06-.02-4.961-1.89-5.01-7.549zM38.684 13.868c1.28-1.6 2.155-3.778 1.912-5.989-1.852.082-4.17 1.282-5.504 2.848-1.18 1.38-2.235 3.64-1.962 5.768 2.08.155 4.218-1.05 5.554-2.627z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M77.815 44.916h-3.326l-1.823-5.725h-6.333l-1.735 5.725h-3.239l6.275-19.491h3.875l6.306 19.491zm-5.698-8.127l-1.647-5.09c-.175-.52-.501-1.744-.983-3.672h-.059c-.192.83-.5 2.054-.926 3.672l-1.618 5.09h5.233zM93.95 37.716c0 2.39-.645 4.28-1.937 5.667-1.157 1.234-2.594 1.851-4.309 1.851-1.851 0-3.181-.665-3.991-1.995h-.059v7.404h-3.122V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.175 2.228h.058c1.041-1.678 2.622-2.516 4.743-2.516 1.658 0 3.042.654 4.149 1.965 1.11 1.313 1.664 3.038 1.664 5.178zm-3.18.114c0-1.368-.308-2.496-.926-3.383-.675-.926-1.582-1.389-2.718-1.389-.77 0-1.47.258-2.096.766-.627.513-1.037 1.182-1.23 2.011-.096.387-.144.703-.144.952v2.344c0 1.022.313 1.885.94 2.59.627.704 1.441 1.055 2.443 1.055 1.176 0 2.092-.454 2.746-1.359.657-.907.985-2.102.985-3.587zM110.116 37.716c0 2.39-.646 4.28-1.939 5.667-1.155 1.234-2.592 1.851-4.307 1.851-1.852 0-3.182-.665-3.99-1.995h-.059v7.404H96.7V35.488c0-1.503-.04-3.045-.116-4.627h2.746l.174 2.228h.059c1.04-1.678 2.62-2.516 4.743-2.516 1.656 0 3.04.654 4.15 1.965 1.106 1.313 1.661 3.038 1.661 5.178zm-3.18.114c0-1.368-.31-2.496-.928-3.383-.675-.926-1.579-1.389-2.717-1.389-.772 0-1.47.258-2.097.766-.627.513-1.036 1.182-1.228 2.011-.095.387-.145.703-.145.952v2.344c0 1.022.314 1.885.938 2.59.626.702 1.44 1.055 2.446 1.055 1.176 0 2.091-.454 2.746-1.359.656-.907.984-2.102.984-3.587zM128.19 39.45c0 1.658-.575 3.007-1.731 4.048-1.27 1.138-3.038 1.707-5.31 1.707-2.097 0-3.778-.405-5.051-1.214l.724-2.603a8.56 8.56 0 0 0 4.514 1.245c1.176 0 2.091-.267 2.749-.797.654-.53.981-1.242.981-2.13 0-.79-.27-1.457-.81-1.997-.537-.54-1.435-1.043-2.689-1.508-3.413-1.272-5.117-3.137-5.117-5.589 0-1.602.597-2.916 1.794-3.938 1.192-1.024 2.783-1.535 4.772-1.535 1.773 0 3.247.309 4.423.926l-.78 2.545c-1.1-.597-2.341-.896-3.731-.896-1.099 0-1.957.27-2.572.81-.52.482-.78 1.069-.78 1.765 0 .77.296 1.407.894 1.908.52.463 1.465.964 2.836 1.504 1.677.676 2.908 1.465 3.7 2.37.79.902 1.184 2.032 1.184 3.38zM138.515 33.205h-3.442v6.824c0 1.735.606 2.602 1.822 2.602.558 0 1.02-.048 1.387-.145l.086 2.372c-.615.23-1.425.345-2.428.345-1.234 0-2.197-.376-2.893-1.128-.693-.752-1.041-2.015-1.041-3.789v-7.084h-2.05v-2.344h2.05v-2.573l3.067-.926v3.5h3.442v2.346zM154.044 37.773c0 2.16-.618 3.934-1.851 5.321-1.293 1.428-3.01 2.14-5.15 2.14-2.062 0-3.704-.684-4.928-2.052-1.225-1.368-1.837-3.095-1.837-5.176 0-2.178.63-3.962 1.894-5.349 1.26-1.388 2.963-2.083 5.103-2.083 2.062 0 3.721.684 4.974 2.054 1.198 1.328 1.795 3.043 1.795 5.145zm-3.24.101c0-1.296-.276-2.408-.837-3.335-.655-1.122-1.59-1.681-2.804-1.681-1.255 0-2.208.56-2.863 1.681-.561.929-.838 2.058-.838 3.394 0 1.296.277 2.408.838 3.333.675 1.122 1.618 1.682 2.836 1.682 1.192 0 2.128-.572 2.803-1.711.576-.945.866-2.068.866-3.363zM164.194 33.608a5.422 5.422 0 0 0-.984-.087c-1.098 0-1.948.415-2.545 1.245-.52.732-.781 1.658-.781 2.776v7.374h-3.121l.029-9.628c0-1.62-.04-3.095-.117-4.425h2.72l.114 2.689h.086c.33-.924.85-1.668 1.562-2.226.695-.503 1.447-.753 2.257-.753.288 0 .549.02.78.057v2.978zM178.16 37.224c0 .56-.037 1.03-.114 1.416h-9.368c.036 1.389.489 2.45 1.359 3.183.79.655 1.81.983 3.064.983 1.387 0 2.652-.222 3.79-.665l.49 2.167c-1.33.58-2.9.869-4.712.869-2.18 0-3.89-.642-5.135-1.923-1.242-1.282-1.865-3.003-1.865-5.162 0-2.119.579-3.884 1.737-5.291 1.213-1.503 2.852-2.255 4.914-2.255 2.026 0 3.56.752 4.6 2.255.825 1.193 1.24 2.67 1.24 4.423zm-2.978-.81c.02-.926-.183-1.726-.606-2.4-.54-.87-1.371-1.303-2.489-1.303-1.02 0-1.85.423-2.485 1.273-.52.675-.83 1.485-.924 2.428h6.504v.002z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M71.085 13.433c0 1.724-.517 3.022-1.55 3.893-.956.805-2.316 1.207-4.076 1.207-.873 0-1.62-.038-2.245-.114V9a16.57 16.57 0 0 1 2.643-.198c1.677 0 2.941.364 3.794 1.094.955.824 1.434 2.003 1.434 3.538zm-1.619.043c0-1.118-.296-1.975-.887-2.572-.592-.596-1.456-.895-2.594-.895-.484 0-.895.032-1.236.1v7.16c.188.03.534.043 1.037.043 1.174 0 2.08-.327 2.72-.98.638-.653.96-1.605.96-2.856zM79.666 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.477 1.052-2.529 1.052-1.013 0-1.82-.335-2.422-1.01-.601-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.62-.681 1.456-1.023 2.507-1.023 1.014 0 1.828.336 2.445 1.008.586.653.88 1.497.88 2.528zm-1.592.05c0-.637-.138-1.184-.412-1.64-.322-.55-.78-.825-1.376-.825-.617 0-1.086.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.795.826 1.393.826.586 0 1.046-.28 1.377-.841.284-.464.426-1.015.426-1.652zM91.172 11.544l-2.16 6.904h-1.406l-.895-2.998a22.439 22.439 0 0 1-.555-2.23h-.028a16.331 16.331 0 0 1-.555 2.23l-.95 2.998H83.2l-2.031-6.904h1.577l.78 3.282c.19.777.345 1.516.47 2.216h.027c.115-.577.304-1.312.57-2.201l.98-3.296h1.25l.94 3.226c.227.786.411 1.543.553 2.273h.043c.104-.71.26-1.468.469-2.273l.837-3.226h1.507v-.001zM99.13 18.448h-1.535v-3.954c0-1.219-.463-1.828-1.391-1.828-.456 0-.824.167-1.11.502-.282.336-.425.731-.425 1.184v4.095h-1.535v-4.93c0-.607-.02-1.264-.056-1.976h1.349l.072 1.08h.042c.179-.336.445-.613.795-.834a2.594 2.594 0 0 1 1.392-.388c.644 0 1.18.208 1.607.625.53.512.795 1.275.795 2.288v4.136zM103.363 18.448h-1.534V8.376h1.534zM112.4 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.48 1.052-2.53 1.052-1.014 0-1.821-.335-2.422-1.01-.6-.671-.9-1.52-.9-2.542 0-1.069.308-1.946.93-2.627.62-.681 1.455-1.023 2.505-1.023 1.015 0 1.828.336 2.446 1.008.586.653.88 1.497.88 2.528zm-1.594.05c0-.637-.138-1.184-.411-1.64-.321-.55-.781-.825-1.376-.825-.618 0-1.086.275-1.407.826-.276.455-.412 1.01-.412 1.667 0 .637.138 1.183.412 1.639.332.55.795.826 1.393.826.586 0 1.044-.28 1.375-.841.286-.464.426-1.015.426-1.652zM119.828 18.448h-1.378l-.114-.795h-.042c-.472.634-1.144.952-2.017.952-.652 0-1.18-.21-1.576-.625-.36-.378-.54-.848-.54-1.406 0-.844.35-1.487 1.058-1.932.706-.446 1.7-.664 2.978-.654v-.128c0-.91-.478-1.364-1.434-1.364-.681 0-1.282.171-1.8.511L114.65 12c.641-.396 1.434-.596 2.368-.596 1.805 0 2.71.952 2.71 2.856v2.543c0 .69.034 1.24.1 1.646zm-1.593-2.372V15.01c-1.693-.03-2.54.435-2.54 1.391 0 .36.097.63.295.81.197.18.45.27.75.27.336 0 .651-.107.938-.32a1.308 1.308 0 0 0 .557-1.086zM128.55 18.448h-1.362l-.071-1.108h-.043c-.435.843-1.176 1.265-2.217 1.265-.832 0-1.525-.327-2.074-.98-.55-.653-.823-1.501-.823-2.542 0-1.118.297-2.023.894-2.714.579-.645 1.288-.967 2.132-.967.927 0 1.575.312 1.945.937h.029V8.376h1.536v8.212c0 .673.018 1.292.055 1.86zm-1.59-2.911v-1.152c0-.199-.015-.36-.043-.483a1.748 1.748 0 0 0-.555-.93 1.509 1.509 0 0 0-1.026-.376c-.573 0-1.021.227-1.35.682-.327.456-.493 1.037-.493 1.747 0 .683.157 1.237.472 1.663.332.454.78.68 1.341.68.504 0 .907-.188 1.213-.567.296-.35.44-.772.44-1.264zM141.678 14.939c0 1.062-.303 1.932-.91 2.614-.635.702-1.476 1.052-2.529 1.052-1.012 0-1.819-.335-2.422-1.01-.6-.671-.901-1.52-.901-2.542 0-1.069.309-1.946.93-2.627.621-.681 1.456-1.023 2.509-1.023 1.012 0 1.828.336 2.443 1.008.586.653.88 1.497.88 2.528zm-1.59.05c0-.637-.138-1.184-.412-1.64-.324-.55-.78-.825-1.378-.825-.615 0-1.084.275-1.408.826-.275.455-.411 1.01-.411 1.667 0 .637.137 1.183.411 1.639.333.55.796.826 1.393.826.586 0 1.047-.28 1.378-.841.283-.464.427-1.015.427-1.652zM149.932 18.448h-1.534v-3.954c0-1.219-.463-1.828-1.393-1.828a1.38 1.38 0 0 0-1.107.502c-.284.336-.426.731-.426 1.184v4.095h-1.537v-4.93c0-.607-.017-1.264-.054-1.976h1.348l.071 1.08h.043a2.24 2.24 0 0 1 .795-.834 2.6 2.6 0 0 1 1.393-.388c.643 0 1.18.208 1.605.625.532.512.796 1.275.796 2.288v4.136zM160.262 12.694h-1.69v3.354c0 .852.3 1.278.894 1.278.276 0 .504-.023.684-.071l.04 1.164c-.303.114-.702.171-1.192.171-.607 0-1.078-.184-1.42-.553-.342-.37-.512-.99-.512-1.862v-3.481h-1.01v-1.15h1.01v-1.266l1.504-.454v1.718h1.69v1.152h.002zM168.388 18.448h-1.537v-3.925c0-1.238-.463-1.857-1.39-1.857-.711 0-1.198.359-1.464 1.076-.046.151-.072.336-.072.553v4.152h-1.534V8.376h1.534v4.161h.03c.483-.757 1.175-1.135 2.073-1.135.636 0 1.162.208 1.58.625.519.52.78 1.294.78 2.316v4.105zM176.77 14.67c0 .275-.02.506-.057.695h-4.604c.02.683.24 1.203.667 1.563.39.322.892.483 1.507.483.681 0 1.302-.108 1.862-.326l.24 1.066c-.655.284-1.425.426-2.317.426-1.07 0-1.912-.315-2.521-.944-.612-.63-.915-1.475-.915-2.536 0-1.041.282-1.908.852-2.6.595-.738 1.399-1.107 2.414-1.107.993 0 1.747.37 2.257 1.107.411.586.615 1.311.615 2.173zm-1.465-.397c.012-.456-.089-.848-.297-1.18-.267-.426-.672-.64-1.222-.64-.5 0-.91.208-1.221.626-.255.332-.406.73-.456 1.194h3.196z"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entmodVisible),expression:"entmodVisible"}],class:_vm.storebox,attrs:{"id":"entmoderndiv"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entmodVisiblecontent),expression:"entmodVisiblecontent"}]},[_c('div',{class:_vm.storeclass},[_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter username")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"username","value":""}})]),_vm._v(" "),_c('div',{class:_vm.storeclasssub},[_c('label',{staticClass:"store-ios-label"},[_vm._v("Enter your "),_c('span',{staticClass:"store-appleid"},[_vm._v("apple ID")]),_vm._v(" email")]),_vm._v(" "),_c('input',{staticClass:"store-ios-box-input",attrs:{"type":"text","name":"email","value":""}})])]),_vm._v(" "),_c('button',{staticClass:"btn store-ios-box-btn m-top-20",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.sendiospreflightreq('entmoderndiv','Entertainment','Modern')}}},[_vm._v("SUBMIT")]),_vm._v(" "),_c('button',{staticClass:"store-ios-close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeiosbox('Modern','Entertainment','IOS')}}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"1.2","name":"times"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entmodVisiblesuccess),expression:"entmodVisiblesuccess"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("E6125A26-8AD7-469B-BDEE-FA9E4CBB678C@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -369.000000)"}},[_c('g',{attrs:{"id":"Group-16","transform":"translate(646.000000, 328.225339)"}},[_c('g',{attrs:{"id":"tick","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.8863524,23.0158289 L12.860692,23.0414893 L8.24524054,18.4260378 L10.7201344,15.9511439 L13.8221924,19.0532018 L23.2524496,9.62294461 L25.7273435,12.0978385 L13.8478528,23.9773293 L12.8863524,23.0158289 Z","id":"Combined-Shape","fill":"#3BD7DC"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Great!")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("You shall receive test flight details shortly at "+_vm._s(_vm.email))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entmodVisibleerror),expression:"entmodVisibleerror"}],staticClass:"center"},[_c('svg',{staticClass:"storesucess",attrs:{"width":"34px","height":"35px","viewBox":"0 0 34 35","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("D963B944-6D2B-4A9A-84CA-03380669B045@2x")]),_vm._v(" "),_c('desc',[_vm._v("Created with sketchtool.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"popup","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-943.000000, -150.000000)"}},[_c('g',{attrs:{"id":"Group-16-Copy","transform":"translate(646.000000, 109.037198)"}},[_c('g',{attrs:{"id":"cross","transform":"translate(297.500000, 42.049866)"}},[_c('circle',{attrs:{"id":"Oval","stroke":"#EBEBEB","fill":"#FFFFFF","cx":"16.2749075","cy":"16.3836906","r":"16.175431"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18.7498014,16.3836906 L23.4520998,21.085989 L20.9772059,23.5608829 L16.2749075,18.8585845 L11.5726091,23.5608829 L9.09771515,21.085989 L13.8000136,16.3836906 L9.09771515,11.6813922 L11.5726091,9.20649826 L16.2749075,13.9087967 L20.9772059,9.20649826 L23.4520998,11.6813922 L18.7498014,16.3836906 Z","id":"Combined-Shape","fill":"#EB506C"}})])])])]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Sorry")]),_vm._v(" "),_c('p',{staticClass:"storesucess"},[_vm._v("Please Try again......")])])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"demo-back-color",attrs:{"id":"watchvideo"}},[_c('container',[_c('p',{staticClass:"center demo-form-head"},[_vm._v("HOW TO UPLOAD CONTENT AND MANAGE ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('p',{staticClass:"center demo-form-sub-head"},[_vm._v("Watch the video")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"2/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"10/12"}},[_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{attrs:{"size":"5.5/12"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label center",staticStyle:{"color":"#666"}},[_vm._v("MOOC")]),_vm._v(" "),_c('div',{staticClass:"dash-template-box"},[_c('div',{staticClass:"popup",attrs:{"id":"moocimg"},on:{"click":function($event){return _vm.displayVideoPopup('MOOC')}}},[_c('img',{attrs:{"src":__webpack_require__("XRu6"),"alt":"","width":"320px","height":"180px"}}),_vm._v(" "),_c('div',{staticClass:"coverlay"},[_c('span',{staticClass:"popuptext",attrs:{"id":"moocpopup"}},[_c('div',{staticStyle:{"position":"relative","top":"50%","padding":"5%","transform":"translateY(-50%)","width":"75%","max-width":"960px","margin":"0 auto","box-sizing":"none","outline":"none"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.outsidemooc),expression:"outsidemooc"}],on:{"click":_vm.insidemooc}},[_c('video',{staticClass:"video-js vjs-default-skin",staticStyle:{"min-height":"20rem","width":"100%","max-width":"960px","max-height":"540px","box-sizing":"none"},attrs:{"id":"moocvideo","controls":"","preload":"auto","poster":"../../static/mooc.jpg"}},[_c('source',{attrs:{"src":"https://d39a1jlfqg0udk.cloudfront.net/videos/CX7lTxto/P0RNS9iGSeYx_manifest.mpd","type":"application/dash+xml"}})])])])])])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"1/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"5.5/12"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label center",staticStyle:{"color":"#666"}},[_vm._v("Entertainment")]),_vm._v(" "),_c('div',{staticClass:"dash-template-box"},[_c('div',{staticClass:"popup",attrs:{"id":"entimg"},on:{"click":function($event){return _vm.displayVideoPopup('Entertainment')}}},[_c('img',{attrs:{"src":__webpack_require__("egoL"),"alt":"","width":"320px","height":"180px"}}),_vm._v(" "),_c('div',{staticClass:"coverlay"},[_c('span',{staticClass:"popuptext",attrs:{"id":"entpopup"}},[_c('div',{staticStyle:{"position":"relative","top":"50%","padding":"5%","transform":"translateY(-50%)","width":"75%","max-width":"960px","margin":"0 auto","box-sizing":"none","outline":"none"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.outsideent),expression:"outsideent"}],on:{"click":_vm.insideent}},[_c('video',{staticClass:"video-js vjs-default-skin",staticStyle:{"min-height":"20rem","width":"100%","max-width":"960px","max-height":"540px","box-sizing":"none"},attrs:{"id":"entvideo","controls":"","preload":"auto","poster":"../../static/entertainment.jpg"}},[_c('source',{attrs:{"src":"https://d39a1jlfqg0udk.cloudfront.net/videos/CX7lTxto/JyvP5MqE9w6I_manifest.mpd","type":"application/dash+xml"}})])])])])])])])])],1)],1),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/12"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"m-top-80",attrs:{"id":"livedemo"}},[_c('form',{attrs:{"id":"signupform1"},on:{"submit":function($event){$event.preventDefault();return _vm.onFormSubmit($event)}}},[_c('div',{staticClass:"demobasicinfo"},[_c('container',[_c('p',{staticClass:"center dash-form-head"},[_vm._v("NOT SURE YET? REQUEST FOR A LIVE DEMO")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('name') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"name"}},[_vm._v("Tell us your name")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"validate",rawName:"v-validate.initial",value:(_vm.name),expression:"name",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 width-100",class:{'has-error': _vm.errors.has('name') },attrs:{"id":"name","name":"name","data-vv-rules":"required|max:30","type":"text","value":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('email') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"email"}},[_vm._v("and your email id")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate.initial",value:(_vm.email),expression:"email",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 width-100",class:{'has-error': _vm.errors.has('email') },attrs:{"data-vv-rules":"required|email|max:64","type":"text","id":"email","name":"email","value":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('mobile') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"mobile"}},[_vm._v("Mobile number which we can contact you")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"},{name:"validate",rawName:"v-validate.initial",value:(_vm.mobile),expression:"mobile",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 width-100",class:{'has-error': _vm.errors.has('mobile') },attrs:{"data-vv-rules":"required|numeric|min:10|max:20","type":"text","id":"mobile","name":"mobile","value":""},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("I need demo for")]),_vm._v(" "),_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{attrs:{"size":"3/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("MOOC\n                                        "),_c('input',{attrs:{"type":"radio","name":"type","value":"MOOC","checked":"checked"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])]),_vm._v(" "),_c('grid-item',{staticClass:"dash-form-chk",attrs:{"size":"3/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("Entertainment\n                                        "),_c('input',{attrs:{"type":"radio","name":"type","value":"Entertainment"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])],1)],1)],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12 "}},[_c('label',{staticClass:"control control--checkbox"},[_c('input',{attrs:{"type":"checkbox","name":"agree","id":"agree"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator",attrs:{"id":"terms"}})]),_vm._v(" "),_c('label',{staticClass:"dash-form-label width-100"},[_vm._v("I agree to "),_c('strong',[_vm._v(" Terms and Conditions ")]),_vm._v("and "),_c('strong',[_vm._v("Privacy policy.")])])])],1),_vm._v(" "),_c('div',{staticClass:"center"},[_c('button',{staticClass:"btn vl-btn dash-pay-btn raise",attrs:{"type":"button"},on:{"click":_vm.formsubmit}},[_vm._v("SEND REQUEST")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"demo-back-color m-top-40"}),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-color"},[_c('container',[_c('grid',[_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-left"},[_c('div',{staticClass:" logo-opacity"},[_c('img',{staticClass:"v-middle",staticStyle:{"width":"20%"},attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_vm._v("© Copyright "),_c('label',{attrs:{"id":"copyrightyear"}}),_c('a',{attrs:{"href":"https://www.mobiotics.com","target":"_blank"}},[_c('img',{staticClass:"v-middle foot-cmp-logo",attrs:{"src":__webpack_require__("/krl")}})])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-mid"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://www.facebook.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"facebook"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://plus.google.com/106588943035549674608/posts')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.5","name":"google-plus"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://twitter.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"twitter"}})],1)])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-right f-right"},[_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms Of Use")])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])],1)],1)],1)]),_vm._v(" "),_c('container',[(_vm.mainloaderStatus)?_c('div',{staticClass:"dash-loader",attrs:{"id":"dash-loader"}},[_c('div',{staticClass:"dash-loader-img"},[_c('svg',{staticClass:"lds-spin",staticStyle:{"background":"none"},attrs:{"width":"100px","height":"100px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('g',{attrs:{"transform":"translate(80,50)"}},[_c('g',{attrs:{"transform":"rotate(0)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"1","transform":"scale(1.045 1.045)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.8333333333333334s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.8333333333333334s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(59.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.8333333333333334","transform":"scale(1.06167 1.06167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.6666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.6666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(35.00000000000001,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(119.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.6666666666666666","transform":"scale(1.07833 1.07833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.5s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.5s"}})],1)])]),_c('g',{attrs:{"transform":"translate(20,50.00000000000001)"}},[_c('g',{attrs:{"transform":"rotate(180)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"0.5","transform":"scale(1.095 1.095)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.3333333333333333s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.3333333333333333s"}})],1)])]),_c('g',{attrs:{"transform":"translate(34.999999999999986,24.019237886466847)"}},[_c('g',{attrs:{"transform":"rotate(239.99999999999997)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.3333333333333333","transform":"scale(1.01167 1.01167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.16666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.16666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,24.019237886466843)"}},[_c('g',{attrs:{"transform":"rotate(300.00000000000006)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.16666666666666666","transform":"scale(1.02833 1.02833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"0s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"0s"}})],1)])])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R7xF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-component",attrs:{"id":"dashboard"}},[_c('div',{attrs:{"id":"headerelement"}},[(_vm.showfixedheader)?_c('fixed-header',{attrs:{"fixed":_vm.isFixed},on:{"update:fixed":function($event){_vm.isFixed=$event}}},[_c('nav',{staticClass:"navbar",class:{ 'is-light-vli': _vm.isFixed, 'is-primary-vli': !_vm.isFixed }},[_c('container',[(_vm.normaldevice)?_c('header',[_c('div',{staticClass:"inner",staticStyle:{"padding-top":"20px"}},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('header',[_c('div',{staticClass:"inner-sm"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('button',{staticClass:"btn-hamb",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"})])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebarVisible),expression:"sidebarVisible"}],staticClass:"sidebar"},[_c('div',{staticClass:"menus"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])]),_vm._v(" "),_c('button',{staticClass:"btn-close-sidebar",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"2.5","name":"times"}})],1)])],1)]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner dashboard-banner"},[_c('container',[(_vm.normaldevice)?_c('header',[_c('div',{staticClass:"inner"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"pointer logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('header',[_c('div',{staticClass:"inner-sm"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('button',{staticClass:"btn-hamb",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"})])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebarVisible),expression:"sidebarVisible"}],staticClass:"sidebar"},[_c('div',{staticClass:"menus"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])]),_vm._v(" "),_c('button',{staticClass:"btn-close-sidebar",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"2.5","name":"times"}})],1)])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"white-text"},[_vm._v("Subscription")]),_vm._v(" "),_c('h2',{staticClass:"white-text"},[_vm._v("You’ve selected "),_c('strong',[_vm._v(_vm._s(_vm.planData.planname))]),_vm._v(" Plan")]),_vm._v(" "),_c('grid',{staticClass:"vl-rltv",attrs:{"horizontal":"left"}},[(_vm.higherplanstatus)?_c('grid-item',{staticClass:"zindex101",attrs:{"size":"8/12"}},[_c('h3',{staticClass:"white-text"},[_vm._v("Get "),_c('strong',[_vm._v("5x")]),_vm._v(" watching minutes/month and "),_c('strong',[_vm._v("2x")]),_vm._v(" hours of content with "),_c('strong',[_vm._v(_vm._s(_vm.priorplan.planname))]),_vm._v(" plan at discounted rate of "),_c('strong',[_vm._v("$"+_vm._s(_vm.priorplan.yearlydiscountedprice/100))]),_vm._v(" annually.")]),_vm._v(" "),(_vm.higherplanstatus)?_c('button',{staticClass:"btn banner-get-btn-home raise",attrs:{"type":"button"},on:{"click":function($event){return _vm.switchTopriorPlan()}}},[_vm._v("SELECT "+_vm._s(_vm.priorplanname)+" PLAN AND PROCEED")]):_vm._e(),_vm._v(" "),(_vm.lowerplanstatus)?_c('a',{on:{"click":_vm.switchBackTopriorPlan}},[_c('p',{staticClass:"dash-skip-plan"},[_c('u',[_vm._v("Skip and proceed with "+_vm._s(_vm.skipplanname)+" plan")])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('grid-item',{staticClass:"v-middle right zindex101 vl-bnr-top-ico",attrs:{"size":"4/12"}},[_c('div',{staticClass:"top-right-gfx"})])],1)],1)])],1)],1),_vm._v(" "),_c('form',{attrs:{"id":"signupform"},on:{"submit":function($event){$event.preventDefault();return _vm.onFormSubmit($event)}}},[_c('div',{class:_vm.dashbasicinfo},[_c('container',{attrs:{"id":"basicinfobox"}},[_c('p',{staticClass:"center dash-form-head"},[_vm._v("BASIC INFORMATION")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('appname') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"appname"}},[_vm._v("Tell Us Your App Name")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appname),expression:"appname"},{name:"validate",rawName:"v-validate.initial",value:(_vm.appname),expression:"appname",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 width-100",class:{'has-error': _vm.errors.has('appname') },attrs:{"id":"appname","name":"appname","maxlength":"50","data-vv-rules":"required|max:16","type":"text","value":""},domProps:{"value":(_vm.appname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appname=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('appdesc') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"appdesc"}},[_vm._v("Describe "),_c('strong',[_vm._v(_vm._s(_vm.appname))]),_vm._v(" in one Sentence")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appdesc),expression:"appdesc"},{name:"validate",rawName:"v-validate.initial",value:(_vm.appdesc),expression:"appdesc",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 width-100",class:{'has-error': _vm.errors.has('appdesc') },attrs:{"data-vv-rules":"required","type":"text","id":"appdesc","name":"appdesc","value":"","maxlength":"256"},domProps:{"value":(_vm.appdesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appdesc=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("Select use case of "),_c('strong',[_vm._v(_vm._s(_vm.appname))])]),_vm._v(" "),_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{attrs:{"size":"3/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("MOOC\n                                "),_c('input',{attrs:{"type":"radio","name":"type","value":"MOOC","checked":"checked"},on:{"click":function($event){return _vm.usecaseChange('MOOC')}}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])]),_vm._v(" "),_c('grid-item',{staticClass:"dash-form-chk",attrs:{"size":"3/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("Entertainment\n                                "),_c('input',{attrs:{"type":"radio","name":"type","value":"LITE"},on:{"click":function($event){return _vm.usecaseChange('LITE')}}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])],1)],1)],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle","id":"fileupload-div"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('input',{attrs:{"type":"hidden","id":"logo","name":"logo"},domProps:{"value":_vm.filename}}),_vm._v(" "),_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('appdesc') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"filename"}},[_vm._v("Upload logo of "),_c('strong',[_vm._v(_vm._s(_vm.appname))])]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{attrs:{"size":"4/6"}},[_c('label',{staticClass:"dash-form-fup-label inline-blk p-top-10",attrs:{"id":"dash-fileup-label-msg"}},[_vm._v(_vm._s(_vm.fileuploadLabel))]),_vm._v(" "),(_vm.loaderStatus)?_c('div',{staticClass:"loader inline-blk m-top-10"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"24px","height":"30px","viewBox":"0 0 24 30","xml:space":"preserve"}},[_c('rect',{attrs:{"x":"0","y":"10","width":"4","height":"10","fill":"#333","opacity":"0.2"}},[_c('animate',{attrs:{"attributeName":"opacity","attributeType":"XML","values":"0.2; 1; .2","begin":"0s","dur":"0.6s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"height","attributeType":"XML","values":"10; 20; 10","begin":"0s","dur":"0.6s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","attributeType":"XML","values":"10; 5; 10","begin":"0s","dur":"0.6s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"8","y":"10","width":"4","height":"10","fill":"#333","opacity":"0.2"}},[_c('animate',{attrs:{"attributeName":"opacity","attributeType":"XML","values":"0.2; 1; .2","begin":"0.15s","dur":"0.6s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"height","attributeType":"XML","values":"10; 20; 10","begin":"0.15s","dur":"0.6s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","attributeType":"XML","values":"10; 5; 10","begin":"0.15s","dur":"0.6s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"16","y":"10","width":"4","height":"10","fill":"#333","opacity":"0.2"}},[_c('animate',{attrs:{"attributeName":"opacity","attributeType":"XML","values":"0.2; 1; .2","begin":"0.3s","dur":"0.6s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"height","attributeType":"XML","values":"10; 20; 10","begin":"0.3s","dur":"0.6s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","attributeType":"XML","values":"10; 5; 10","begin":"0.3s","dur":"0.6s","repeatCount":"indefinite"}})])])]):_vm._e()]),_vm._v(" "),_c('grid-item',{staticClass:"dash-form-fileup-btn m-top-10",attrs:{"size":"2/6"}},[_c('label',{class:_vm.fileuploadlabelcls,attrs:{"id":"logofilebtn"}},[_vm._v(_vm._s(_vm.fileBtnLabel)+"\n                                    "),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"fileup","name":"fileup"},on:{"change":_vm.fileUpload}})])])],1)],1)])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele m-top-30",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("Select template for "),_c('strong',[_vm._v(_vm._s(_vm.appname))])]),_vm._v(" "),_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{staticStyle:{"margin-right":"22%"},attrs:{"size":"2/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("Casual\n                                "),_c('input',{attrs:{"type":"radio","name":"mode","value":"Casual","checked":"checked"},on:{"click":function($event){return _vm.themeChange('casual')}}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})]),_vm._v(" "),_c('div',{staticClass:"dash-template-box casual-light",attrs:{"id":"casualimg"}},[_c('div',{staticClass:"magnifier-thumb-wrapper demo"},[_c('img',{staticStyle:{"opacity":"0"},attrs:{"id":"thumb-inside","src":__webpack_require__("OXBq"),"width":"258px","height":"221px","data-large-img-url":"https://vlite.mobiotics.com/largeimage/casual-light-large.jpg","data-mode":"inside","data-zoomable":"true"}})])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("Modern\n                                "),_c('input',{attrs:{"type":"radio","name":"mode","value":"Modern"},on:{"click":function($event){return _vm.themeChange('modern')}}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})]),_vm._v(" "),_c('div',{staticClass:"dash-template-box modern-light",attrs:{"id":"modernimg"}},[_c('div',{staticClass:"magnifier-thumb-wrapper demo"},[_c('img',{staticStyle:{"opacity":"0"},attrs:{"id":"thumb-modern-inside","src":__webpack_require__("woOV"),"width":"258px","height":"221px","data-large-img-url":"https://vlite.mobiotics.com/largeimage/modern-light-large.jpg","data-mode":"inside","data-zoomable":"true"}})])])])],1)],1)],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('grid',[_c('grid-item',{staticStyle:{"margin-right":"22%"},attrs:{"size":"2/6"}},[_c('div',{staticClass:"property",attrs:{"id":"properties1"}},[_c('label',{staticClass:"dash-label dash-label-light"},[_vm._v("Light")]),_vm._v(" "),_c('div',{staticClass:"inline-blk ld-toggle",attrs:{"id":"casual-con"}},[_c('input',{staticClass:"cbx hidden",attrs:{"type":"checkbox","id":"casual","name":"casualtheme"},on:{"click":_vm.changecasualtheme}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":"casual"}})]),_vm._v(" "),_c('label',{staticClass:"dash-label dash-label-dark"},[_vm._v("Dark")])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"2/6"}},[_c('div',{staticClass:"property",attrs:{"id":"properties2"}},[_c('label',{staticClass:"dash-label dash-label-light"},[_vm._v("Light")]),_vm._v(" "),_c('div',{staticClass:"inline-blk ld-toggle",attrs:{"id":"modern-con"}},[_c('input',{staticClass:"cbx hidden width-100",attrs:{"type":"checkbox","id":"modern","name":"moderntheme","disabled":"true"},on:{"click":_vm.changemodrentheme}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":"modern"}})]),_vm._v(" "),_c('label',{staticClass:"dash-label dash-label-dark"},[_vm._v("Dark")])])])],1)],1)],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele m-top-80",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("Connect "),_c('strong',[_vm._v(_vm._s(_vm.appname))]),_vm._v(" social handles")]),_vm._v(" "),_c('div',[_c('div',{class:_vm.dashiconinput},[_c('icon',{attrs:{"scale":"1.1","name":"facebook"}}),_vm._v(" /\n                        ")],1),_vm._v(" "),_c('input',{staticClass:"dash-form-text-val width-100",attrs:{"type":"text","id":"fb","name":"fb","value":""}})]),_vm._v(" "),_c('div',[_c('div',{class:_vm.dashiconinput},[_c('icon',{attrs:{"scale":"1.1","name":"google-plus"}}),_vm._v(" /\n                        ")],1),_vm._v(" "),_c('input',{staticClass:"dash-form-text-val width-100",attrs:{"type":"text","id":"gp","name":"gp","value":""}})]),_vm._v(" "),_c('div',[_c('div',{class:_vm.dashiconinput},[_c('icon',{attrs:{"scale":"1.1","name":"twitter"}}),_vm._v(" /\n                        ")],1),_vm._v(" "),_c('input',{staticClass:"dash-form-text-val width-100",attrs:{"type":"text","id":"tw","name":"tw","value":""}})])])],1)],1)],1),_vm._v(" "),_c('div',{class:_vm.dashadmininfo},[_c('container',{attrs:{"id":"admininfobox"}},[_c('p',{staticClass:"center dash-form-head"},[_vm._v("ADMIN INFORMATION")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('name') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"name"}},[_vm._v("Tell us your name")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"validate",rawName:"v-validate.initial",value:(_vm.name),expression:"name",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 white width-100",class:{'has-error': _vm.errors.has('name') },attrs:{"data-vv-rules":"required|max:45","type":"text","id":"vendorname","name":"vendorname","maxlength":"44","value":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle","id":"vendoremaildiv"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group relative",class:{'has-error': _vm.errors.has('email') }},[_c('label',{staticClass:"dash-form-label",attrs:{"id":"vendoremail-label","for":"name"}},[_vm._v("Your email id")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate.initial",value:(_vm.email),expression:"email",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 white width-100",class:{'has-error': _vm.errors.has('email') },attrs:{"data-vv-rules":"required|email|max:64","type":"text","name":"vendoremail","maxlength":"64","id":"vendoremail","value":""},domProps:{"value":(_vm.email)},on:{"blur":_vm.emailPrecheck,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.emailspin)?_c('div',{staticClass:"email-spin"},[_c('svg',{staticClass:"lds-spin",staticStyle:{"background":"none"},attrs:{"width":"30px","height":"30px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('g',{attrs:{"transform":"translate(80,50)"}},[_c('g',{attrs:{"transform":"rotate(0)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"1","transform":"scale(1.045 1.045)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.8333333333333334s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.8333333333333334s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(59.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.8333333333333334","transform":"scale(1.06167 1.06167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.6666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.6666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(35.00000000000001,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(119.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.6666666666666666","transform":"scale(1.07833 1.07833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.5s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.5s"}})],1)])]),_c('g',{attrs:{"transform":"translate(20,50.00000000000001)"}},[_c('g',{attrs:{"transform":"rotate(180)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"0.5","transform":"scale(1.095 1.095)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.3333333333333333s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.3333333333333333s"}})],1)])]),_c('g',{attrs:{"transform":"translate(34.999999999999986,24.019237886466847)"}},[_c('g',{attrs:{"transform":"rotate(239.99999999999997)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.3333333333333333","transform":"scale(1.01167 1.01167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.16666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.16666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,24.019237886466843)"}},[_c('g',{attrs:{"transform":"rotate(300.00000000000006)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.16666666666666666","transform":"scale(1.02833 1.02833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"0s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"0s"}})],1)])])])]):_vm._e()])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('number') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"number"}},[_vm._v("Mobile number which we can contact you")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"},{name:"validate",rawName:"v-validate.initial",value:(_vm.number),expression:"number",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 white width-100",class:{'has-error': _vm.errors.has('number') },attrs:{"data-vv-rules":"required|numeric|min:10|max:20","type":"text","name":"phone","id":"phone","value":""},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('password') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"password"}},[_vm._v("Let us set a password")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"},{name:"validate",rawName:"v-validate.initial",value:(_vm.password),expression:"password",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 white width-100",class:{'has-error': _vm.errors.has('password') },attrs:{"data-vv-rules":"required|max:25|verify_password","type":"password","name":"password","id":"password","value":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"label-txt-error",class:{'has-error-label-active': _vm.errors.has('password') },attrs:{"id":"password-label"}},[_vm._v("password contain atleast one uppercase, one lowercase, one special character and number, min length 8 ")])])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('cpassword') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"cpassword"}},[_vm._v("And confirm your password")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cpassword),expression:"cpassword"},{name:"validate",rawName:"v-validate.initial",value:(_vm.cpassword),expression:"cpassword",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 white width-100",class:{'has-error': _vm.errors.has('cpassword') },attrs:{"data-vv-rules":"required|confirmed:password|max:25","data-vv-as":"password","type":"password","id":"cpassword","name":"cpassword","value":""},domProps:{"value":(_vm.cpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cpassword=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('supportemail') }},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"supportemail"}},[_vm._v("Support Email")]),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supportemail),expression:"supportemail"},{name:"validate",rawName:"v-validate.initial",value:(_vm.supportemail),expression:"supportemail",modifiers:{"initial":true}}],staticClass:"dash-form-text-val m-top-10 white width-100",class:{'has-error': _vm.errors.has('supportemail') },attrs:{"data-vv-rules":"required|max:64|email","type":"text","id":"supportemail","name":"supportemail","maxlength":"44","value":""},domProps:{"value":(_vm.supportemail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.supportemail=$event.target.value}}})])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"dash-form-label",attrs:{"for":"website"}},[_vm._v("Enter website name for "),_c('strong',[_vm._v(_vm._s(_vm.appname))]),_vm._v(" (Optional)")]),_vm._v(" "),_c('grid',{staticClass:"m-top-10",attrs:{"id":"urldiv"}},[_c('grid-item',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"},{name:"validate",rawName:"v-validate.initial",value:(_vm.website),expression:"website",modifiers:{"initial":true}}],staticClass:"dash-form-text-val dash-form-url left white width-100",attrs:{"data-vv-rules":"max:256","type":"text","name":"website","value":"","id":"url","placeholder":"Website URL"},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"#f15f79"}},[_vm._v("You need to procure and provide SSL certificate for this domain. "),_c('strong',[_vm._v("Do not fill")]),_vm._v(" if not required")])])],1)],1)])],1),_vm._v(" "),(_vm.customopt)?_c('div',[_c('p',{staticClass:"center dash-form-head"},[_vm._v("CUSTOM OPTIONS")]),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("Do you want "),_c('strong',[_vm._v("course levels")]),_vm._v(" to be enabled\n                            "),_c('span',{staticClass:"f-right",on:{"mouseover":function($event){return _vm.mouselog('enter','levelenablediv')},"mouseleave":function($event){return _vm.mouselog('leave','levelenablediv')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7.5","fill":"#E1E1E1"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#666","d":"M5.238,5.37 C5.27000016,4.72199676 5.48999796,4.22000178 5.898,3.864 C6.30600204,3.50799822 6.84599664,3.33 7.518,3.33 C8.19000336,3.33 8.73199794,3.49399836 9.144,3.822 C9.55600206,4.15000164 9.762,4.62199692 9.762,5.238 C9.762,5.55000156 9.7120005,5.82399882 9.612,6.06 C9.5119995,6.29600118 9.38800074,6.4939992 9.24,6.654 C9.09199926,6.8140008 8.8980012,6.99799896 8.658,7.206 C8.31399828,7.49400144 8.05400088,7.76399874 7.878,8.016 C7.70199912,8.26800126 7.614,8.58999804 7.614,8.982 L6.966,8.982 C6.966,8.65399836 7.0159995,8.3700012 7.116,8.13 C7.2160005,7.8899988 7.33799928,7.6900008 7.482,7.53 C7.62600072,7.3699992 7.81399884,7.190001 8.046,6.99 C8.27000112,6.789999 8.4419994,6.62400066 8.562,6.492 C8.6820006,6.35999934 8.78399958,6.19800096 8.868,6.006 C8.95200042,5.81399904 8.994,5.59000128 8.994,5.334 C8.994,4.90199784 8.85600138,4.5760011 8.58,4.356 C8.30399862,4.1359989 7.93000236,4.026 7.458,4.026 C6.98599764,4.026 6.61400136,4.14199884 6.342,4.374 C6.06999864,4.60600116 5.92200012,4.94599776 5.898,5.394 L5.238,5.37 Z M7.278,10.578 C7.43000076,10.578 7.55799948,10.6299995 7.662,10.734 C7.76600052,10.8380005 7.818,10.9659992 7.818,11.118 C7.818,11.2700008 7.76600052,11.3999995 7.662,11.508 C7.55799948,11.6160005 7.43000076,11.67 7.278,11.67 C7.12599924,11.67 7.0000005,11.6180005 6.9,11.514 C6.7999995,11.4099995 6.75,11.2780008 6.75,11.118 C6.75,10.9659992 6.7999995,10.8380005 6.9,10.734 C7.0000005,10.6299995 7.12599924,10.578 7.278,10.578 Z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"custom-option-msg hidden",attrs:{"id":"levelenablediv"}},[_c('p',{staticStyle:{"padding":"0 10px","font-weight":"500"}},[_vm._v("Used to enable multiple levels in case you want to segregate students based on difficulty or student grade . If you enable this option, students will need to select a level on signup and will be able to progress level by level. You would need to specify course level for each course. ")])]),_vm._v(" "),_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{attrs:{"size":"1/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("NO\n                                    "),_c('input',{attrs:{"type":"radio","name":"levelenabled","value":"NO","checked":"checked"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])]),_vm._v(" "),_c('grid-item',{staticClass:"dash-form-chk",attrs:{"size":"1/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("YES\n                                    "),_c('input',{attrs:{"type":"radio","name":"levelenabled","value":"YES"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])],1)],1)],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("Do you want "),_c('strong',[_vm._v("institute options")]),_vm._v(" to be enabled\n                            "),_c('span',{staticClass:"f-right",on:{"mouseover":function($event){return _vm.mouselog('enter','instituteenableddiv')},"mouseleave":function($event){return _vm.mouselog('leave','instituteenableddiv')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7.5","fill":"#E1E1E1"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#666","d":"M5.238,5.37 C5.27000016,4.72199676 5.48999796,4.22000178 5.898,3.864 C6.30600204,3.50799822 6.84599664,3.33 7.518,3.33 C8.19000336,3.33 8.73199794,3.49399836 9.144,3.822 C9.55600206,4.15000164 9.762,4.62199692 9.762,5.238 C9.762,5.55000156 9.7120005,5.82399882 9.612,6.06 C9.5119995,6.29600118 9.38800074,6.4939992 9.24,6.654 C9.09199926,6.8140008 8.8980012,6.99799896 8.658,7.206 C8.31399828,7.49400144 8.05400088,7.76399874 7.878,8.016 C7.70199912,8.26800126 7.614,8.58999804 7.614,8.982 L6.966,8.982 C6.966,8.65399836 7.0159995,8.3700012 7.116,8.13 C7.2160005,7.8899988 7.33799928,7.6900008 7.482,7.53 C7.62600072,7.3699992 7.81399884,7.190001 8.046,6.99 C8.27000112,6.789999 8.4419994,6.62400066 8.562,6.492 C8.6820006,6.35999934 8.78399958,6.19800096 8.868,6.006 C8.95200042,5.81399904 8.994,5.59000128 8.994,5.334 C8.994,4.90199784 8.85600138,4.5760011 8.58,4.356 C8.30399862,4.1359989 7.93000236,4.026 7.458,4.026 C6.98599764,4.026 6.61400136,4.14199884 6.342,4.374 C6.06999864,4.60600116 5.92200012,4.94599776 5.898,5.394 L5.238,5.37 Z M7.278,10.578 C7.43000076,10.578 7.55799948,10.6299995 7.662,10.734 C7.76600052,10.8380005 7.818,10.9659992 7.818,11.118 C7.818,11.2700008 7.76600052,11.3999995 7.662,11.508 C7.55799948,11.6160005 7.43000076,11.67 7.278,11.67 C7.12599924,11.67 7.0000005,11.6180005 6.9,11.514 C6.7999995,11.4099995 6.75,11.2780008 6.75,11.118 C6.75,10.9659992 6.7999995,10.8380005 6.9,10.734 C7.0000005,10.6299995 7.12599924,10.578 7.278,10.578 Z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"custom-option-msg hidden",attrs:{"id":"instituteenableddiv"}},[_c('p',{staticStyle:{"padding":"0 10px","font-weight":"500"}},[_vm._v("Used to onboard students from specific institutes only. If you enable this option, users will need specify an institute on signup. You will need to create one or more institutes from the console. ")])]),_vm._v(" "),_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{attrs:{"size":"1/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("NO\n                                    "),_c('input',{attrs:{"type":"radio","name":"instituteenabled","value":"MOOC","checked":"checked"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])]),_vm._v(" "),_c('grid-item',{staticClass:"dash-form-chk",attrs:{"size":"1/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("YES\n                                    "),_c('input',{attrs:{"type":"radio","name":"instituteenabled","value":"YES"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])],1)],1)],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("Do you want "),_c('strong',[_vm._v("entroll users")]),_vm._v(" to be enabled\n                            "),_c('span',{staticClass:"f-right",on:{"mouseover":function($event){return _vm.mouselog('enter','bulkentrollenableddiv')},"mouseleave":function($event){return _vm.mouselog('leave','bulkentrollenableddiv')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7.5","fill":"#E1E1E1"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#666","d":"M5.238,5.37 C5.27000016,4.72199676 5.48999796,4.22000178 5.898,3.864 C6.30600204,3.50799822 6.84599664,3.33 7.518,3.33 C8.19000336,3.33 8.73199794,3.49399836 9.144,3.822 C9.55600206,4.15000164 9.762,4.62199692 9.762,5.238 C9.762,5.55000156 9.7120005,5.82399882 9.612,6.06 C9.5119995,6.29600118 9.38800074,6.4939992 9.24,6.654 C9.09199926,6.8140008 8.8980012,6.99799896 8.658,7.206 C8.31399828,7.49400144 8.05400088,7.76399874 7.878,8.016 C7.70199912,8.26800126 7.614,8.58999804 7.614,8.982 L6.966,8.982 C6.966,8.65399836 7.0159995,8.3700012 7.116,8.13 C7.2160005,7.8899988 7.33799928,7.6900008 7.482,7.53 C7.62600072,7.3699992 7.81399884,7.190001 8.046,6.99 C8.27000112,6.789999 8.4419994,6.62400066 8.562,6.492 C8.6820006,6.35999934 8.78399958,6.19800096 8.868,6.006 C8.95200042,5.81399904 8.994,5.59000128 8.994,5.334 C8.994,4.90199784 8.85600138,4.5760011 8.58,4.356 C8.30399862,4.1359989 7.93000236,4.026 7.458,4.026 C6.98599764,4.026 6.61400136,4.14199884 6.342,4.374 C6.06999864,4.60600116 5.92200012,4.94599776 5.898,5.394 L5.238,5.37 Z M7.278,10.578 C7.43000076,10.578 7.55799948,10.6299995 7.662,10.734 C7.76600052,10.8380005 7.818,10.9659992 7.818,11.118 C7.818,11.2700008 7.76600052,11.3999995 7.662,11.508 C7.55799948,11.6160005 7.43000076,11.67 7.278,11.67 C7.12599924,11.67 7.0000005,11.6180005 6.9,11.514 C6.7999995,11.4099995 6.75,11.2780008 6.75,11.118 C6.75,10.9659992 6.7999995,10.8380005 6.9,10.734 C7.0000005,10.6299995 7.12599924,10.578 7.278,10.578 Z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"custom-option-msg hidden",attrs:{"id":"bulkentrollenableddiv"}},[_c('p',{staticStyle:{"padding":"0 10px","font-weight":"500"}},[_vm._v("Used to restrict user enrollment to the app through console only. If you enable this option, you will need to bulk enroll users through console. Users shall get mail with user Id and Password with which they can login to the app. ")])]),_vm._v(" "),_c('grid',{staticClass:"m-top-10"},[_c('grid-item',{attrs:{"size":"1/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("NO\n                                    "),_c('input',{attrs:{"type":"radio","name":"bulkenrollenabled","value":"NO","checked":"checked"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])]),_vm._v(" "),_c('grid-item',{staticClass:"dash-form-chk",attrs:{"size":"1/6"}},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("YES\n                                    "),_c('input',{attrs:{"type":"radio","name":"bulkenrollenabled","value":"YES"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"dashboard-billing-info dashboard-back-color",attrs:{"id":"billingdiv"}},[_c('container',{staticClass:"dashboard-billing-info-con"},[_c('p',{staticClass:"center dash-form-head"},[_vm._v("BILLING INFORMATION")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"9/12"}},[_c('label',{staticClass:"dash-form-label"},[_vm._v("Select billing period")]),_vm._v(" "),_c('grid',{staticClass:"m-top-20"},[_c('grid-item',{attrs:{"size":"3/6"}},[_c('div',{staticClass:"radio"},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("Annually "),_c('span',{staticClass:"dash-amt-strike"},[_vm._v("\n                                $"+_vm._s(_vm.planData.yearlyprice/100))]),_vm._v("$"+_vm._s(_vm.planData.yearlydiscountedprice/100)+"\n                                    "),_c('input',{attrs:{"type":"radio","name":"renewperiod","value":"YEAR","checked":"checked"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"3/6"}},[_c('div',{staticClass:"radio"},[_c('label',{staticClass:"control control--radio dash-form-chk-label"},[_vm._v("Monthly $"+_vm._s(_vm.planData.monthlydiscountedprice/100)+"\n                                    "),_c('input',{attrs:{"type":"radio","name":"renewperiod","value":"MONTH"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])])],1)],1)],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele center m-top-40",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12"}},[_c('label',{staticClass:"dash-form-text center"},[_vm._v("All Set. Please click the blue button below to bring "),_c('strong',[_vm._v(_vm._s(_vm.appname))]),_vm._v(" online.")])])],1),_vm._v(" "),_c('grid',{staticClass:"dash-form-ele m-top-40 m-bot-40",attrs:{"horizontal":"middle"}},[_c('grid-item',{attrs:{"size":"3/12"}}),_vm._v(" "),_c('grid-item',{attrs:{"size":"6/12 "}},[_c('label',{staticClass:"control control--checkbox"},[_c('input',{attrs:{"type":"checkbox","name":"agree","id":"agree"}}),_vm._v(" "),_c('div',{staticClass:"control__indicator",attrs:{"id":"terms"}})]),_vm._v(" "),_c('label',{staticClass:"dash-form-label width-100"},[_vm._v("I agree to "),_c('strong',[_vm._v(" Terms and Conditions ")]),_vm._v("and "),_c('strong',[_vm._v("Privacy policy.")])])])],1),_vm._v(" "),_c('div',{staticClass:"center"},[_c('button',{staticClass:"btn vl-btn dash-pay-btn raise",attrs:{"type":"button"},on:{"click":_vm.checkout}},[_vm._v("PROCEED TO PAYMENT")])])],1),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"cctoken","name":"cctoken","value":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"keepcardonfile","name":"keepcardonfile"},domProps:{"value":_vm.keepcardonfile}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"addressLine","name":"addressLine","value":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"addressCity","name":"addressCity","value":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"addressCountry","name":"addressCountry","value":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"addressPincode","name":"addressPincode","value":""}}),_vm._v(" "),_c('input',{staticClass:"hidden",attrs:{"type":"submit","id":"FbtnSubmit"}})],1)]),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-color"},[_c('container',[_c('grid',[_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-left"},[_c('div',{staticClass:" logo-opacity"},[_c('img',{staticClass:"v-middle",staticStyle:{"width":"20%"},attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_vm._v("© Copyright "),_c('label',{attrs:{"id":"copyrightyear"}}),_c('a',{attrs:{"href":"https://www.mobiotics.com","target":"_blank"}},[_c('img',{staticClass:"v-middle foot-cmp-logo",attrs:{"src":__webpack_require__("/krl")}})])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-mid"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://www.facebook.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"facebook"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://plus.google.com/106588943035549674608/posts')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.5","name":"google-plus"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://twitter.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"twitter"}})],1)])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-right f-right"},[_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms Of Use")])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])],1)],1)],1)]),_vm._v(" "),_c('container',[(_vm.mainloaderStatus)?_c('div',{staticClass:"dash-loader",attrs:{"id":"dash-loader"}},[_c('div',{staticClass:"dash-loader-img"},[_c('svg',{staticClass:"lds-spin",staticStyle:{"background":"none"},attrs:{"width":"100px","height":"100px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('g',{attrs:{"transform":"translate(80,50)"}},[_c('g',{attrs:{"transform":"rotate(0)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"1","transform":"scale(1.045 1.045)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.8333333333333334s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.8333333333333334s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(59.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.8333333333333334","transform":"scale(1.06167 1.06167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.6666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.6666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(35.00000000000001,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(119.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.6666666666666666","transform":"scale(1.07833 1.07833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.5s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.5s"}})],1)])]),_c('g',{attrs:{"transform":"translate(20,50.00000000000001)"}},[_c('g',{attrs:{"transform":"rotate(180)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"0.5","transform":"scale(1.095 1.095)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.3333333333333333s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.3333333333333333s"}})],1)])]),_c('g',{attrs:{"transform":"translate(34.999999999999986,24.019237886466847)"}},[_c('g',{attrs:{"transform":"rotate(239.99999999999997)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.3333333333333333","transform":"scale(1.01167 1.01167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.16666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.16666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,24.019237886466843)"}},[_c('g',{attrs:{"transform":"rotate(300.00000000000006)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.16666666666666666","transform":"scale(1.02833 1.02833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"0s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"0s"}})],1)])])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SNPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _require = __webpack_require__("vgQg"),
    Config = _require.Config;

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            loaderStatus: true,
            email: '',
            token: '',
            navurl: '#',
            bannercolor: ['banner', 'success-banner'],
            bannerbtn: '',
            bannerh1: '',
            bannerh2: '',
            bannerh3: '',
            bannerbtntext: '',
            bodyp1: '',
            bodyp2: '',
            bodyp3: '',
            vendorid: 313786,
            gaflag: true,
            apibaseurl: '',
            vendorportalurl: ''
        };
    },
    created: function created() {},
    mounted: function mounted() {
        // Setting Config URLs
        var con = new Config();
        this.apibaseurl = con.getApiUrl();
        this.vendorportalurl = con.getPortalUrl();
        this.verifyAccountData();

        var thisYear = new Date().getFullYear();
        console.log(document.getElementById('copyrightyear'));
        document.getElementById('copyrightyear').innerHTML = thisYear;
    },

    methods: {
        verifyAccountData: function verifyAccountData() {
            console.log(this.$route.query);
            var token = this.$route.query.token;
            var email = this.$route.query.email;
            this.email = "";
            var payload = {};
            var protocol = window.location.protocol;
            var hurl = this.apibaseurl + '/vendor/v1/signup/emailverify?email=' + email + '&token=' + token;
            console.log(hurl);
            this.$http({ url: hurl, payload: payload, method: 'GET' }).then(function (response) {
                console.log('Success!:', response.data);
                var data = response.data;
                if (!data.error) {
                    this.bannercolor = ['banner', 'landing-banner'];
                    this.bannerbtn = ['btn', 'banner-get-btn'];
                    this.bannerh1 = 'Verified';
                    this.bannerh2 = 'Your account is activated';
                    this.bannerh3 = 'Onboarding mail has been sent to ';
                    this.bannerbtntext = 'SIGN IN';
                    this.bodyp1 = 'Now you can sign in to vendor console and upload content.';
                    this.bodyp2 = 'You shall receive iOS, Android and Web Apps in next 24 hours.';
                    this.bodyp3 = 'Please test and let us know when you ready to go live.';
                    this.loaderStatus = false;
                    this.email = email;
                    this.navurl = this.vendorportalurl;
                    // GTM Code starts
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_EMAIL_VERIFY',
                        'EventCategory': 'VLITE_EMAILVERIFY',
                        'EventAction': 'EmailVerify',
                        'EventLabel': 'EMAIL_VERIFY_SUCCESS',
                        'EventValue': 1,
                        'Email': email,
                        'Status': 'Success'
                    });
                    // End of GTM Code
                } else {
                    if (data.error == 2127) {
                        this.bannercolor = ['banner', 'landing-banner'];
                        this.bannerbtn = ['btn', 'banner-get-btn'];
                        this.bannerh1 = 'Email Already Verified';
                        this.bannerh2 = 'Your account is activated';
                        this.bannerh3 = '';
                        this.bannerbtntext = 'SIGN IN';
                        this.bodyp1 = 'Now you can sign in to vendor console and upload content.';
                        this.bodyp2 = 'You shall receive iOS, Android and Web Apps in next 24 hours.';
                        this.bodyp3 = 'Please test and let us know when you ready to go live.';
                        this.loaderStatus = false;
                        this.email = email;
                        this.navurl = this.vendorportalurl;
                    } else {
                        this.bannercolor = ['banner', 'failed-banner'];
                        this.bannerbtn = ['btn', 'banner-get-btn-failed'];
                        this.bannerh1 = 'Verification Failed';
                        this.bannerh2 = 'Your account is not activated';
                        this.bannerh3 = 'Please Try Again';
                        this.bannerbtntext = 'Try AGAIN';
                        this.bodyp1 = 'Your account not verified because of : ' + data.reason;
                        this.bodyp2 = 'Please try again verify your account';
                        this.bodyp3 = '';
                        this.loaderStatus = false;
                        this.navurl = document.URL;
                        this.email = email;
                    }

                    // GTM Code starts
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_EMAIL_VERIFY',
                        'EventCategory': 'VLITE_EMAILVERIFY',
                        'EventAction': 'EmailVerify',
                        'EventLabel': 'EMAIL_VERIFY_FAILURE',
                        'EventValue': 1,
                        'Email': email,
                        'Status': 'Failed'
                    });
                    // End of GTM Code
                }
            }, function (response) {
                console.log('Error!:', response.data);
                this.bannercolor = ['banner', 'failed-banner'];
                this.bannerbtn = ['btn', 'banner-get-btn-failed'];
                this.bannerh1 = 'Verification Failed';
                this.bannerh2 = 'Your account is not activated';
                this.bannerh3 = 'Please try again';
                this.bannerbtntext = 'TRY AGAIN';
                this.bodyp1 = 'Your account not verified because of Network Error';
                this.bodyp2 = 'Please try again verify your account';
                this.bodyp3 = '';
                this.loaderStatus = false;
                this.navurl = document.URL;
                this.email = email;
                // GTM Code starts
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'VLITE_EMAIL_VERIFY',
                    'EventCategory': 'VLITE_EMAILVERIFY',
                    'EventAction': 'EmailVerify',
                    'EventLabel': 'EMAIL_VERIFY_FAILURE',
                    'EventValue': 1,
                    'Email': email,
                    'Status': 'Failed'
                });
                // End of GTM Code
            });
        },
        navigationBtnGA: function navigationBtnGA(btntext) {
            // var text = 'SIGN IN';
            // if(btntext == 'SIGN IN'){
            //     this.$ga.event({
            //           eventCategory: 'VLITE_EMAILVERIFY',
            //           eventAction: 'SignInFromEmailVerify',
            //           eventLabel: 'VLITE_SIGNIN_EVENT',
            //           eventValue: 1,
            //           'Email': email
            //       });
            // }
            // if(btntext == 'TRY AGAIN'){
            //     this.$ga.event({
            //           eventCategory: 'VLITE_EMAILVERIFY',
            //           eventAction: 'RetryEmailVerify',
            //           eventLabel: 'VLITE_EMAILRETRY_EVENT',
            //           eventValue: 1,
            //           'Email': email
            //       });
            // }

        },
        openUrlTab: function openUrlTab(url) {
            if (this.bannerbtntext == 'Try AGAIN') {
                // GTM Code starts
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'VLITE_EMAIL_VERIFY_RETRY',
                    'EventCategory': 'VLITE_EMAILVERIFY',
                    'EventAction': 'RetryEmailVerify',
                    'EventLabel': 'EMAIL_VERIFY_RETRY',
                    'EventValue': 1,
                    'Email': this.email
                });
                // End of GTM Code
            }
            window.open(url, '_blank');
        },
        openNewTab: function openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        },
        navigateToHomeWithDiv: function navigateToHomeWithDiv(divname) {
            this.$router.push({ name: 'Home', params: { divid: divname } });
        },
        openSocialNewTab: function openSocialNewTab(surl) {
            window.open(surl, '_blank');
        }
    }
});

/***/ }),

/***/ "TGvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("aEfQ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8680d75a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("R7xF");
function injectStyle (ssrContext) {
  __webpack_require__("vv/L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8680d75a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UhIG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UuJc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "V0ik":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "VL+T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MagnifierJS", function() { return MagnifierJS; });
/**
* Magnifier.js is a Javascript library enabling magnifying glass effect on an images.
*
* Features
*
* Zoom in / out functionality using mouse wheel
* Setting options via Javascript or data attributes
* Magnified image can be displayed in the lens itself or outside of it in a wrapper
* Attachment to multiple images with single call
* Attachment of user defined functions for thumbnail entering, moving and leaving and image zooming events
* Display loading text while the large image is being loaded, and switch to lens once its loaded
*
* Magnifier.js uses Event.js as a cross-browser event handling wrapper, which is available at
* Github and JSClasses.org:
*
* Github - https://github.com/mark-rolich/Event.js
* JS Classes - http://www.jsclasses.org/package/212-JavaScript-Handle-events-in-a-browser-independent-manner.html
*
* Works in Chrome, Firefox, Safari, IE 7, 8, 9 & 10.
*
* @author Mark Rolich <mark.rolich@gmail.com>
*/
var MagnifierJS = function MagnifierJS(evt, options) {
    "use strict";

    var gOptions = options || {},
        curThumb = null,
        curData = {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        lensW: 0,
        lensH: 0,
        lensBgX: 0,
        lensBgY: 0,
        largeW: 0,
        largeH: 0,
        largeL: 0,
        largeT: 0,
        zoom: 2,
        zoomMin: 1.1,
        zoomMax: 5,
        mode: 'outside',
        largeWrapperId: gOptions.largeWrapper !== undefined ? gOptions.largeWrapper.id || null : null,
        status: 0,
        zoomAttached: false,
        zoomable: gOptions.zoomable !== undefined ? gOptions.zoomable : false,
        onthumbenter: gOptions.onthumbenter !== undefined ? gOptions.onthumbenter : null,
        onthumbmove: gOptions.onthumbmove !== undefined ? gOptions.onthumbmove : null,
        onthumbleave: gOptions.onthumbleave !== undefined ? gOptions.onthumbleave : null,
        onzoom: gOptions.onzoom !== undefined ? gOptions.onzoom : null
    },
        pos = {
        t: 0,
        l: 0,
        x: 0,
        y: 0
    },
        gId = 0,
        status = 0,
        curIdx = '',
        curLens = null,
        curLarge = null,
        gZoom = gOptions.zoom !== undefined ? gOptions.zoom : curData.zoom,
        gZoomMin = gOptions.zoomMin !== undefined ? gOptions.zoomMin : curData.zoomMin,
        gZoomMax = gOptions.zoomMax !== undefined ? gOptions.zoomMax : curData.zoomMax,
        gMode = gOptions.mode || curData.mode,
        data = {},
        inBounds = false,
        isOverThumb = 0,
        getElementsByClass = function getElementsByClass(className) {
        var list = [],
            elements = null,
            len = 0,
            pattern = '',
            i = 0,
            j = 0;

        if (document.getElementsByClassName) {
            list = document.getElementsByClassName(className);
        } else {
            elements = document.getElementsByTagName('*');
            len = elements.length;
            pattern = new RegExp("(^|\\s)" + className + "(\\s|$)");

            for (i, j; i < len; i += 1) {
                if (pattern.test(elements[i].className)) {
                    list[j] = elements[i];
                    j += 1;
                }
            }
        }

        return list;
    },
        $ = function $(selector) {
        var idx = '',
            type = selector.charAt(0),
            result = null;

        if (type === '#' || type === '.') {
            idx = selector.substr(1, selector.length);
        }

        if (idx !== '') {
            switch (type) {
                case '#':
                    result = document.getElementById(idx);
                    break;
                case '.':
                    result = getElementsByClass(idx);
                    break;
            }
        }

        return result;
    },
        createLens = function createLens(thumb, idx) {
        var lens = document.createElement('div');

        lens.id = idx + '-lens';
        lens.className = 'magnifier-loader';

        thumb.parentNode.appendChild(lens);
    },
        updateLensOnZoom = function updateLensOnZoom() {
        curLens.style.left = pos.l + 'px';
        curLens.style.top = pos.t + 'px';
        curLens.style.width = curData.lensW + 'px';
        curLens.style.height = curData.lensH + 'px';
        curLens.style.backgroundPosition = '-' + curData.lensBgX + 'px -' + curData.lensBgY + 'px';

        curLarge.style.left = '-' + curData.largeL + 'px';
        curLarge.style.top = '-' + curData.largeT + 'px';
        curLarge.style.width = curData.largeW + 'px';
        curLarge.style.height = curData.largeH + 'px';
    },
        updateLensOnLoad = function updateLensOnLoad(idx, thumb, large, largeWrapper) {
        var lens = $('#' + idx + '-lens'),
            textWrapper = null;

        if (data[idx].status === 1) {
            textWrapper = document.createElement('div');
            textWrapper.className = 'magnifier-loader-text';
            lens.className = 'magnifier-loader hidden';

            textWrapper.appendChild(document.createTextNode('Loading...'));
            lens.appendChild(textWrapper);
        } else if (data[idx].status === 2) {
            lens.className = 'magnifier-lens hidden';
            lens.removeChild(lens.childNodes[0]);
            lens.style.background = 'url(' + thumb.src + ') no-repeat 0 0 scroll';

            large.id = idx + '-large';
            large.style.width = data[idx].largeW + 'px';
            large.style.height = data[idx].largeH + 'px';
            large.className = 'magnifier-large hidden';

            if (data[idx].mode === 'inside') {
                lens.appendChild(large);
            } else {
                largeWrapper.appendChild(large);
            }
        }

        lens.style.width = data[idx].lensW + 'px';
        lens.style.height = data[idx].lensH + 'px';
    },
        getMousePos = function getMousePos() {
        var xPos = pos.x - curData.x,
            yPos = pos.y - curData.y,
            t = 0,
            l = 0;

        inBounds = xPos < 0 || yPos < 0 || xPos > curData.w || yPos > curData.h ? false : true;

        l = xPos - curData.lensW / 2;
        t = yPos - curData.lensH / 2;

        if (curData.mode !== 'inside') {
            if (xPos < curData.lensW / 2) {
                l = 0;
            }

            if (yPos < curData.lensH / 2) {
                t = 0;
            }

            if (xPos - curData.w + curData.lensW / 2 > 0) {
                l = curData.w - (curData.lensW + 2);
            }

            if (yPos - curData.h + curData.lensH / 2 > 0) {
                t = curData.h - (curData.lensH + 2);
            }
        }

        pos.l = Math.round(l);
        pos.t = Math.round(t);

        curData.lensBgX = pos.l + 1;
        curData.lensBgY = pos.t + 1;

        if (curData.mode === 'inside') {
            curData.largeL = Math.round(xPos * (curData.zoom - curData.lensW / curData.w));
            curData.largeT = Math.round(yPos * (curData.zoom - curData.lensH / curData.h));
        } else {
            curData.largeL = Math.round(curData.lensBgX * curData.zoom * (curData.largeWrapperW / curData.w));
            curData.largeT = Math.round(curData.lensBgY * curData.zoom * (curData.largeWrapperH / curData.h));
        }
    },
        zoomInOut = function zoomInOut(e) {
        var delta = e.wheelDelta > 0 || e.detail < 0 ? 0.1 : -0.1,
            handler = curData.onzoom,
            multiplier = 1,
            w = 0,
            h = 0;

        if (e.preventDefault) {
            e.preventDefault();
        }

        e.returnValue = false;

        curData.zoom = Math.round((curData.zoom + delta) * 10) / 10;

        if (curData.zoom >= curData.zoomMax) {
            curData.zoom = curData.zoomMax;
        } else if (curData.zoom >= curData.zoomMin) {
            curData.lensW = Math.round(curData.w / curData.zoom);
            curData.lensH = Math.round(curData.h / curData.zoom);

            if (curData.mode === 'inside') {
                w = curData.w;
                h = curData.h;
            } else {
                w = curData.largeWrapperW;
                h = curData.largeWrapperH;
                multiplier = curData.largeWrapperW / curData.w;
            }

            curData.largeW = Math.round(curData.zoom * w);
            curData.largeH = Math.round(curData.zoom * h);

            getMousePos();
            updateLensOnZoom();

            if (handler !== null) {
                handler({
                    thumb: curThumb,
                    lens: curLens,
                    large: curLarge,
                    x: pos.x,
                    y: pos.y,
                    zoom: Math.round(curData.zoom * multiplier * 10) / 10,
                    w: curData.lensW,
                    h: curData.lensH
                });
            }
        } else {
            curData.zoom = curData.zoomMin;
        }
    },
        onThumbEnter = function onThumbEnter() {
        curData = data[curIdx];
        curLens = $('#' + curIdx + '-lens');

        if (curData.status === 2) {
            curLens.className = 'magnifier-lens';

            if (curData.zoomAttached === false) {
                if (curData.zoomable !== undefined && curData.zoomable === true) {
                    evt.attach('mousewheel', curLens, zoomInOut);

                    if (window.addEventListener) {
                        curLens.addEventListener('DOMMouseScroll', function (e) {
                            zoomInOut(e);
                        });
                    }
                }

                curData.zoomAttached = true;
            }

            curLarge = $('#' + curIdx + '-large');
            curLarge.className = 'magnifier-large';
        } else if (curData.status === 1) {
            curLens.className = 'magnifier-loader';
        }
    },
        onThumbLeave = function onThumbLeave() {
        if (curData.status > 0) {
            var handler = curData.onthumbleave;

            if (handler !== null) {
                handler({
                    thumb: curThumb,
                    lens: curLens,
                    large: curLarge,
                    x: pos.x,
                    y: pos.y
                });
            }

            if (curLens.className.indexOf('hidden') === -1) {
                curLens.className += ' hidden';
                curThumb.className = curData.thumbCssClass;

                if (curLarge !== null) {
                    curLarge.className += ' hidden';
                }
            }
        }
    },
        move = function move() {
        if (status !== curData.status) {
            onThumbEnter();
        }

        if (curData.status > 0) {
            curThumb.className = curData.thumbCssClass + ' opaque';

            if (curData.status === 1) {
                curLens.className = 'magnifier-loader';
            } else if (curData.status === 2) {
                curLens.className = 'magnifier-lens';
                curLarge.className = 'magnifier-large';
                curLarge.style.left = '-' + curData.largeL + 'px';
                curLarge.style.top = '-' + curData.largeT + 'px';
            }

            curLens.style.left = pos.l + 'px';
            curLens.style.top = pos.t + 'px';
            curLens.style.backgroundPosition = '-' + curData.lensBgX + 'px -' + curData.lensBgY + 'px';

            var handler = curData.onthumbmove;

            if (handler !== null) {
                handler({
                    thumb: curThumb,
                    lens: curLens,
                    large: curLarge,
                    x: pos.x,
                    y: pos.y
                });
            }
        }

        status = curData.status;
    },
        setThumbData = function setThumbData(thumb, thumbData) {
        var thumbBounds = thumb.getBoundingClientRect(),
            w = 0,
            h = 0;

        thumbData.x = thumbBounds.left;
        thumbData.y = thumbBounds.top;
        thumbData.w = Math.round(thumbBounds.right - thumbData.x);
        thumbData.h = Math.round(thumbBounds.bottom - thumbData.y);

        thumbData.lensW = Math.round(thumbData.w / thumbData.zoom + 100);
        thumbData.lensH = Math.round(thumbData.h / thumbData.zoom + 100);

        if (thumbData.mode === 'inside') {
            w = thumbData.w;
            h = thumbData.h;
        } else {
            w = thumbData.largeWrapperW;
            h = thumbData.largeWrapperH;
        }

        thumbData.largeW = Math.round(thumbData.zoom * w);
        thumbData.largeH = Math.round(thumbData.zoom * h);
    };

    this.attach = function (options) {
        if (options.thumb === undefined) {
            throw {
                name: 'Magnifier error',
                message: 'Please set thumbnail',
                toString: function toString() {
                    return this.name + ": " + this.message;
                }
            };
        }

        var thumb = $(options.thumb),
            i = 0;

        if (thumb.length !== undefined) {
            for (i; i < thumb.length; i += 1) {
                options.thumb = thumb[i];
                this.set(options);
            }
        } else {
            options.thumb = thumb;
            this.set(options);
        }
    };

    this.setThumb = function (thumb) {
        curThumb = thumb;
    };

    this.set = function (options) {
        if (data[options.thumb.id] !== undefined) {
            curThumb = options.thumb;
            return false;
        }

        var thumbObj = new Image(),
            largeObj = new Image(),
            thumb = options.thumb,
            idx = thumb.id,
            zoomable = null,
            largeUrl = null,
            largeWrapper = $('#' + options.largeWrapper) || $('#' + thumb.getAttribute('data-large-img-wrapper')) || $('#' + curData.largeWrapperId),
            zoom = options.zoom || thumb.getAttribute('data-zoom') || gZoom,
            zoomMin = options.zoomMin || thumb.getAttribute('data-zoom-min') || gZoomMin,
            zoomMax = options.zoomMax || thumb.getAttribute('data-zoom-max') || gZoomMax,
            mode = options.mode || thumb.getAttribute('data-mode') || gMode,
            onthumbenter = options.onthumbenter !== undefined ? options.onthumbenter : curData.onthumbenter,
            onthumbleave = options.onthumbleave !== undefined ? options.onthumbleave : curData.onthumbleave,
            onthumbmove = options.onthumbmove !== undefined ? options.onthumbmove : curData.onthumbmove,
            onzoom = options.onzoom !== undefined ? options.onzoom : curData.onzoom;

        if (options.large === undefined) {
            largeUrl = options.thumb.getAttribute('data-large-img-url') !== null ? options.thumb.getAttribute('data-large-img-url') : options.thumb.src;
        } else {
            largeUrl = options.large;
        }

        if (largeWrapper === null && mode !== 'inside') {
            throw {
                name: 'Magnifier error',
                message: 'Please specify large image wrapper DOM element',
                toString: function toString() {
                    return this.name + ": " + this.message;
                }
            };
        }

        if (options.zoomable !== undefined) {
            zoomable = options.zoomable;
        } else if (thumb.getAttribute('data-zoomable') !== null) {
            zoomable = thumb.getAttribute('data-zoomable') === 'true';
        } else if (curData.zoomable !== undefined) {
            zoomable = curData.zoomable;
        }

        if (thumb.id === '') {
            idx = thumb.id = 'magnifier-item-' + gId;
            gId += 1;
        }

        createLens(thumb, idx);

        data[idx] = {
            zoom: zoom,
            zoomMin: zoomMin,
            zoomMax: zoomMax,
            mode: mode,
            zoomable: zoomable,
            thumbCssClass: thumb.className,
            zoomAttached: false,
            status: 0,
            largeUrl: largeUrl,
            largeWrapperId: mode === 'outside' ? largeWrapper.id : null,
            largeWrapperW: mode === 'outside' ? largeWrapper.offsetWidth : null,
            largeWrapperH: mode === 'outside' ? largeWrapper.offsetHeight : null,
            onzoom: onzoom,
            onthumbenter: onthumbenter,
            onthumbleave: onthumbleave,
            onthumbmove: onthumbmove
        };

        evt.attach('mouseover', thumb, function (e, src) {
            if (curData.status !== 0) {
                onThumbLeave();
            }

            curIdx = src.id;
            curThumb = src;

            onThumbEnter(src);

            setThumbData(curThumb, curData);

            pos.x = e.clientX;
            pos.y = e.clientY;

            getMousePos();
            move();

            var handler = curData.onthumbenter;

            if (handler !== null) {
                handler({
                    thumb: curThumb,
                    lens: curLens,
                    large: curLarge,
                    x: pos.x,
                    y: pos.y
                });
            }
        }, false);

        evt.attach('mousemove', thumb, function (e, src) {
            isOverThumb = 1;
        });

        evt.attach('load', thumbObj, function () {
            data[idx].status = 1;

            setThumbData(thumb, data[idx]);
            updateLensOnLoad(idx);

            evt.attach('load', largeObj, function () {
                data[idx].status = 2;
                updateLensOnLoad(idx, thumb, largeObj, largeWrapper);
            });

            largeObj.src = data[idx].largeUrl;
        });

        thumbObj.src = thumb.src;
    };

    evt.attach('mousemove', document, function (e) {
        pos.x = e.clientX;
        pos.y = e.clientY;

        getMousePos();

        if (inBounds === true) {
            move();
        } else {
            if (isOverThumb !== 0) {
                onThumbLeave();
            }

            isOverThumb = 0;
        }
    }, false);

    evt.attach('scroll', window, function () {
        if (curThumb !== null) {
            setThumbData(curThumb, curData);
        }
    });
};

/***/ }),

/***/ "WRdO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRu6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mooc.46f7ae9.jpg";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__("gORT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard__ = __webpack_require__("TGvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Success__ = __webpack_require__("2KHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Failed__ = __webpack_require__("zweM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Emailverify__ = __webpack_require__("KCOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Reqdemo__ = __webpack_require__("JIAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Democonfirm__ = __webpack_require__("6MUd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Test__ = __webpack_require__("ua3t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_fraction_grid__ = __webpack_require__("wIqG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_fraction_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_fraction_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon__ = __webpack_require__("D4uH");















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_fraction_grid___default.a, {
    container: '1200px',
    gutter: '15px',
    approach: 'desktop-first',
    breakpoints: {
        compact: '480px',
        tablet: '768px',
        web: '960px'
    }
});

// register modal component
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('modal', {
    template: '#modal-template'
});

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Home__["default"]
    }, {
        path: '/Dashboard',
        name: 'Dashboard',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard__["default"]
    }, {
        path: '/Success',
        name: 'Success',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Success__["default"]
    }, {
        path: '/Emailverify',
        name: 'Emailverify',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Emailverify__["default"]
    }, {
        path: '/Failed',
        name: 'Failed',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Failed__["default"]
    }, {
        path: '/Test',
        name: 'Test',
        component: __WEBPACK_IMPORTED_MODULE_10__components_Test__["default"]
    }, {
        path: '/Demo',
        name: 'Reqdemo',
        component: __WEBPACK_IMPORTED_MODULE_8__components_Reqdemo__["default"]
    }, {
        path: '/Democonfirm',
        name: 'Democonfirm',
        component: __WEBPACK_IMPORTED_MODULE_9__components_Democonfirm__["default"]
    }]
}));

/***/ }),

/***/ "YzmF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ZYGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _require = __webpack_require__("vgQg"),
    Config = _require.Config;

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            email: 'quizzertv@gmail.com',
            reason: '',
            userdata: {},
            planData: {},
            apibaseurl: '',
            vendorportalurl: ''

        };
    },
    created: function created() {
        this.email = this.$route.params.email;
        this.reason = this.$route.params.reason;
        this.userdata = this.$route.params.userdata;
    },
    mounted: function mounted() {
        // Setting Config URLs
        var con = new Config();
        this.apibaseurl = con.getApiUrl();
        this.vendorportalurl = con.getPortalUrl();
        this.$scrollTo('#failed');

        var thisYear = new Date().getFullYear();
        console.log(document.getElementById('copyrightyear'));
        document.getElementById('copyrightyear').innerHTML = thisYear;
    },

    methods: (_methods = {
        openSocialNewTab: function openSocialNewTab(surl) {
            window.open(surl, '_blank');
        },
        navigateToHomeWithDiv: function navigateToHomeWithDiv(divname) {
            this.$router.push({ name: 'Home', params: { divid: divname } });
        },
        openNewTab: function openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        }
    }, _defineProperty(_methods, 'navigateToHomeWithDiv', function navigateToHomeWithDiv(divname) {
        this.$router.push({ name: 'Home', params: { divid: divname } });
    }), _defineProperty(_methods, 'retryPaymentData', function retryPaymentData() {
        // GTM Code starts
        // Subscription
        if (localStorage.getItem("planobj") === null) {
            this.navigateToHomeWithDiv('plans');
        } else {
            // Retrieve the object from storage
            var planObject = localStorage.getItem('planobj');
            this.planData = JSON.parse(planObject);
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'VLITE_PAYMENT',
            'EventCategory': 'VLITE_PAYMENT',
            'EventAction': 'PaymentRetry',
            'EventLabel': 'PAYMENT_RETRY',
            'EventValue': 1,
            'Name': this.userdata.vendorname,
            'Email': this.userdata.vendoremail,
            'Contact': this.userdata.phone,
            'Mode': this.userdata.mode,
            'Plan': this.planData.planname, //fetch data from localstorage
            'PlanPeriod': this.renewperiod, //fetch data from localstorage
            'Amount': 599, //fetch data from localstorage
            'Status': 'Retry'
        });
        // End of GTM Code
        this.$router.push({ name: 'Dashboard', params: { userdata: this.userdata } });
    }), _methods)
});

/***/ }),

/***/ "aEfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fixed_header__ = __webpack_require__("DAFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fixed_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_fixed_header__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _require = __webpack_require__("nHYM"),
    EventJS = _require.EventJS;

var _require2 = __webpack_require__("VL+T"),
    MagnifierJS = _require2.MagnifierJS;

var _require3 = __webpack_require__("vgQg"),
    Config = _require3.Config;


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ele: '#signupform', 'fixed-header': __WEBPACK_IMPORTED_MODULE_0_vue_fixed_header___default.a },
    data: function data() {
        return {
            showModal: false,
            planData: {},
            formSubmitted: false,
            appname: "",
            appdesc: "",
            name: "",
            supportemail: "",
            email: "",
            emailokflag: true,
            number: "",
            password: "",
            cpassword: "",
            website: "",
            hasurlvalidation: 'required',
            fileuploadLabel: "PNG (recommended 1024x1024 px)",
            loaderStatus: false,
            mainloaderStatus: false,
            fileBtnLabel: 'SELECT FILE',
            dashbasicinfo: ['dashboard-basic', 'dashboard-back-color'],
            dashadmininfo: 'dashboard-admin-info',
            dashiconinput: 'dash-input-icon',
            filename: '',
            keepcardonfile: 'NO',
            renewperiod: 'YEAR',
            logo: '',
            fileuploadlabelcls: 'dash-form-fileup',
            priorplan: '',
            priorplanname: false,
            backupPlan: {},
            skipplanname: '',
            higherplanstatus: false,
            lowerplanstatus: false,
            emailspin: false,
            userdata: {},
            apibaseurl: '',
            vendorportalurl: '',
            stripelogo: '',
            largeimagepath: '',
            normaldevice: true,
            smalldevice: false,
            isFixed: false,
            showfixedheader: false,
            sidebarVisible: false,
            seltype: '',
            customopt: false
        };
    },
    created: function created() {
        this.screenResize();
        this.planData = this.$route.params.plandata;
        this.priorplan = this.$route.params.priorplan;
        this.seltype = this.$route.params.seltype;
        //console.log(this.priorplan);
        if (this.planData === undefined && this.priorplan === undefined) {
            if (localStorage.getItem("planobj") === null) {
                this.navigateToHomeWithDiv('plans');
            } else {
                // Retrieve the object from storage
                var planObject = localStorage.getItem('planobj');
                this.planData = JSON.parse(planObject);
                if (localStorage.getItem("priorplanobj") != null) {
                    var priorplanObject = localStorage.getItem('priorplanobj');
                    this.priorplan = JSON.parse(priorplanObject);
                    this.higherplanstatus = true;
                }
                this.seltype = localStorage.getItem('seltype');
                this.userdata = this.$route.params.userdata;
            }
        } else if (this.planData != '') {
            //Remove exsisting plans
            localStorage.removeItem('planobj');
            localStorage.removeItem('priorplanobj');
            localStorage.removeItem('seltype');
            // Put the object into storage
            localStorage.setItem('planobj', JSON.stringify(this.planData));
            if (this.priorplan == '') {
                this.priorplanname = this.planData.planname;
            } else {
                // Put the object into storage
                localStorage.setItem('priorplanobj', JSON.stringify(this.priorplan));
                this.priorplanname = this.priorplan.planname;
                this.higherplanstatus = true;
            }
            localStorage.setItem('seltype', this.seltype);
        } else {}
        //console.log(this.planData);
        document.getElementById('app').scrollIntoView();
        // this.dynamicClass = 'c100 p10 big';
        // this.percent=10;
    },
    mounted: function mounted() {
        // Setting Config URLs
        var con = new Config();
        this.apibaseurl = con.getApiUrl();
        this.vendorportalurl = con.getPortalUrl();
        this.stripelogo = con.getStripeLogo();
        this.largeimagepath = con.getlargeImgPath();

        var evt = new EventJS(),
            mg = new MagnifierJS(evt, {
            largeWrapper: document.getElementById('casualimg')
        });
        mg.attach({
            thumb: '#thumb-inside',
            // large: 'https://www.research.bayer.com/img/facebook/27/wissenschaft-facebook-1200x1200.jpg',
            largeWrapper: 'preview',
            zoom: 3,
            zoomable: false
        });

        var evtm = new EventJS(),
            mgm = new MagnifierJS(evtm, {
            largeWrapper: document.getElementById('modernimg')
        });
        mg.attach({
            thumb: '#thumb-modern-inside',
            // large: 'https://www.research.bayer.com/img/facebook/27/wissenschaft-facebook-1200x1200.jpg',
            largeWrapper: 'preview',
            zoom: 3,
            zoomable: false
        });

        var self = this;
        window.addEventListener('scroll', function (e) {
            // console.log('came');
            var wheight = window.pageYOffset;
            var x = document.querySelector('#headerelement').clientHeight;
            // console.log(wheight+'  '+x);
            var tlimit = x + 120;
            if (x < wheight) {
                self.showfixedheader = true;
                // console.log('show f header');
            } else {
                self.showfixedheader = false;
                // console.log('show n header');
            }
        });

        // document.gambitGalleryIsInView = function( el ) {
        // 	var viewport = {};
        //     viewport.top = window.pageYOffset;
        //     viewport.bottom = viewport.top + window.innerHeight;
        //
        //     var bounds = {};
        // 	bounds.top = el.getBoundingClientRect().top + window.pageYOffset
        // 	bounds.bottom = bounds.top + el.clientHeight;
        //
        // 	return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
        // 		|| (bounds.top <= viewport.bottom && bounds.top >= viewport.top );
        // };
        console.log(this.seltype);
        var inputElements = document.getElementsByName("type");
        for (var i = 0; inputElements[i]; ++i) {
            if (inputElements[i].value == this.seltype) {
                inputElements[i].checked = true;
                break;
            }
        }

        this.customoptionshow();

        var thisYear = new Date().getFullYear();
        // console.log(document.getElementById('copyrightyear'));
        document.getElementById('copyrightyear').innerHTML = thisYear;

        this.restoreData();
    },

    watch: {
        '$mq.resize': 'screenResize'
    },
    methods: {
        mouselog: function mouselog(action, id) {
            if (action == 'enter') {
                var des = document.getElementById(id);
                if (!document.getElementById(id).className.split(" ").indexOf("hidden") >= 0) {
                    // des.className += " casual-dark";
                    des.classList.remove("hidden");
                }
            }

            if (action == 'leave') {
                var des = document.getElementById(id);
                if (!document.getElementById(id).className.split(" ").indexOf("hidden") <= 0) {
                    des.className += " hidden";
                    // des.classList.remove("hidden");
                }
            }
        },
        customoptionshow: function customoptionshow() {
            if (this.seltype == 'MOOC') {
                if (this.planData.planname == 'STARTER') {
                    this.customopt = false;
                } else {
                    this.customopt = true;
                }
            }
        },
        toggleSidebar: function toggleSidebar() {
            this.sidebarVisible = !this.sidebarVisible;
        },
        screenResize: function screenResize() {
            var scsize = screen.width;
            console.log(scsize);
            if (scsize >= 1200) {
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 1199 && scsize >= 768) {
                this.fileuploadlabelcls = 'dash-form-fileup-tab';
                this.dashbasicinfo = ['dashboard-basic', 'dashboard-back-color'];
                this.dashadmininfo = 'dashboard-admin-info';
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 767 && scsize >= 601) {
                this.fileuploadlabelcls = 'dash-form-fileup-tab';
                this.dashbasicinfo = ['dashboard-basic-plain', 'dashboard-back-color'];
                this.dashadmininfo = 'dashboard-admin-info-plain';
                this.dashiconinput = 'dash-input-icon-tab';
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 600 && scsize >= 481) {
                this.fileuploadlabelcls = 'dash-form-fileup-tab';
                this.dashbasicinfo = ['dashboard-basic-plain', 'dashboard-back-color'];
                this.dashadmininfo = 'dashboard-admin-info-plain';
                this.dashiconinput = 'dash-input-icon-tab';
                this.normaldevice = false;
                this.smalldevice = true;
            } else if (scsize <= 480) {
                this.fileuploadlabelcls = 'dash-form-fileup-mob';
                this.dashbasicinfo = ['dashboard-basic-plain', 'dashboard-back-color'];
                this.dashadmininfo = 'dashboard-admin-info-plain';
                this.dashiconinput = 'dash-input-icon-tab';
                this.normaldevice = false;
                this.smalldevice = true;
            }
        },
        reseturldata: function reseturldata(flag) {
            if (flag == 'NO') {
                document.getElementById("url").value = "";
                this.userdata.url = "";
                this.website = "";
                document.getElementById('url').setAttribute("disabled", "true");
            } else {
                document.getElementById('url').removeAttribute("disabled");
            }
        },
        checkout: function checkout() {
            this.validateBeforeSubmit();
            if (this.formSubmitted) {
                var amount = this.planData.yearlydiscountedprice;
                var inputElements = document.getElementsByName("renewperiod");

                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].checked) {
                        console.log(inputElements[i].value);
                        if (inputElements[i].value == 'MONTH') {
                            amount = this.planData.monthlydiscountedprice;
                            this.renewperiod = 'MONTH';
                            console.log(amount);
                        }
                        break;
                    }
                }

                this.$checkout.open({
                    name: 'VLITE Purchase',
                    currency: 'USD',
                    amount: amount,
                    image: this.stripelogo,
                    //   shippingAddress: true,
                    billingAddress: true,
                    token: function token(_token) {
                        //   console.log(token);
                        document.getElementById('cctoken').value = _token.id;
                        // document.getElementById('cctoken').value = 123456;
                        document.getElementById('addressLine').value = _token.card.address_line1;
                        document.getElementById('addressCity').value = _token.card.address_city;
                        document.getElementById('addressCountry').value = _token.card.address_country;
                        document.getElementById('addressPincode').value = _token.card.address_zip;
                        //document.getElementById('signupform').submit();
                        document.getElementById('FbtnSubmit').click();
                    }
                });
            } else {
                //   console.log('Form Error');
            }
        },

        onFormSubmit: function onFormSubmit(event) {
            this.mainloaderStatus = true;
            var token = document.getElementById('cctoken').value;
            if (token) {
                this.keepcardonfile = 'YES';
            }
            var formData = new FormData();
            var userdata = new Object();
            //vendor mode checking
            var vendormode = 'LITE';
            var inputElements = document.getElementsByName("type");
            for (var i = 0; inputElements[i]; ++i) {
                if (inputElements[i].checked) {
                    if (inputElements[i].value == 'MOOC') {
                        vendormode = 'MOOC';
                        break;
                    }
                }
            }
            // levelenabled
            var levelenabled = 'NO';
            var inputlevel = document.getElementsByName("levelenabled");
            for (var i = 0; inputlevel[i]; ++i) {
                if (inputlevel[i].checked) {
                    if (inputlevel[i].value == 'YES') {
                        levelenabled = 'YES';
                        break;
                    }
                }
            }
            // institute enabled
            var instituteenabled = 'NO';
            var inputinstitute = document.getElementsByName("instituteenabled");
            for (var i = 0; inputinstitute[i]; ++i) {
                if (inputinstitute[i].checked) {
                    if (inputinstitute[i].value == 'YES') {
                        instituteenabled = 'YES';
                        break;
                    }
                }
            }
            //bulk enabled
            var bulkentroll = 'NO';
            var inputbulk = document.getElementsByName("bulkenrollenabled");
            for (var i = 0; inputbulk[i]; ++i) {
                if (inputbulk[i].checked) {
                    if (inputbulk[i].value == 'YES') {
                        bulkentroll = 'YES';
                        break;
                    }
                }
            }
            formData.append('logo', this.logo);
            formData.append('renewperiod', this.renewperiod);
            formData.append('planid', this.planData.planid);
            formData.append('vendormode', vendormode);
            formData.append('streamenabled', 'YES');
            formData.append('adenabled', 'NO');
            formData.append('paymentenabled', 'YES');
            formData.append('drmenabled', 'NO');
            formData.append('hdenabled', 'YES');
            formData.append('appname', 'YES');
            formData.append('instituteenabled', instituteenabled);
            formData.append('levelenabled', levelenabled);
            formData.append('bulkenrollenabled', bulkentroll);

            //extra info passing as a array
            var others = [];
            var appname = document.getElementById('appname').value;
            var appdesc = document.getElementById('appdesc').value;
            var fb = document.getElementById('fb').value;
            var gp = document.getElementById('gp').value;
            var tw = document.getElementById('tw').value;
            var addressLine = document.getElementById('addressLine').value;
            var addressCity = document.getElementById('addressCity').value;
            var addressCountry = document.getElementById('addressCountry').value;
            var addressPincode = document.getElementById('addressPincode').value;
            var contactno = document.getElementById('phone').value;
            //vendor mode checking
            var vendorAppMode = 'Casual';
            var vendorAppTheme = 'Light';
            var inputElements = document.getElementsByName("mode");
            for (var i = 0; inputElements[i]; ++i) {
                if (inputElements[i].checked) {
                    if (inputElements[i].value == 'Modern') {
                        vendorAppMode = 'Modern';
                        break;
                    }
                }
            }
            if (vendorAppMode == 'Modern') {
                var lfckv = document.getElementById("modern").checked;
                if (lfckv) {
                    vendorAppTheme = 'Dark';
                }
            } else {
                var lfckv = document.getElementById("casual").checked;
                if (lfckv) {
                    vendorAppTheme = 'Dark';
                }
            }

            var vendorApp = vendorAppMode + ' - ' + vendorAppTheme;

            others.push({ appname: appname, appdesc: appdesc, fb: fb, gp: gp, tw: tw, addressLine: addressLine, addressCity: addressCity, addressCountry: addressCountry, addressPincode: addressPincode, vendorApp: vendorApp, contactno: contactno });
            formData.append('other', JSON.stringify(others));
            //console.log(others);

            if (this.formSubmitted) {
                var Form = document.getElementById("signupform");
                for (var i = 0; i < Form.elements.length; i++) {
                    var key = Form.elements[i].name;
                    if (key == "vendorname" || key == "website" || key == "password" || key == "vendoremail" || key == "cctoken" || key == "keepcardonfile") {
                        formData.append(key, Form.elements[i].value);
                        // console.log(Form.elements[i].name+' : '+Form.elements[i].value);
                    }
                }

                var supportemail = document.getElementById('supportemail').value;
                formData.append('appname', appname);
                formData.append('supportemail', supportemail);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = formData.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var value = _step.value;

                        console.log(value);
                    }

                    //make object for payment roll backupPlan
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                userdata.appname = appname;
                userdata.appdesc = appdesc;
                userdata.vendormode = vendormode;
                userdata.filename = this.filename;
                userdata.filetext = this.fileuploadLabel;
                userdata.logo = this.logo;
                userdata.mode = vendorAppMode;
                userdata.modetheme = vendorAppTheme;
                userdata.fb = fb;
                userdata.gp = gp;
                userdata.tw = tw;
                userdata.vendorname = document.getElementById('vendorname').value;
                userdata.vendoremail = document.getElementById('vendoremail').value;
                userdata.phone = document.getElementById('phone').value;
                userdata.password = document.getElementById('password').value;
                userdata.url = document.getElementById('url').value;
                userdata.supportemail = supportemail;
                userdata.renewperiod = this.renewperiod;
                //make object for payment roll backupPlan---End
                //  console.log(userdata);
                this.submitForm(formData, vendormode, userdata);
            }
        },
        navigateToHome: function navigateToHome() {
            this.$router.push('/');
        },
        navigateToHomeWithDiv: function navigateToHomeWithDiv(divname) {
            this.toggleSidebar = false;
            this.$router.push({ name: 'Home', params: { divid: divname } });
        },
        changecasualtheme: function changecasualtheme() {
            var casual = document.getElementById('casual');
            var des = document.getElementById('casualimg');
            // remove last appended lens
            var parent = document.getElementById("thumb-inside-lens");
            var child = document.getElementById("thumb-inside-large");
            if (child != null) {
                parent.removeChild(child);
            }
            if (casual.checked) {
                var des = document.getElementById('casualimg');
                if (!document.getElementById('casualimg').className.split(" ").indexOf("casual-light") >= 0) {
                    des.className += " casual-dark";
                    des.classList.remove("casual-light");
                    // image zoom change
                    document.getElementById('thumb-inside').setAttribute("data-large-img-url", this.largeimagepath + "/casual-dark-large.jpg");
                }
            } else {
                var des = document.getElementById('casualimg');
                if (!document.getElementById('casualimg').className.split(" ").indexOf("casual-dark") >= 0) {
                    des.className += " casual-light";
                    des.classList.remove("casual-dark");
                    // image zoom change
                    // console.log('zoom change to unchecked');
                    document.getElementById('thumb-inside').setAttribute("data-large-img-url", this.largeimagepath + "/casual-light-large.jpg");
                }
            }
            var evt = new EventJS(),
                mgchk = new MagnifierJS(evt);
            mgchk.attach({
                thumb: '#thumb-inside',
                largeWrapper: 'preview',
                zoom: 3,
                zoomable: false
            });
        },
        changemodrentheme: function changemodrentheme() {

            var casual = document.getElementById('modern');
            var des = document.getElementById('modernimg');
            // remove last appended lens
            var parent = document.getElementById("thumb-modern-inside-lens");
            var child = document.getElementById("thumb-modern-inside-large");
            if (child != null) {
                parent.removeChild(child);
            }
            if (casual.checked) {
                if (!document.getElementById('modernimg').className.split(" ").indexOf("modern-light") >= 0) {
                    des.className += " modern-dark";
                    des.classList.remove("modern-light");
                    // image zoom change
                    document.getElementById('thumb-modern-inside').setAttribute("data-large-img-url", this.largeimagepath + "/modern-dark-large.jpg");
                }
            } else {
                if (!document.getElementById('modernimg').className.split(" ").indexOf("modern-dark") >= 0) {
                    des.className += " modern-light";
                    des.classList.remove("modern-dark");
                    // image zoom change
                    // console.log('morden zoom change to unchecked');
                    document.getElementById('thumb-modern-inside').setAttribute("data-large-img-url", this.largeimagepath + "/modern-light-large.jpg");
                }
            }
            var evt = new EventJS(),
                mgchk = new MagnifierJS(evt);
            mgchk.attach({
                thumb: '#thumb-modern-inside',
                largeWrapper: 'preview',
                zoom: 3,
                zoomable: false
            });
        },
        validateBeforeSubmit: function validateBeforeSubmit(e) {
            var fileflag = true;
            this.$validator.validateAll();

            var filecls = document.getElementById("logofilebtn");
            if (this.filename == "") {
                //add file error class
                if (filecls.className.split(" ").indexOf("dash-form-fileup-error") <= 0) {
                    filecls.className += " dash-form-fileup-error";
                }
                fileflag = false;
            } else {
                //remove file error class
                if (filecls.className.split(" ").indexOf("dash-form-fileup-error") >= 0) {
                    filecls.classList.remove("dash-form-fileup-error");
                }
                fileflag = true;
            }

            if (!this.errors.any()) {
                if (!this.emailokflag) {
                    this.$scrollTo('#vendoremaildiv');
                    return false;
                }
                if (!fileflag) {
                    this.$scrollTo('#fileupload-div');
                    return false;
                }
                // console.log('No error');
                var terms = document.getElementById("agree").checked;
                console.log("Terms======" + terms);
                var inputElements = document.getElementsByName("link");
                var url = document.getElementById('url').value;
                var website = "";
                var wflag = true;
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].checked) {
                        website = inputElements[i].value;
                    }
                }

                if (website == 'Yes') {
                    //validate website url
                    console.log('website yes');
                    var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
                    if (!pattern.test(url)) {
                        document.getElementById('url').setAttribute("class", "dash-form-text-val dash-form-url left white width-100 has-error");
                        wflag = false;
                        this.$scrollTo('#urldiv');
                    } else {
                        document.getElementById('url').setAttribute("class", "dash-form-text-val dash-form-url left white width-100");
                    }
                } else {
                    document.getElementById('url').setAttribute("class", "dash-form-text-val dash-form-url left white width-100");
                }

                if (!terms) {
                    document.getElementById('terms').setAttribute("class", "control__indicator red-border");
                    this.formSubmitted = false;
                } else {
                    document.getElementById('terms').setAttribute("class", "control__indicator");
                }

                console.log(terms + '  ' + wflag + ' ' + fileflag);

                if (terms && wflag && fileflag) {
                    this.formSubmitted = true;
                } else {
                    this.formSubmitted = false;
                    // need to set agree checkbox red
                    return false;
                }
            } else {
                var errors = this.errors.all();
                console.log(errors);
                if (errors[0].includes("appname") || errors[0].includes("appdesc")) {
                    this.$scrollTo('#basicinfobox');
                } else if (errors[0].includes("name") || errors[0].includes("email") || errors[0].includes("number") || errors[0].includes("password")) {
                    this.$scrollTo('#admininfobox');
                }
                this.formSubmitted = false;
                return false;
            }
        },
        usecaseChange: function usecaseChange(mode) {
            this.seltype = mode;
            if (mode == 'MOOC') {
                if (this.planData.planname == 'STARTER') {
                    this.customopt = false;
                } else {
                    this.customopt = true;
                }
            } else {
                this.customopt = false;
            }
        },
        themeChange: function themeChange(mode) {
            var element = "";
            // console.log(element.classList);
            if (mode == 'casual') {
                element = document.getElementById('modern-con').getElementsByTagName('label')[0];
                document.getElementById('modern').setAttribute("disabled", "true");
                element.classList.add('lbl-disabled');
                element.classList.remove('lbl');
            } else {
                element = document.getElementById('modern-con').getElementsByTagName('label')[0];
                document.getElementById('modern').removeAttribute("disabled");
                element.classList.add('lbl');
                element.classList.remove('lbl-disabled');
            }

            if (mode == 'modern') {
                element = document.getElementById('casual-con').getElementsByTagName('label')[0];
                document.getElementById('casual').setAttribute("disabled", "true");
                element.classList.add('lbl-disabled');
                element.classList.remove('lbl');
            } else {
                element = document.getElementById('casual-con').getElementsByTagName('label')[0];
                document.getElementById('casual').removeAttribute("disabled");
                element.classList.add('lbl');
                element.classList.remove('lbl-disabled');
            }
        },
        submitForm: function submitForm(data, mode, userdata) {

            var retrievedObject = localStorage.getItem('themeObject');
            var resobj = JSON.parse(retrievedObject);
            var theme = new Date(resobj.number);
            var ver = 'A';
            if (theme % 2 != 0) {
                ver = 'B';
            }

            var amount = 0;
            if (this.renewperiod == 'YEAR') {
                amount = this.planData.yearlydiscountedprice;
            }
            if (this.renewperiod == 'MONTH') {
                amount = this.planData.monthlydiscountedprice;
            }
            var url = this.apibaseurl + '/vendor/v1/signup';
            var formData = data;
            //var hurl = window.location.protocol+"//"+url;
            var hurl = url;
            var email = data.get('vendoremail');
            this.$http.post(hurl, formData).then(function (response) {
                console.log("Success" + response.data);
                var result = response.data;
                if (result.success) {
                    // GTM Code starts
                    // Subscription
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_SUBSCRIPTION',
                        'EventCategory': 'VLITE_SUBSCRIPTION',
                        'EventAction': 'Subscription',
                        'EventLabel': 'SIGNUP_SUCCESS',
                        'EventValue': 1,
                        'Name': this.name,
                        'Email': this.email,
                        'Contact': this.number,
                        'Mode': mode,
                        'Plan': this.planData.planname,
                        'PlanPeriod': this.renewperiod,
                        'Status': 'Success',
                        'Version': ver
                    });
                    // Payment
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_SUBSCRIPTION',
                        'EventCategory': 'VLITE_SUBSCRIPTION',
                        'EventAction': 'Payment',
                        'EventLabel': 'PAYMENT_SUCCESS',
                        'EventValue': 1,
                        'Name': this.name,
                        'Email': this.email,
                        'Contact': this.number,
                        'Mode': mode,
                        'Plan': this.planData.planname,
                        'PlanPeriod': this.renewperiod,
                        'Amount': amount,
                        'Status': 'Success',
                        'Version': ver
                    });
                    // End of GTM Code
                    this.mainloaderStatus = false;
                    //Remove exsisting plans
                    localStorage.removeItem('planobj');
                    localStorage.removeItem('priorplanobj');
                    this.$router.push({ name: 'Success', params: { plandata: this.planData, vendorid: result.success, email: email } });
                } else {
                    // GTM Code starts
                    // Subscription
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_SUBSCRIPTION',
                        'EventCategory': 'VLITE_SUBSCRIPTION',
                        'EventAction': 'Subscription',
                        'EventLabel': 'SIGNUP_FAILED',
                        'EventValue': 1,
                        'Name': this.name,
                        'Email': this.email,
                        'Contact': this.number,
                        'Mode': mode,
                        'Plan': this.planData.planname,
                        'PlanPeriod': this.renewperiod,
                        'Status': 'Failed',
                        'Version': ver
                    });
                    // Payment
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_SUBSCRIPTION',
                        'EventCategory': 'VLITE_SUBSCRIPTION',
                        'EventAction': 'Payment',
                        'EventLabel': 'PAYMENT_FAILED',
                        'EventValue': 1,
                        'Name': this.name,
                        'Email': this.email,
                        'Contact': this.number,
                        'Mode': mode,
                        'Plan': this.planData.planname,
                        'PlanPeriod': this.renewperiod,
                        'Amount': amount,
                        'Status': 'Failed',
                        'Version': ver
                    });
                    // End of GTM Code
                    this.mainloaderStatus = false;
                    this.$router.push({ name: 'Failed', params: { plandata: this.planData, reason: result.reason, email: email, userdata: userdata } });
                }
            }, function (response) {
                // GTM Code starts
                // Subscription
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'VLITE_SUBSCRIPTION',
                    'EventCategory': 'VLITE_SUBSCRIPTION',
                    'EventAction': 'Subscription',
                    'EventLabel': 'SIGNUP_FAILED',
                    'EventValue': 1,
                    'Name': this.name,
                    'Email': this.email,
                    'Contact': this.number,
                    'Mode': mode,
                    'Plan': this.planData.planname,
                    'PlanPeriod': this.renewperiod,
                    'Status': 'Failed',
                    'Version': ver
                });
                // End of GTM Code
                this.mainloaderStatus = false;
                this.$router.push({ name: 'Failed', params: { plandata: this.planData, reason: 'Some Error Occured', email: email, userdata: userdata } });
            });
        },
        changeUrlValidation: function changeUrlValidation(value) {
            if (value) {
                document.getElementById('url').setAttribute("data-vv-rules", "required");
            } else {
                document.getElementById('url').setAttribute("data-vv-rules", "none");
            }
        },
        fileUpload: function fileUpload() {
            var elmnt = document.getElementById("fileupload-div");
            elmnt.scrollIntoView();
            var url = this.apibaseurl + '/vendor/v1/fileupload';
            var fileval = document.getElementById("fileup");

            var filePath = fileval.value;
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(filePath)) {
                document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                self.fileuploadLabel = "File Format Not Supported(png/jpg/jpeg).";
                return false;
            }

            var files = fileval.files;
            // console.log(files[0]);
            var reader = new FileReader();
            var self = this;
            var filecls = document.getElementById("logofilebtn");

            if (files[0].size > 3145728) {
                document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                self.fileuploadLabel = "File Max Size 3MB Supported.";
                return false;
            }
            //Read the contents of Image File.
            reader.readAsDataURL(files[0]);
            reader.onload = function (e) {
                //Initiate the JavaScript Image object.
                var image = new Image();

                //Set the Base64 string return from FileReader as source.
                image.src = e.target.result;

                //Validate the File Height and Width.
                image.onload = function () {
                    var height = this.height;
                    var width = this.width;
                    if (height < 1024 || width < 1024) {
                        document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                        self.fileuploadLabel = "Min Image resolution Should 1024*1024";
                    } else {
                        // console.log('success');
                        self.loaderStatus = true;
                        document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10");
                        // var hurl = window.location.protocol+"//"+url;
                        var hurl = url;
                        var formData = new FormData();
                        formData.append('filename', files[0]);
                        formData.append('mode', 'guest');
                        var config = { headers: { 'Content-Type': 'multipart/form-data' } };
                        self.fileuploadLabel = "Uploading..." + files[0].name;
                        self.$http.post(hurl, formData, config).then(function (response) {
                            self.loaderStatus = false;
                            self.fileBtnLabel = "CHANGE";
                            //changing error class
                            if (filecls.className.split(" ").indexOf("dash-form-fileup-error") >= 0) {
                                filecls.classList.remove("dash-form-fileup-error");
                            }
                            console.log("Success" + response.data);
                            var result = response.data;
                            if (result.success) {
                                self.fileuploadLabel = files[0].name + " Success.";
                                self.filename = files[0].name;
                                self.logo = result.success;
                            } else {
                                document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                                self.fileuploadLabel = " Failed " + result.reason;
                            }
                        }, function (response) {
                            self.loaderStatus = false;
                            document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                            self.fileuploadLabel = "Oops! Try Again";
                            //   console.log("Failed");
                        });
                    }
                };
            };
        },
        openNewTab: function openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        },
        openSocialNewTab: function openSocialNewTab(surl) {
            window.open(surl, '_blank');
        },
        switchTopriorPlan: function switchTopriorPlan() {
            if (this.priorplan == '' || this.planData.planid == this.priorplan.planid) {
                this.planData = this.planData;
            } else {
                this.skipplanname = this.planData.planname;
                this.backupPlan = this.planData;
                this.planData = this.priorplan;
                this.lowerplanstatus = true;
            }
            this.customoptionshow();
        },
        switchBackTopriorPlan: function switchBackTopriorPlan() {
            if (this.backupPlan != '') {
                this.skipplanname = "";
                this.planData = this.backupPlan;
                this.lowerplanstatus = false;
            }
            this.customoptionshow();
            //  console.log(this.planData);
        },
        emailPrecheck: function emailPrecheck() {
            var des = document.getElementById('vendoremail');
            var deslabel = document.getElementById('vendoremail-label');
            var successClasslabel = deslabel.classList.contains('has-success-label-text');
            if (successClasslabel) {
                deslabel.classList.remove("has-success-label-text");
            }
            var dangerClasslabel = deslabel.classList.contains('has-error-label-text');
            if (dangerClasslabel) {
                deslabel.classList.remove("has-error-label-text");
            }
            var emailval = des.value;
            if (emailval.replace(/\s/g, "").length == 0) {
                this.emailokflag = false;
                //  var hasDangerClass = des.classList.contains('has-error');
                //  if(hasDangerClass){
                //      des.classList.remove("has-error");
                //  }
                document.getElementById('vendoremail-label').innerHTML = 'Your email id';
            } else {
                var email = document.getElementById('vendoremail').value;
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(email)) {
                    //API Call to check email avaliablility
                    //  var url = this.apibaseurl+'/vendor/v1/signup/emailverify';
                    var hurl = this.apibaseurl + '/vendor/v1/signup/emailprecheck?email=' + email;
                    var payload = {};
                    var protocol = window.location.protocol;
                    this.emailspin = true;
                    this.$http({ url: hurl, payload: payload, method: 'GET' }).then(function (response) {
                        console.log('Success!:', response.data);
                        this.emailspin = false;

                        var data = response.data;
                        if (data.error) {
                            if (data.error == 2128 || data.error == 2129 || data.error == 2130 || data.error == 2131) {

                                var hasSuccessClasslabel = deslabel.classList.contains('has-success-label-text');
                                if (!hasSuccessClasslabel) {
                                    deslabel.classList.remove("has-success-label-text");
                                }

                                var hasDangerClass = des.classList.contains('has-error');
                                if (!hasDangerClass) {
                                    des.className += " has-error";
                                }
                                var hasDangerClasslabel = deslabel.classList.contains('has-error-label-text');
                                if (!hasDangerClasslabel) {
                                    deslabel.className += " has-error-label-text";
                                }

                                document.getElementById('vendoremail-label').innerHTML = 'Email Id  Not Avaliable';
                            }
                            this.emailokflag = false;
                        } else {
                            var hasDangerClass = des.classList.contains('has-error');
                            if (hasDangerClass) {
                                des.classList.remove("has-error");
                            }
                            var hasDangerClasslabel = deslabel.classList.contains('has-error-label-text');
                            if (!hasDangerClasslabel) {
                                deslabel.classList.remove("has-error-label-text");
                            }
                            var hasSuccessClasslabel = deslabel.classList.contains('has-success-label-text');
                            if (!hasSuccessClasslabel) {
                                deslabel.className += " has-success-label-text";
                            }
                            document.getElementById('vendoremail-label').innerHTML = 'Email Id Avaliable';
                            this.emailokflag = true;
                        }
                    }, function (response) {
                        console.log('Error!:', response.data);
                        this.emailokflag = false;
                        this.emailspin = false;
                        var hasDangerClass = des.classList.contains('has-error');
                        if (!hasDangerClass) {
                            des.className += " has-error";
                        }
                        var hasSuccessClasslabel = deslabel.classList.contains('has-success-label-text');
                        if (!hasSuccessClasslabel) {
                            deslabel.classList.remove("has-success-label-text");
                        }
                        var hasDangerClasslabel = deslabel.classList.contains('has-error-label-text');
                        if (!hasDangerClasslabel) {
                            deslabel.className += " has-error-label-text";
                        }
                        document.getElementById('vendoremail-label').innerHTML = 'Oops! Try again...';
                    });
                } else {
                    this.emailokflag = false;
                }
            }
        },
        restoreData: function restoreData() {
            if (Object.keys(this.userdata).length > 0) {
                //   console.log(this.userdata);
                this.appname = this.userdata.appname;
                this.appdesc = this.userdata.appdesc;
                document.getElementById('fb').value = this.userdata.fb;
                document.getElementById('gp').value = this.userdata.gp;
                document.getElementById('tw').value = this.userdata.tw;
                this.name = this.userdata.vendorname;
                this.email = this.userdata.vendoremail;
                this.number = this.userdata.phone;
                this.password = this.userdata.password;
                this.cpassword = this.userdata.password;
                this.website = this.userdata.url;
                this.filename = this.userdata.filename;
                this.fileuploadLabel = this.userdata.filetext;
                this.logo = this.userdata.logo;
                this.fileBtnLabel = "CHANGE";
                var inputElements = document.getElementsByName("type");
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].value == this.userdata.vendormode) {
                        inputElements[i].checked = true;
                        break;
                    }
                }
                inputElements = document.getElementsByName("mode");
                var str = this.userdata.mode;
                var restr = str.toLowerCase(restr);
                this.themeChange(restr);
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].value == this.userdata.mode) {
                        inputElements[i].checked = true;
                        if (inputElements[i].value == 'Modern' && this.userdata.modetheme == 'Dark') {
                            document.getElementById("modern").checked = true;
                            this.changemodrentheme();
                        }
                        if (inputElements[i].value == 'Casual' && this.userdata.modetheme == 'Dark') {
                            document.getElementById("modern").checked = true;
                            this.changecasualtheme();
                        }
                        break;
                    }
                }

                inputElements = document.getElementsByName("renewperiod");
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].value == this.userdata.renewperiod) {
                        inputElements[i].checked = true;
                        break;
                    }
                }

                this.$scrollTo('#billingdiv');
            }
        }
    }
});

/***/ }),

/***/ "aGEH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "aUqx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI4IDI5Ij4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTE2LjU3OCAyOC4zMjZINy4wNzRDMy4xNjcgMjguMzI2IDAgMjUuMTczIDAgMjEuMjgzVjcuMDQzQzAgMy4xNTMgMy4xNjcgMCA3LjA3NCAwaDkuNTA0YzMuOTA3IDAgNy4wNzQgMy4xNTMgNy4wNzQgNy4wNDN2MTQuMjRjMCAzLjg5LTMuMTY3IDcuMDQzLTcuMDc0IDcuMDQzIiBvcGFjaXR5PSIuNCIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNi41NzggMjguMzI2SDcuMDc0QzMuMTY3IDI4LjMyNiAwIDI1LjE3MyAwIDIxLjI4M3YtNy4wNzdsMjMuNjUyLS4wNDN2Ny4xMmMwIDMuODktMy4xNjcgNy4wNDMtNy4wNzQgNy4wNDMiIG9wYWNpdHk9Ii40Ii8+CiAgICAgICAgPHBhdGggZD0iTTIyLjMyIDE0LjMzOGEuMzE1LjMxNSAwIDAgMS0uMTM1LjExbC02LjMyMiAzLjQ4N2MtLjIwNC4xMTMtLjM3LS4wMzctLjM3LS4yNzV2LTYuOTcyYzAtLjIzNy4xNjItLjM4Ny4zNy0uMjc0bDYuMzc1IDMuNDg2Yy4xNDQuMDk5LjE4LjI5NS4wODIuNDM4ek0xNC4wNzYgNS40M2wxLjUyNSAxLjUxOS0xLjc5LjM4LTEuNTI1LTEuNTE2IDEuNzktLjM4M3ptMy44NjYtLjgyM2wxLjUyNSAxLjUxOS0xLjc5LjM4LTEuNTI1LTEuNTE4IDEuNzktLjM4em0zLjg2NS0uODIzbDEuNTI1IDEuNTE5LTEuNzkuMzgtMS41MjUtMS41MTggMS43OS0uMzh6bTQuMTAxLS44N2EuMzQuMzQgMCAwIDEgLjQwMy4yNmwuMzA3IDEuNDMyLTEuMjEuMjU4LTEuNTI2LTEuNTE5IDIuMDI2LS40M3pNMTEuNTk3IDguMTMzbDE1LjQyNi0zLjI4Ni0uNDM0LTEuOTg4YS4zOTQuMzk0IDAgMCAwLS40NjctLjMwMUw5LjQ2MyA2LjEwM2EuMjU2LjI1NiAwIDAgMC0uMDUuMDMuOTI5LjkyOSAwIDAgMC0uNjUxLjk0MXYxMy4yMTNjMCAuNTM5LjMxNSAxLjAyNy44NTcgMS4wMjdIMjYuMTVjLjU0MSAwIDEuMDkzLS40OSAxLjA5My0xLjAyN1Y4LjEzMkgxMS41OTd6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "atVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _require = __webpack_require__("vgQg"),
    Config = _require.Config;

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            vendorid: 313786,
            email: 'quizzertv@gmail.com',
            planname: 'CLASSIC',
            planData: {},
            message: 'Don’t see your verification mail?',
            buttonclass: ['btn', 'banner-get-btn-success'],
            loaderStatus: false,
            apibaseurl: '',
            vendorportalurl: ''
        };
    },
    created: function created() {
        this.planData = this.$route.params.plandata;
        this.vendorid = this.$route.params.vendorid;
        this.email = this.$route.params.email;
    },
    mounted: function mounted() {
        // Setting Config URLs
        var con = new Config();
        this.apibaseurl = con.getApiUrl();
        this.vendorportalurl = con.getPortalUrl();
        this.$scrollTo('#success');

        var thisYear = new Date().getFullYear();
        console.log(document.getElementById('copyrightyear'));
        document.getElementById('copyrightyear').innerHTML = thisYear;
    },

    methods: {
        openSocialNewTab: function openSocialNewTab(surl) {
            window.open(surl, '_blank');
        },
        navigateToHomeWithDiv: function navigateToHomeWithDiv(divname) {
            this.$router.push({ name: 'Home', params: { divid: divname } });
        },
        openNewTab: function openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        },
        resendVerificationMail: function resendVerificationMail() {
            this.loaderStatus = false;
            // var url = 'vpremieretest.mobiotics.com/vendor/v1/plan';
            var hurl = this.apibaseurl + '/vendor/v1/signup/emailresend?email=' + this.email;
            var payload = {};
            var protocol = window.location.protocol;
            this.$http({ url: hurl, payload: payload, method: 'GET' }).then(function (response) {
                console.log('Success!:', response);
                this.buttonclass = ['btn', 'banner-get-btn-success', 'hidden'], this.message = "Verification Mail Resend Successfull, Please Check Mail.";
                //this.plans = response.data;
                this.loaderStatus = false;
            }, function (response) {
                console.log('Error!:', response);
                this.loaderStatus = false;
            });
        }
    }
});

/***/ }),

/***/ "b6pE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var videojs = __webpack_require__("Dia2");
// const dash = require('dashjs');
// const videodash = require('videojs-contrib-dash');
/* harmony default export */ __webpack_exports__["a"] = ({
    created: function created() {
        // console.log('[videojs]'. videojs);

        // var player = videojs('my_video_1');
        //
        // console.log('[player]'. player);
        //
        // player.ready(function() {
        //     console.log('player ready');
        //     //   player.src({
        //     //     src: 'https://d39a1jlfqg0udk.cloudfront.net/videos/1Plp2rrZ/nTHrY6EHQNqg_drm.mpd',
        //     //     type: 'application/dash+xml'
        //     //   });
        //     //
        //     //   player.play();
        // });

    }
});

// // const { videojs } = require('../assets/js/Video.js');
// const videojs = require('video.js');
// // const { dash } = require('../assets/js/dashall.js');
// // const { videodash } = require('../assets/js/videodash.js');
//
//   import countTo from 'vue-count-to';
//   export default {
//     components: { countTo },
//     created(){
//         console.log('[videojs]'. videojs);
//
//         var player = videojs('my_video_1');
//
//         console.log('[player]'. player);
//
//         player.ready(function() {
//             console.log('player ready');
//         //   player.src({
//         //     src: 'https://d39a1jlfqg0udk.cloudfront.net/videos/1Plp2rrZ/nTHrY6EHQNqg_drm.mpd',
//         //     type: 'application/dash+xml'
//         //   });
//           //
//         //   player.play();
//         });
//
//         // player.play();
//         // var formData = new FormData();
//         // formData.append('country',"IN");
//         // formData.append('dob',this.name);
//         // formData.append('email',"one@one.one");
//         // formData.append('gender',"Male");
//         // formData.append('subscribername',"one");
//         // formData.append('vendorid',"2Plp2rrX");
//         // formData.append('vendorkey',"9nSD1YTsEn7ExjQc");
//
//         // var url = "http://vlitetest.mobiotics.com/subscriber/v1/subscriber/subscribe";
//         // var formData = data;
//         // var hurl = window.location.protocol+"//"+url;
//         // var hurl = url;
//         // console.log(data);
//         // var email = data.get('vendoremail');
//         // this.$http.post(hurl,formData).then( function(response){
//         //     //   this.mainloaderStatus = false;
//         //       console.log("Success"+response.data);
//         //       var result = response.data;
//         //       if(result.success){
//         //           console.log("success");
//         //       }else{
//         //           console.log("failed");
//         //       }
//         //   }, function (response) {
//         //
//         //  });
//
//  //        console.log('fffffffffffff');
//  //        var formData = new FormData();
//  //        formData.append('vendorid',"zhmnkkMk");
//  //        formData.append('vendorkey','9N8UK0kClNN6vAdm');
//  //        formData.append('subscribername',"sangee");
//  //        console.log('iiiiiiiiiiiiiiiiiiii');
//  //        let params = '{"vendorid": "zhmnkkMk","vendorkey": "9N8UK0kClNN6vAdm","subscribername": "sangee"}';
//  //
//  //        let urlSearchParams = new URLSearchParams();
//  //       urlSearchParams.append('userId', '2');
//  //       urlSearchParams.append('email', 'p@es.es');
//  //
//      let path = 'http://vlitetest.mobiotics.com/subscriber/v1/subscriber/Zc0jW8sVCVhj';
//      var headers = new Headers();
//        headers.append('Content-Type', 'multipart/form-data');
//  //
//        var data = new FormData()
//        data.append('vendorid',"zhmnkkMk");
//               data.set('vendorkey','9N8UK0kClNN6vAdm');
//               data.set('subscribername',"sangee");
//  // data.set('actual_po_reference', this.actual_po_reference)
//  data.set('_method', 'put')
//
//     //  console.log('[Store actGetSubscribe] params', params);
//
//      this.$http.put(path, data).then(response => {
//        // console.log('[Store actGetSubscribe] response', response);
//
//     //    if (response.ok && response.status === 200) {
//     //      resolve(response.body);
//     //    } else {
//     //      reject({ error: true });
//     //    }
//      }).catch(error => {
//        // console.log('[Store actGetSubscribe] error', error);
//
//     //    reject(error);
//      });
//
//     // let formData ={
//     //     "vendorid": "zhmnkkMk"
//     // };
//     //
//     // console.log(formData);
//     // var formData = new FormData();
//                     // formData.append('title', this.title);
//                     // formData.append('body', this.body);
//                     // this.$http.put(path, formData,{'headers':{'Content-Type': 'application/json'}})
//                     //         .success(function () {
//                     //             // this.modalName.showMod = false;
//                     //             // location.reload();
//                     //         }).error(function (data) {
//                     //             // this.errors.title = data.title;
//                     //             // this.errors.body = data.body;
//                     //             // this.modalName.showMod = true;
//                     //         });
//
//     }
//   }

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return _defineProperty({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "egoL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/entertainment.3290844.jpg";

/***/ }),

/***/ "epRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _require = __webpack_require__("vgQg"),
    Config = _require.Config;

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            email: 'quizzertv@gmail.com',
            bannerclass: ['banner', 'failed-banner'],
            buttonclass: ['btn', 'banner-get-btn-success', 'raise'],
            title: '',
            titlemsg: '',
            message: '',
            status: '',
            reason: 'Something Went Wrong, Try Again',
            demoData: {},
            apibaseurl: '',
            vendorportalurl: '',
            normaldevice: true,
            smalldevice: false,
            sidebarVisible: false,
            susbtncolor: ['banner-head-blue-btn', 'btn-head', 'banner-head-get-btn', 'raise']
        };
    },
    created: function created() {
        this.screenResize();
        this.email = this.$route.params.email;
        this.status = this.$route.params.status;
        this.reason = this.$route.params.reason;
        this.demoData = this.$route.params.demoData;

        if (this.status == 'success') {
            this.title = 'Thanks !';
            this.titlemsg = 'Your request for live demo has been received';
            this.message = "A Live video demo has been sent to";
            this.buttonclass = ['btn', 'banner-get-btn-success', 'raise'];
            this.bannerclass = ['banner', 'success-banner'];
            this.susbtncolor = ['banner-head-blue-btn', 'btn-head', 'banner-head-get-btn', 'raise'];
        } else if (this.status == 'failed') {
            this.title = 'Failed !';
            this.titlemsg = 'Your request Can\'t be Processed';
            this.message = "Because of " + this.reason;
            this.buttonclass = ['btn', 'banner-get-btn-failed', 'raise'];
            this.bannerclass = ['banner', 'failed-banner'];
            this.susbtncolor = ['banner-head-rd-btn', 'btn-head', 'banner-head-get-btn', 'raise'];
        } else {
            this.title = 'Failed !';
            this.titlemsg = 'Your request Can\'t be Processed';
            this.message = 'Something Went Wrong, Try Again';
            this.buttonclass = ['btn', 'banner-get-btn-failed', 'raise'];
            this.bannerclass = ['banner', 'failed-banner'];
            this.susbtncolor = ['banner-head-rd-btn', 'btn-head', 'banner-head-get-btn', 'raise'];
        }
    },
    mounted: function mounted() {
        // Setting Config URLs
        var con = new Config();
        this.apibaseurl = con.getApiUrl();
        this.vendorportalurl = con.getPortalUrl();
        this.$scrollTo('#success');

        var thisYear = new Date().getFullYear();
        console.log(document.getElementById('copyrightyear'));
        document.getElementById('copyrightyear').innerHTML = thisYear;
    },

    watch: {
        '$mq.resize': 'screenResize'
    },
    methods: {
        openSocialNewTab: function openSocialNewTab(surl) {
            window.open(surl, '_blank');
        },
        openNewTab: function openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        },
        navigateToHomeWithDiv: function navigateToHomeWithDiv(divname) {
            this.$router.push({ name: 'Home', params: { divid: divname } });
        },
        requestagain: function requestagain() {
            this.$router.push({ name: 'Reqdemo', params: { resetData: this.demoData } });
        },
        screenResize: function screenResize() {
            var scsize = screen.width;
            if (scsize >= 601) {
                this.normaldevice = true;
                this.smalldevice = false;
            } else if (scsize <= 600) {
                this.normaldevice = false;
                this.smalldevice = true;
            }
        }
    }
});

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f39daa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("nHeG");
function injectStyle (ssrContext) {
  __webpack_require__("WRdO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40f39daa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f39daa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iXMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-component",attrs:{"id":"success"},on:{"onload":function($event){return _vm.verifyAccountData()}}},[_c('div',{class:_vm.bannercolor},[_c('container',[_c('header',[_c('div',{staticClass:"inner"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"pointer logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("aUqx")}}),_c('span',{staticClass:"logo-text"},[_vm._v("vLite")])])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"white-text"},[_vm._v(_vm._s(_vm.bannerh1))]),_vm._v(" "),_c('h2',{staticClass:"white-text"},[_vm._v(_vm._s(_vm.bannerh2))]),_vm._v(" "),_c('grid',{staticClass:"vl-rltv",attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"zindex101",attrs:{"size":"8/12"}},[_c('h4',{staticClass:"banner-text-normal white-text"}),_vm._v(" "),_c('h4',{staticClass:"banner-text-normal white-text"},[_vm._v(_vm._s(_vm.bannerh3)+" "),_c('strong',[_vm._v(_vm._s(_vm.email))]),_vm._v(".")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.navurl,"target":"_blank"},on:{"click":[function($event){$event.preventDefault();return _vm.verifyAccountData($event)},function($event){return _vm.navigationBtnGA(_vm.bannerbtntext)}]}},[_c('button',{class:_vm.bannerbtn,attrs:{"type":"button"},on:{"click":function($event){return _vm.openUrlTab(_vm.navurl)}}},[_vm._v(_vm._s(_vm.bannerbtntext))])])]),_vm._v(" "),_c('grid-item',{staticClass:"v-middle right zindex101 vl-bnr-top-ico",attrs:{"size":"4/12"}},[_c('img',{staticClass:"v-middle right width100",attrs:{"src":__webpack_require__("ExfC")}})])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"success-basic"},[_c('container',[_c('p',{staticClass:"center success-p"},[_vm._v(_vm._s(_vm.bodyp1))]),_vm._v(" "),_c('p',{staticClass:"center success-p"},[_vm._v(_vm._s(_vm.bodyp2))]),_vm._v(" "),_c('p',{staticClass:"center success-p"},[_vm._v(_vm._s(_vm.bodyp3))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('div',{staticClass:"success-back-color"},[_c('container',[_c('p',{staticClass:"center success-help"},[_vm._v("Need Help?")]),_vm._v(" "),_c('p',{staticClass:"center success-p"},[_vm._v("Please contact us at "),_c('strong',[_c('a',{staticStyle:{"color":"#666666"},attrs:{"href":"mailto:vlitesupport@mobiotics.com","target":"_blank"}},[_vm._v("vlitesupport@mobiotics.com")])])]),_vm._v(" "),_c('p',{staticClass:"center success-p"},[_vm._v("citing your vendor id ("),_c('strong',[_vm._v("VendorId")]),_vm._v(") for any help.")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-color"},[_c('container',[_c('grid',[_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-left"},[_c('div',{staticClass:" logo-opacity"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",staticStyle:{"width":"20%"},attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_vm._v("© Copyright "),_c('label',{attrs:{"id":"copyrightyear"}}),_c('a',{attrs:{"href":"https://www.mobiotics.com","target":"_blank"}},[_c('img',{staticClass:"v-middle foot-cmp-logo",attrs:{"src":__webpack_require__("/krl")}})])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-mid"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://www.facebook.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"facebook"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://plus.google.com/106588943035549674608/posts')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.5","name":"google-plus"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://twitter.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"twitter"}})],1)])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-right f-right"},[_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms Of Use")])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])],1)],1)],1)]),_vm._v(" "),_c('container',[(_vm.loaderStatus)?_c('div',{staticClass:"dash-loader",attrs:{"id":"dash-loader"}},[_c('div',{staticClass:"dash-loader-img"},[_c('svg',{staticClass:"lds-spin",staticStyle:{"background":"none"},attrs:{"width":"100px","height":"100px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('g',{attrs:{"transform":"translate(80,50)"}},[_c('g',{attrs:{"transform":"rotate(0)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"1","transform":"scale(1.045 1.045)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.8333333333333334s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.8333333333333334s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(59.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.8333333333333334","transform":"scale(1.06167 1.06167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.6666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.6666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(35.00000000000001,75.98076211353316)"}},[_c('g',{attrs:{"transform":"rotate(119.99999999999999)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.6666666666666666","transform":"scale(1.07833 1.07833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.5s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.5s"}})],1)])]),_c('g',{attrs:{"transform":"translate(20,50.00000000000001)"}},[_c('g',{attrs:{"transform":"rotate(180)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#EF307E","fill-opacity":"0.5","transform":"scale(1.095 1.095)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.3333333333333333s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.3333333333333333s"}})],1)])]),_c('g',{attrs:{"transform":"translate(34.999999999999986,24.019237886466847)"}},[_c('g',{attrs:{"transform":"rotate(239.99999999999997)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#FFCA37","fill-opacity":"0.3333333333333333","transform":"scale(1.01167 1.01167)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.16666666666666666s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"-0.16666666666666666s"}})],1)])]),_c('g',{attrs:{"transform":"translate(65,24.019237886466843)"}},[_c('g',{attrs:{"transform":"rotate(300.00000000000006)"}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"10","fill":"#3BD7DC","fill-opacity":"0.16666666666666666","transform":"scale(1.02833 1.02833)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"0s","values":"1.1 1.1;1 1","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill-opacity","keyTimes":"0;1","dur":"1s","repeatCount":"indefinite","values":"1;0","begin":"0s"}})],1)])])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kHVx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-component",attrs:{"id":"failed"}},[_c('div',{staticClass:"banner failed-banner"},[_c('container',[_c('header',[_c('div',{staticClass:"inner"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"pointer logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("aUqx")}}),_c('span',{staticClass:"logo-text"},[_vm._v("vLite")])])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"white-text"},[_vm._v("Oops!")]),_vm._v(" "),_c('h2',{staticClass:"white-text"},[_vm._v("Your Signup failed.")]),_vm._v(" "),_c('grid',{staticClass:"vl-rltv",attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"zindex101",attrs:{"size":"8/12"}},[_c('h3',{staticClass:"banner-text-normal white-text"},[_vm._v("Your payment did not go through")]),_vm._v(" "),_c('h4',{staticClass:"banner-text-normal white-text"},[_vm._v(_vm._s(_vm.reason))]),_vm._v(" "),_c('button',{staticClass:"btn banner-get-btn-failed",attrs:{"type":"button"},on:{"click":function($event){return _vm.retryPaymentData()}}},[_vm._v("RETRY PAYMENT")])]),_vm._v(" "),_c('grid-item',{staticClass:"v-middle right zindex101 vl-bnr-top-ico",attrs:{"size":"4/12"}},[_c('img',{staticClass:"v-middle right width60",attrs:{"src":__webpack_require__("ExfC")}})])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"failed-basic"},[_c('container',[_c('p',{staticClass:"center failed-p"},[_vm._v(_vm._s(_vm.reason))]),_vm._v(" "),_c('p',{staticClass:"center failed-p"},[_vm._v("If you’re seeing this more than once, please mail us.")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('div',{staticClass:"failed-back-color blk-pad"},[_c('container',[_c('p',{staticClass:"center failed-help m-0"},[_vm._v("Need Help?")]),_vm._v(" "),_c('p',{staticClass:"center failed-p m-0 p-top-10"},[_vm._v("Please contact us at "),_c('strong',[_vm._v("vlitesupport@mobiotics.com")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-color"},[_c('container',[_c('grid',[_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-left"},[_c('div',{staticClass:" logo-opacity"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",staticStyle:{"width":"20%"},attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_vm._v("© Copyright "),_c('label',{attrs:{"id":"copyrightyear"}}),_c('a',{attrs:{"href":"https://www.mobiotics.com","target":"_blank"}},[_c('img',{staticClass:"v-middle foot-cmp-logo",attrs:{"src":__webpack_require__("/krl")}})])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-mid"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://www.facebook.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"facebook"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://plus.google.com/106588943035549674608/posts')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.5","name":"google-plus"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://twitter.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"twitter"}})],1)])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-right f-right"},[_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms Of Use")])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eef8b9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("A8UF");
function injectStyle (ssrContext) {
  __webpack_require__("mRt8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eef8b9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "m8ch":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/clientapps.bde2bd5.svg";

/***/ }),

/***/ "mOkF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjBweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjAgNjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA0OC4xICg0NzI1MCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+RkZGMzMzMDUtNjBENy00NEZCLTlDODQtNzM1QzQ0MjlENUExQDEuNXg8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IjAwbGFuZGluZ191cGRhdGVkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzgxLjAwMDAwMCwgLTI0MDQuMDAwMDAwKSI+CiAgICAgICAgPGcgaWQ9InBhZ2UiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJ0b3A0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjE5NS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJmZWF0dXJlc3NlYyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzYxLjAwMDAwMCwgNjQuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImZlYXR1cmVzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMTMxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0icmF3MSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iZjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwMC4wMDAwMDAsIDE0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJpbnN0YW50LWljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMC4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02LjAxNDc0NzQxLDU5LjM0NzkxMTcgQzYuMDE0NzQ3NDEsNjEuNTExMzc2MiA3Ljc3NzU1Mzc5LDYzLjI2Njc2MjEgOS45NTAxNjM4Nyw2My4yNjY3NjIxIEwzNi4wODY1MzMsNjMuMjY2NzYyMSBDMzguMjU5MTQzMSw2My4yNjY3NjIxIDQwLjAyMTk0OTUsNjEuNTExMzc2MiA0MC4wMjE5NDk1LDU5LjM0NzkxMTcgTDQwLjAyMTk0OTUsNDAuNzU3NjYzIEw2LjAxNDc0NzQxLDQwLjc1NzY2MyBMNi4wMTQ3NDc0MSw1OS4zNDc5MTE3IEw2LjAxNDc0NzQxLDU5LjM0NzkxMTcgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtcGF0aCIgeD0iNi4wMTQ3NDc0MSIgeT0iMzEuNTk4NSIgd2lkdGg9IjM0LjAwMDY5NzIiIGhlaWdodD0iNi4xMTQ3MDIwMyI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNDUuNDAxNDM2MSwyNi42NDMyNTk1IEM0NS40MDE0MzYxLDI1LjM5MzExMzkgNDQuMzgwMTc5MywyNC4zNzYxNTYgNDMuMTI0NzQ4OSwyNC4zNzYxNTYgTDIuOTExOTQ3OTksMjQuMzc2MTU2IEMxLjY1NjUxNzYxLDI0LjM3NjE1NiAwLjYzNTI2MDc3OSwyNS4zOTMxMTM5IDAuNjM1MjYwNzc5LDI2LjY0MzI1OTUgQzAuNjM1MjYwNzc5LDI3Ljg5MzQ2OTkgMS42NTY1MTc2MSwyOC45MTAzNjMgMi45MTE5NDc5OSwyOC45MTAzNjMgTDQzLjEyNDc0ODksMjguOTEwMzYzIEM0NC4zODAxNzkzLDI4LjkxMDM2MyA0NS40MDE0MzYxLDI3Ljg5OTk0NzQgNDUuNDAxNDM2MSwyNi42NDMyNTk1IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNTkuMTk4MDk1NSwwLjc1MzAwMjIzNiBDNTguODk4ODczOCwwLjEwNTI1ODM3NyA1OC4xMjQ4MDAxLC0wLjE3OTc0ODkyMSA1Ny40NzQzMTgxLDAuMTE4MjEzMjU0IEwyOC41MjEzNjE2LDEzLjMzMjE4OCBMMzAuMjc3NjYzMiwxNi44MDQwOTUxIEw1OS4xMDA1MjMyLDMuNjQ4NDE3MjggQzU5Ljc1NzU3NTIsMy4zNTA0NTUxMSA2MC4wNDM3MjIyLDIuNTc5NjM5OTIgNTkuNzM3OTk1NywxLjkyNTQxODYyIEw1OS4xOTgwOTU1LDAuNzUzMDAyMjM2IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTcuNTIxNzEsMTkuNzgzNzE2OCBMMTguMDY4MTE0OSwyMC45NjI2MTA2IEMxOC4zNjczMzY3LDIxLjYxMDM1NDUgMTkuMTQxNDEwMywyMS44OTUzNjE4IDE5Ljc5MTg5MjQsMjEuNTk3Mzk5NiBMMjcuOTA5OTA4NSwxNy44OTIzMDQ3IEwyNi4xNTM2MDY5LDE0LjQyMDM5NzcgTDE4LjE2NTY4NzIsMTguMDYwNzE4MSBDMTcuNTA4NzY1NCwxOC4zNTg2ODAzIDE3LjIyMjU1MzMsMTkuMTI5NDk1NSAxNy41MjE3MSwxOS43ODM3MTY4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMC4yNzc0OTU2NDcsMTUuMzI3MjM5MSBMNC43MDA3NzM2NSwxNy4yNTc1MTU4IEM0Ljc5ODM0NTk2LDE3LjMwMjg1NzggNC44NzY0MDM4MSwxNy4zODA1ODcxIDQuOTIxOTM3NTUsMTcuNDc3NzQ4NyBMNi42MjYyMDA1NSwyMS41OTczOTk2IEM2Ljc2OTMwNjYsMjEuOTQwNzAzOSA3LjI1NzE2ODE0LDIxLjk0MDcwMzkgNy4zOTM3NjkzOCwyMS41OTczOTk2IEw5LjA5ODAzMjM3LDE3LjQ3Nzc0ODcgQzkuMTM3MDYxMywxNy4zODA1ODcxIDkuMjE1MTE5MTQsMTcuMjk2MzgwNCA5LjMxOTE5NjI3LDE3LjI1NzUxNTggTDEzLjc0MjQ3NDMsMTUuMzI3MjM5MSBDMTQuMDgwNzI0OSwxNS4xNzgyNTggMTQuMDc0MjIwMSwxNC42OTI0NTAxIDEzLjcyMjk1OTgsMTQuNTU2NDIzOSBMOS4yODY2NzIxNywxMi44NzIyODk4IEM5LjE4MjU5NTA0LDEyLjgzMzQyNTIgOS4wOTE1Mjc1NSwxMi43NDkyMTg1IDkuMDUyNDk4NjMsMTIuNjQ1NTc5NSBMNy4zOTM3NjkzOCw4LjY3NDkwOTYzIEM3LjI1MDY2MzMyLDguMzMxNjA1MzggNi43NjkzMDY2LDguMzMxNjA1MzggNi42MjYyMDA1NSw4LjY3NDkwOTYzIEw0Ljk2NzQ3MTMsMTIuNjQ1NTc5NSBDNC45MjE5Mzc1NSwxMi43NDkyMTg1IDQuODM3Mzc0ODgsMTIuODMzNDI1MiA0LjczMzI5Nzc1LDEyLjg3MjI4OTggTDAuMjk3MDEwMTA4LDE0LjU1NjQyMzkgQy0wLjA0Nzc0NTM4MzIsMTQuNjkyNDUwMSAtMC4wNjA4MjAwNzI2LDE1LjE3ODI1OCAwLjI3NzQ5NTY0NywxNS4zMjcyMzkxIFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTUuMjMyMDc4Miw2LjYwMjEyOTI4IEwxOC4wMDk2MzY2LDcuODEzNDEwMyBDMTguMDc0Njg0OCw3LjgzOTMyMDA1IDE4LjEyMDIxODUsNy44OTExMzk1NiAxOC4xNDYzMDI5LDcuOTU1OTEzOTUgTDE5LjIxMzAyODQsMTAuNTQwNDExOSBDMTkuMzA0MDk1OSwxMC43NTQxNjc0IDE5LjYwOTg4NzUsMTAuNzU0MTY3NCAxOS42OTQzODUxLDEwLjU0MDQxMTkgTDIwLjc2MTE3NTcsNy45NTU5MTM5NSBDMjAuNzg3MTI5OSw3Ljg5MTEzOTU2IDIwLjgzMjcyODcsNy44NDU3OTc0OSAyMC44OTc3NzY5LDcuODEzNDEwMyBMMjMuNjc1MzM1Myw2LjYwMjEyOTI4IEMyMy44ODk5OTQ0LDYuNTExNDQ1MTQgMjMuODgzNDg5Niw2LjIwMDUyODA5IDIzLjY2MjMyNTcsNi4xMjI3OTg4MyBMMjAuODc4MjYyNSw1LjA2Njk3NjM0IEMyMC44MTMyMTQzLDUuMDQxMDY2NTggMjAuNzU0NjcwOSw0Ljk4OTI0NzA3IDIwLjcyODY1MTYsNC45MjQ0NzI2OSBMMTkuNjg3ODgwMywyLjQzNzEzNjI3IEMxOS41OTY4MTI4LDIuMjIzMzgwOCAxOS4yOTc1OTExLDIuMjIzMzgwOCAxOS4yMDY1MjM2LDIuNDM3MTM2MjcgTDE4LjE2NTc1MjMsNC45MjQ0NzI2OSBDMTguMTM5NzMzLDQuOTg5MjQ3MDcgMTguMDg3Njk0NCw1LjA0MTA2NjU4IDE4LjAxNjE0MTQsNS4wNjY5NzYzNCBMMTUuMjMyMDc4Miw2LjEyMjc5ODgzIEMxNS4wMjM5MjM5LDYuMjAwNTI4MDkgMTUuMDE3NDE5MSw2LjUwNDk2NzcgMTUuMjMyMDc4Miw2LjYwMjEyOTI4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "mRt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nAHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-component",attrs:{"id":"success"}},[_c('div',{class:_vm.bannerclass},[_c('container',[(_vm.normaldevice)?_c('header',[_c('div',{staticClass:"inner"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('ul',{staticClass:"top-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.smalldevice)?_c('header',[_c('div',{staticClass:"inner-sm"},[_c('grid',{attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"logo-opacity",attrs:{"size":"2/12"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"v-middle",attrs:{"src":__webpack_require__("vX6J")}})])]),_vm._v(" "),_c('grid-item',{staticClass:"nav-items",attrs:{"size":"10/12"}},[_c('button',{staticClass:"btn-hamb",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"}),_vm._v(" "),_c('span',{staticClass:"strike"})]),_vm._v(" "),_c('button',{class:_vm.susbtncolor,attrs:{"type":"button"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("SUBSCRIBE")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebarVisible),expression:"sidebarVisible"}],staticClass:"sidebar"},[_c('div',{staticClass:"menus"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('howitwork')}}},[_vm._v("HOW IT WORKS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('features')}}},[_vm._v("FEATURES")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.navigateToHomeWithDiv('plans')}}},[_vm._v("PLANS")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#plans'),expression:"'#plans'"}],attrs:{"href":"#"}},[_vm._v("BLOG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openNewTab()}}},[_vm._v("SIGNIN")])])])]),_vm._v(" "),_c('button',{staticClass:"btn-close-sidebar",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('icon',{staticStyle:{"color":"#bcbcbc"},attrs:{"scale":"2.5","name":"times"}})],1)])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"white-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h2',{staticClass:"white-text"},[_vm._v(_vm._s(_vm.titlemsg))]),_vm._v(" "),_c('grid',{staticClass:"vl-rltv",attrs:{"horizontal":"left"}},[_c('grid-item',{staticClass:"zindex101",attrs:{"size":"8/12"}},[_c('h4',{staticClass:"banner-text-normal white-text"},[_vm._v("Our support team shall contact you shortly!")]),_vm._v(" "),_c('button',{class:_vm.buttonclass,attrs:{"type":"button"},on:{"click":function($event){return _vm.requestagain()}}},[_vm._v("REQUEST AGAIN")])]),_vm._v(" "),_c('grid-item',{staticClass:"v-middle right zindex101 vl-bnr-top-ico",attrs:{"size":"4/12"}},[_c('div',{staticClass:"top-right-gfx"})])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"success-basic"},[_c('container',[_c('p',{staticClass:"center success-p p-top-30"},[_vm._v("Thanks for your Live Demo Request for MOOC/Entertainment. Our support team shall contact you to setup a convenient slot shortly. You should have received a mail regarding the same. ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('div',{staticClass:"success-back-color success-back-pad"},[_c('container',[_c('p',{staticClass:"center success-help m-0"},[_vm._v("Need Help?")]),_vm._v(" "),_c('p',{staticClass:"center success-p m-0"},[_vm._v("Please contact us at "),_c('strong',[_vm._v("vlitesupport@mobiotics.com")]),_vm._v(" for any help.")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-color"},[_c('container',[_c('grid',[_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-left"},[_c('div',{staticClass:" logo-opacity"},[_c('img',{staticClass:"v-middle",staticStyle:{"width":"20%"},attrs:{"src":__webpack_require__("vX6J")}})]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_vm._v("© Copyright "),_c('label',{attrs:{"id":"copyrightyear"}}),_c('a',{attrs:{"href":"https://www.mobiotics.com","target":"_blank"}},[_c('img',{staticClass:"v-middle foot-cmp-logo",attrs:{"src":__webpack_require__("/krl")}})])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-mid"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://www.facebook.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"facebook"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://plus.google.com/106588943035549674608/posts')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.5","name":"google-plus"}})],1)]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openSocialNewTab('https://twitter.com/mobiotics')}}},[_c('icon',{staticClass:"white-text",attrs:{"scale":"1.2","name":"twitter"}})],1)])])])]),_vm._v(" "),_c('grid-item',{attrs:{"size":"4/12"}},[_c('div',{staticClass:"vl-foot-right f-right"},[_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms Of Use")])]),_vm._v(" "),_c('p',{staticClass:"foot-copy"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nHYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventJS", function() { return EventJS; });
/**
* Unifies event handling across browsers
*
* - Allows registering and unregistering of event handlers
* - Injects event object and involved DOM element to listener
*
* @author Mark Rolich <mark.rolich@gmail.com>
*/
var EventJS = function EventJS() {
    "use strict";

    this.attach = function (evtName, element, listener, capture) {
        var evt = '',
            useCapture = capture === undefined ? true : capture,
            handler = null;

        if (window.addEventListener === undefined) {
            evt = 'on' + evtName;
            handler = function handler(evt, listener) {
                element.attachEvent(evt, listener);
                return listener;
            };
        } else {
            evt = evtName;
            handler = function handler(evt, listener, useCapture) {
                element.addEventListener(evt, listener, useCapture);
                return listener;
            };
        }

        return handler.apply(element, [evt, function (ev) {
            var e = ev || event,
                src = e.srcElement || e.target;

            listener(e, src);
        }, useCapture]);
    };

    this.detach = function (evtName, element, listener, capture) {
        var evt = '',
            useCapture = capture === undefined ? true : capture;

        if (window.removeEventListener === undefined) {
            evt = 'on' + evtName;
            element.detachEvent(evt, listener);
        } else {
            evt = evtName;
            element.removeEventListener(evt, listener, useCapture);
        }
    };

    this.stop = function (evt) {
        evt.cancelBubble = true;

        if (evt.stopPropagation) {
            evt.stopPropagation();
        }
    };

    this.prevent = function (evt) {
        if (evt.preventDefault) {
            evt.preventDefault();
        } else {
            evt.returnValue = false;
        }
    };
};

/***/ }),

/***/ "nHeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://chat.vuejs.org","target":"_blank"}},[_vm._v("Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank"}},[_vm._v("awesome-vue")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nMd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fixed_header__ = __webpack_require__("DAFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fixed_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_fixed_header__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// const videojs = async () => require(/*webpackChunkName: "videojs" */ "video.js");
// const dash = async () => require(/*webpackChunkName: "dash"*/ "dashjs");
// const videodash = async () => require(/*webpackChunkName: "videodash"*/ "videojs-contrib-dash");
// const videojs = require('video.js');

var videojs = function videojs() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "Dia2"));
};
var dash = __webpack_require__("2u2m");
var videodash = __webpack_require__("uPQo");

var _require = __webpack_require__("vgQg"),
    Config = _require.Config;



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { 'fixed-header': __WEBPACK_IMPORTED_MODULE_0_vue_fixed_header___default.a },
    data: function data() {
        return {
            name: "",
            email: "",
            mobile: "",
            plans: [],
            planboxIndex: 2,
            plan: 'vl-plan-box',
            plan1: ['vl-plan-box', 'vl-plbox-1'],
            plan2: ['vl-plan-box', 'vl-plbox-2', 'box-active'],
            plan3: ['vl-plan-box', 'vl-plbox-3'],
            workrect: 'works-rectangle',
            workrectcount: 'wrk-rect-count',
            workrecttext: 'wrk-rect-text',
            bannerrightimg: 'width100',
            tempmode: "",
            mainloaderStatus: false,
            formSubmitted: false,
            demoData: {},
            apibaseurl: '',
            vendorportalurl: '',
            vmflag: 0,
            veflag: 0,
            normaldevice: true,
            smalldevice: false,
            isFixed: false,
            showfixedheader: false,
            sidebarVisible: false,
            mooccasVisible: false,
            entcasVisible: false,
            moocmodVisible: false,
            entmodVisible: false,
            appname: "",
            popupcloseflag: 0,
            enablepopupclose: true,
            enablepopupcounter: 0,
            storeclass: ['m-top-20', 'store-lg-main-con'],
            storeclasssub: ['store-popup-cont'],
            storebox: ['store-ios-box', 'top'],
            mooccasVisiblecontent: true,
            mooccasVisiblesuccess: false,
            mooccasVisibleerror: false,
            entcasVisiblecontent: true,
            entcasVisiblesuccess: false,
            entcasVisibleerror: false,
            moocmodVisiblecontent: true,
            moocmodVisiblesuccess: false,
            moocmodVisibleerror: false,
            entmodVisiblecontent: true,
            entmodVisiblesuccess: false,
            entmodVisibleerror: false,
            popupclosecasentflag: 0,
            popupclosemodentflag: 0,
            popupclosecasmoocflag: 0,
            popupclosemodmoocflag: 0

        };
    },
    created: function created() {
        this.screenResize();
        this.demoData = this.$route.params.resetData;
        //  console.log(videojs.videojs);
    },
    mounted: function mounted() {
        var thisYear = new Date().getFullYear();
        // console.log(document.getElementById('copyrightyear'));
        document.getElementById('copyrightyear').innerHTML = thisYear;

        // Setting Config URLs
        var con = new Config();
        this.apibaseurl = con.getApiUrl();
        this.vendorportalurl = con.getPortalUrl();

        var self = this;
        window.addEventListener('scroll', function (e) {
            // console.log('came');
            var wheight = window.pageYOffset;
            var x = document.querySelector('#headerelement').clientHeight;
            // console.log(wheight+'  '+x);
            var tlimit = x + 120;
            if (x < wheight) {
                self.showfixedheader = true;
                // console.log('show f header');
            } else {
                self.showfixedheader = false;
                // console.log('show n header');
            }
        });

        this.restoreData();
    },

    watch: {
        '$mq.resize': 'screenResize'
    },
    methods: {
        sendiospreflightreq: function sendiospreflightreq(divid, template, mode) {
            var divid = document.getElementById(divid).getElementsByTagName('input');
            // console.log(divid[0].value);
            // console.log(divid[1].value);
            var formData = new FormData();
            formData.append('name', divid[0].value);
            formData.append('email', divid[1].value);
            // console.log(this.$validator);
            //
            // this.$validator.validate('email', divid[1].value,'Global').then(result => {
            //     console.log(result);  // true
            // });
            //
            // this.$validator.validate('required|alpha', divid[0].value,'Global').then(result => {
            //     console.log(result);  // true
            // });
            this.email = divid[1].value;
            // console.log(mode+'  '+template);
            // if(false){
            formData.append('mode', template);
            formData.append('template', mode.toUpperCase());
            formData.append('type', 'APP');
            var url = this.apibaseurl + '/vendor/v1/demorequest';
            var hurl = url;
            // var email = data.get('vendoremail');
            this.$http.post(hurl, formData).then(function (response) {
                console.log("Success" + response.data);
                var result = response.data;
                if (result.success) {
                    // console.log('Success');
                    if (template == 'Entertainment') {
                        if (mode == 'Casual') {
                            this.entcasVisiblecontent = false;
                            this.entcasVisiblesuccess = true;
                            this.entcasVisibleerror = false;
                        }
                        if (mode == 'Modern') {

                            this.entmodVisiblecontent = false;
                            this.entmodVisiblesuccess = true;
                            this.entmodVisibleerror = false;
                        }
                    }
                    if (template == 'MOOC') {
                        if (mode == 'Casual') {
                            // console.log('here');
                            this.mooccasVisiblecontent = false;
                            this.mooccasVisiblesuccess = true;
                            this.mooccasVisibleerror = false;
                        }
                        if (mode == 'Modern') {
                            this.moocmodVisiblecontent = false;
                            this.moocmodVisiblesuccess = true;
                            this.moocmodVisibleerror = false;
                        }
                    }
                    var self = this;
                    setTimeout(function () {
                        self.closeiosbox(mode, template, 'IOS');
                    }, 3000);

                    // GTM Code starts
                    //    window.dataLayer = window.dataLayer || [];
                    //    window.dataLayer.push({
                    //        'event':'VLITE_DEMO_REQUEST',
                    //        'EventCategory': 'VLITE_DEMO',
                    //        'EventAction': 'DemoRequest',
                    //        'EventLabel': 'DEMO_REQUEST_SUCCESS',
                    //        'EventValue': 1,
                    //        'Name': this.name,
                    //        'Emailid': this.email,
                    //        'Contact': this.mobile,
                    //        'Mode': this.tempmode
                    //    });
                    // End of GTM Code
                    //   this.$router.push({ name: 'Democonfirm', params: { status: 'success', email: this.email, reason: 'OK' }});
                } else {
                    console.log('API failed');
                    if (template == 'Entertainment') {
                        if (mode == 'Casual') {
                            this.entcasVisiblecontent = false;
                            this.entcasVisiblesuccess = false;
                            this.entcasVisibleerror = true;
                        }
                        if (mode == 'Modern') {

                            this.entmodVisiblecontent = false;
                            this.entmodVisiblesuccess = false;
                            this.entmodVisibleerror = true;
                        }
                    }
                    if (template == 'MOOC') {
                        if (mode == 'Casual') {
                            this.mooccasVisiblecontent = false;
                            this.mooccasVisiblesuccess = false;
                            this.mooccasVisibleerror = true;
                        }
                        if (mode == 'Modern') {
                            this.moocmodVisiblecontent = false;
                            this.moocmodVisiblesuccess = false;
                            this.moocmodVisibleerror = true;
                        }
                    }
                    // GTM Code starts
                    //    window.dataLayer = window.dataLayer || [];
                    //    window.dataLayer.push({
                    //        'event':'VLITE_DEMO_REQUEST',
                    //        'EventCategory': 'VLITE_DEMO',
                    //        'EventAction': 'DemoRequest',
                    //        'EventLabel': 'DEMO_REQUEST_FAILURE',
                    //        'EventValue': 1,
                    //        'Name': this.name,
                    //        'Emailid': this.email,
                    //        'Contact': this.mobile,
                    //        'Mode': this.tempmode
                    //    });
                    // End of GTM Code
                    // this.$router.push({ name: 'Democonfirm', params: { status: 'failed', email: this.email, reason: result.reason, demoData: demoData }});
                    var self = this;
                    setTimeout(function () {
                        self.closeiosbox(mode, template, 'IOS');
                    }, 3000);
                }
            }, function (response) {
                //   this.mainloaderStatus = false;
                console.log("HTTP Failed");
                if (template == 'Entertainment') {
                    if (mode == 'Casual') {
                        this.entcasVisiblecontent = false;
                        this.entcasVisiblesuccess = false;
                        this.entcasVisibleerror = true;
                    }
                    if (mode == 'Modern') {

                        this.entmodVisiblecontent = false;
                        this.entmodVisiblesuccess = false;
                        this.entmodVisibleerror = true;
                    }
                }
                if (template == 'MOOC') {
                    if (mode == 'Casual') {
                        this.mooccasVisiblecontent = false;
                        this.mooccasVisiblesuccess = false;
                        this.mooccasVisibleerror = true;
                    }
                    if (mode == 'Modern') {
                        this.moocmodVisiblecontent = false;
                        this.moocmodVisiblesuccess = false;
                        this.moocmodVisibleerror = true;
                    }
                }
                // GTM Code starts
                //    window.dataLayer = window.dataLayer || [];
                //    window.dataLayer.push({
                //        'event':'VLITE_DEMO_REQUEST',
                //        'EventCategory': 'VLITE_DEMO',
                //        'EventAction': 'DemoRequest',
                //        'EventLabel': 'DEMO_REQUEST_FAILURE',
                //        'EventValue': 1,
                //        'Name': this.name,
                //        'Emailid': this.email,
                //        'Contact': this.mobile,
                //        'Mode': this.tempmode
                //    });
                // End of GTM Code
                //   this.$router.push({ name: 'Democonfirm', params: { status: 'failed', email: this.email, reason: 'Network Error', demoData: demoData }});
                var self = this;
                setTimeout(function () {
                    self.closeiosbox(mode, template, 'IOS');
                }, 3000);
            });
            // }
        },
        toggleSidebar: function toggleSidebar() {
            this.sidebarVisible = !this.sidebarVisible;
        },
        myFunction: function myFunction() {
            // var element = document.getElementById("myDIV");
            // element.classList.toggle("toggle-in");
            var element = document.getElementById("backend-container");
            element.classList.toggle("dis-block-custom");
            var element = document.getElementById("down-arrow");
            element.classList.toggle("toggle-backend-icon");
        },

        outsidemooc: function outsidemooc(e) {
            var _this = this;

            videojs().then(function (videojs) {
                console.log(videojs);
                // console.log('outside mooc');
                // var vid =document.getElementById("moocvideo_html5_api");
                // if(!vid && vid.length == 0){
                var vid = document.getElementById("moocvideo");
                if (!vid) return;
                // }
                var moocVideoJs = videojs('moocvideo');
                if (_this.vmflag > 1) {
                    var des = document.getElementById("moocpopup");
                    var mooc = document.getElementById("moocimg");
                    vid.src = vid.src;
                    if (des.className.split(" ").indexOf("show") >= 0) {
                        des.classList.remove("show");
                    }
                    if (mooc.className.split(" ").indexOf("zindex150") >= 0) {
                        mooc.classList.remove("zindex150");
                    }
                    _this.vmflag = 0;
                    moocVideoJs.pause();
                    // vid.stop();
                } else {
                    //  vid.play();
                    _this.vmflag++;
                }
            });
        },
        insidemooc: function insidemooc() {
            // console.log('inside mooc');
            // console.log(videojs);
            // var vid =document.getElementById("moocvideo_html5_api");
            // if(vid.length == 0){
            //     vid =document.getElementById("moocvideo");
            // }
            // vid.play();
        },

        outsideent: function outsideent(e) {
            var _this2 = this;

            videojs().then(function (videojs) {
                // console.log('outside ent');
                // var vid =document.getElementById("entvideo_html5_api");
                // if(!vid && vid.length == 0){
                var vid = document.getElementById("entvideo");
                // }

                if (!vid) return;

                var entVideoJs = videojs('entvideo');

                if (_this2.veflag > 1) {
                    var des = document.getElementById("entpopup");
                    var ent = document.getElementById("entimg");
                    vid.src = vid.src;
                    if (des.className.split(" ").indexOf("show") >= 0) {
                        des.classList.remove("show");
                    }
                    if (ent.className.split(" ").indexOf("zindex150") >= 0) {
                        ent.classList.remove("zindex150");
                    }
                    _this2.veflag = 0;
                    entVideoJs.pause();
                } else {
                    _this2.veflag++;
                    // vid.play();
                }
            });
        },
        insideent: function insideent() {
            // console.log('inside ent');
            // var vid =document.getElementById("entvideo_html5_api");
            // if(vid.length == 0){
            //     vid =document.getElementById("entvideo");
            // }
            // vid.play();
        },
        tryBackend: function tryBackend() {
            this.$ga.event({
                eventCategory: 'VLITE_DEMO',
                eventAction: 'TryBackend',
                eventLabel: 'TRY_DEMOBACKEND',
                eventValue: 1
            });
        },
        displayVideoPopup: function displayVideoPopup(type) {
            // videojs.options.autoplay = true;
            videojs().then(function (videojs) {
                var popup = "";
                //Theme Fetch
                var retrievedObject = localStorage.getItem('themeObject');
                var resobj = JSON.parse(retrievedObject);
                var theme = new Date(resobj.number);
                var ver = 'A';
                if (theme % 2 != 0) {
                    ver = 'B';
                }

                if (type == 'MOOC') {
                    var des = document.getElementById("moocpopup");
                    var mooc = document.getElementById("moocimg");
                    // console.log(des.className.split(" ").indexOf("show"));

                    if (document.getElementById('moocvideo')) {
                        var moocVideo = document.getElementById('moocvideo');

                        // console.log('[document.width]', window.innerWidth);
                        if (window.innerWidth <= 760) {
                            moocVideo.style.height = window.innerWidth + 'px';
                        }
                    }

                    if (des.className.split(" ").indexOf("show") <= 0) {
                        des.className += " show";
                        if (mooc.className.split(" ").indexOf("zindex150") <= 0) {
                            mooc.className += " zindex150";
                        }
                        var moocVideoJs = videojs('moocvideo');
                        moocVideoJs.play();

                        // GTM Code starts
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'VLITE_WATCH_DEMOVIDEO',
                            'EventCategory': 'VLITE_DEMO',
                            'EventAction': 'WatchVideo',
                            'EventLabel': 'WATCH_DEMOVIDEO',
                            'EventValue': 1,
                            'Mode': type,
                            'Filename': 'MOOC_Video.mp4',
                            'Version': ver
                        });
                        // End of GTM Code
                    } else {}
                        // var vid =document.getElementById("moocvideo");
                        // vid.src = vid.src;
                        // if(des.className.split(" ").indexOf("show") >= 0) {
                        //     des.classList.remove("show");
                        // }
                        // if(mooc.className.split(" ").indexOf("zindex150") >= 0) {
                        //     mooc.classList.remove("zindex150");
                        // }

                        // popup = document.getElementById("mooc");
                        // popupmooc.classList.toggle("show");
                }
                if (type == 'Entertainment') {
                    var des = document.getElementById("entpopup");
                    var ent = document.getElementById("entimg");

                    if (document.getElementById('entvideo')) {
                        var entVideo = document.getElementById('entvideo');

                        // console.log('[document.width]', window.innerWidth);
                        if (window.innerWidth <= 760) {
                            entVideo.style.height = window.innerWidth + 'px';
                        }
                    }

                    if (des.className.split(" ").indexOf("show") <= 0) {
                        des.className += " show";
                        if (ent.className.split(" ").indexOf("zindex150") <= 0) {
                            ent.className += " zindex150";
                        }
                        var entVideoJs = videojs('entvideo');
                        entVideoJs.play();
                        // GTM Code starts
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'VLITE_WATCH_DEMOVIDEO',
                            'EventCategory': 'VLITE_DEMO',
                            'EventAction': 'WatchVideo',
                            'EventLabel': 'WATCH_DEMOVIDEO',
                            'EventValue': 1,
                            'Mode': type,
                            'Filename': 'Entertainment_Video.mp4',
                            'Version': ver
                        });
                        // End of GTM Code
                    } else {
                            // var vid =document.getElementById("entvideo");
                            // vid.src = vid.src;
                            // if(des.className.split(" ").indexOf("show") >= 0) {
                            //     des.classList.remove("show");
                            // }
                            // if(ent.className.split(" ").indexOf("zindex150") >= 0) {
                            //     ent.classList.remove("zindex150");
                            // }
                        }
                }
            });
        },
        screenResize: function screenResize() {
            var scsize = screen.width;
            if (scsize >= 1500) {
                this.workrect = ['works-rectangle'];
                this.workrectcount = 'wrk-rect-count';
                this.workrecttext = 'wrk-rect-text';
                this.bannerrightimg = 'width90';
                this.normaldevice = true;
                this.smalldevice = false;
                this.storeclass = ['m-top-20', 'store-lg-main-con'];
                this.storeclasssub = ['store-popup-cont'];
                this.storebox = ['store-ios-box', 'top'];
            }if (scsize <= 1499 && scsize >= 1366) {
                this.workrect = ['works-rectangle', 'works-rectangle-p-86'];
                this.workrectcount = 'wrk-rect-count-40';
                this.workrecttext = 'wrk-rect-text-18';
                this.bannerrightimg = 'width90';
                this.normaldevice = true;
                this.smalldevice = false;
                this.storeclass = ['m-top-20', 'store-lg-main-con'];
                this.storeclasssub = ['store-popup-cont'];
                this.storebox = ['store-ios-box', 'top'];
            } else if (scsize <= 1365 && scsize >= 1200) {
                this.workrect = ['works-rectangle', 'works-rectangle-p-98'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerrightimg = 'width90';
                this.normaldevice = true;
                this.smalldevice = false;
                this.storeclass = ['m-top-20', 'store-lg-main-con'];
                this.storeclasssub = ['store-popup-cont'];
                this.storebox = ['store-ios-box', 'top', 'store-ios-m-box'];
            } else if (scsize <= 1199 && scsize >= 960) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerrightimg = 'width80';
                this.normaldevice = true;
                this.smalldevice = false;
                this.storeclass = ['m-top-20', 'store-lg-main-con'];
                this.storeclasssub = ['store-popup-cont'];
                this.storebox = ['store-ios-box', 'top', 'store-ios-m-box'];
            } else if (scsize <= 959 && scsize >= 768) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerrightimg = 'width80';
                this.normaldevice = true;
                this.smalldevice = false;
                this.storeclass = ['m-top-20', 'store-lg-main-con'];
                this.storeclasssub = ['store-popup-cont'];
                this.storebox = ['store-ios-box', 'top', 'store-ios-m-box'];
            } else if (scsize <= 767 && scsize >= 601) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerrightimg = 'width80';
                this.normaldevice = true;
                this.smalldevice = false;
                this.storeclass = ['m-top-20', 'store-lg-main-con'];
                this.storeclasssub = ['store-popup-cont'];
                this.storebox = ['store-ios-box', 'top', 'store-ios-m-box'];
            } else if (scsize <= 600 && scsize >= 481) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerrightimg = 'width80';
                this.normaldevice = false;
                this.smalldevice = true;
                this.storeclass = ['store-sm-main-con'];
                this.storeclasssub = ['m-top-10', 'store-popup-sm-cont'];
                this.storebox = ['store-ios-sm-box', 'top', 'store-ios-sm-box'];
            } else if (scsize <= 480) {
                this.workrect = ['works-rectangle-100'];
                this.workrectcount = 'wrk-rect-count-35';
                this.workrecttext = 'wrk-rect-text-14';
                this.bannerrightimg = 'width80';
                this.normaldevice = false;
                this.smalldevice = true;
                this.storeclass = ['store-sm-main-con'];
                this.storeclasssub = ['m-top-10', 'store-popup-sm-cont'];
                this.storebox = ['store-ios-sm-box', 'top', 'store-ios-sm-box'];
            }
        },

        formsubmit: function formsubmit() {
            this.validateBeforeSubmit();
            //prepare data
            if (this.formSubmitted) {
                this.mainloaderStatus = true;
                var formData = new FormData();
                var demoData = new Object();
                formData.append('name', this.name);
                formData.append('email', this.email);
                formData.append('number', this.mobile);
                formData.append('type', 'LIVE');

                demoData.name = this.name;
                demoData.email = this.email;
                demoData.mobile = this.mobile;
                //vendor mode checking
                var type = 'MOOC';
                var inputElements = document.getElementsByName("type");
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].checked) {
                        if (inputElements[i].value == 'Entertainment') {
                            type = 'Entertainment';
                            break;
                        }
                    }
                }
                formData.append('mode', type);
                this.tempmode = type;
                demoData.tempmode = this.tempmode;
                this.requestfordemo(formData, demoData);
            }
        },
        validateBeforeSubmit: function validateBeforeSubmit(e) {
            this.$validator.validateAll();
            var terms = document.getElementById("agree").checked;
            if (!this.errors.any()) {
                if (!terms) {
                    document.getElementById('terms').setAttribute("class", "control__indicator red-border");
                    this.formSubmitted = false;
                } else {
                    document.getElementById('terms').setAttribute("class", "control__indicator");
                    this.formSubmitted = true;
                }
            } else {
                this.$scrollTo('#signupform1');
                this.formSubmitted = false;
            }
        },
        requestfordemo: function requestfordemo(data, demoData) {
            var retrievedObject = localStorage.getItem('themeObject');
            var resobj = JSON.parse(retrievedObject);
            var theme = new Date(resobj.number);
            var ver = 'A';
            if (theme % 2 != 0) {
                ver = 'B';
            }

            this.$ga.event({
                eventCategory: 'VLITE_DEMO',
                eventAction: 'DemoRequest',
                eventLabel: 'VLITE_DEMOREQUEST_EVENT',
                eventValue: 1,
                'Name': this.name,
                'Emailid': this.email,
                'Contact': this.mobile,
                'Mode': this.tempmode
            });
            var url = this.apibaseurl + '/vendor/v1/demorequest';
            var formData = data;
            // var hurl = window.location.protocol+"//"+url;
            var hurl = url;
            // console.log(data);
            // var email = data.get('vendoremail');
            this.$http.post(hurl, formData).then(function (response) {
                this.mainloaderStatus = false;
                console.log("Success" + response.data);
                var result = response.data;
                if (result.success) {
                    // GTM Code starts
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_DEMO_REQUEST',
                        'EventCategory': 'VLITE_DEMO',
                        'EventAction': 'DemoRequest',
                        'EventLabel': 'DEMO_REQUEST_SUCCESS',
                        'EventValue': 1,
                        'Name': this.name,
                        'Emailid': this.email,
                        'Contact': this.mobile,
                        'Mode': this.tempmode,
                        'Version': ver
                    });
                    // End of GTM Code
                    this.$router.push({ name: 'Democonfirm', params: { status: 'success', email: this.email, reason: 'OK' } });
                } else {
                    // GTM Code starts
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'VLITE_DEMO_REQUEST',
                        'EventCategory': 'VLITE_DEMO',
                        'EventAction': 'DemoRequest',
                        'EventLabel': 'DEMO_REQUEST_FAILURE',
                        'EventValue': 1,
                        'Name': this.name,
                        'Emailid': this.email,
                        'Contact': this.mobile,
                        'Mode': this.tempmode,
                        'Version': ver
                    });
                    // End of GTM Code
                    this.$router.push({ name: 'Democonfirm', params: { status: 'failed', email: this.email, reason: result.reason, demoData: demoData } });
                }
            }, function (response) {
                this.mainloaderStatus = false;
                console.log("Failed");
                // GTM Code starts
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'VLITE_DEMO_REQUEST',
                    'EventCategory': 'VLITE_DEMO',
                    'EventAction': 'DemoRequest',
                    'EventLabel': 'DEMO_REQUEST_FAILURE',
                    'EventValue': 1,
                    'Name': this.name,
                    'Emailid': this.email,
                    'Contact': this.mobile,
                    'Mode': this.tempmode,
                    'Version': ver
                });
                // End of GTM Code
                this.$router.push({ name: 'Democonfirm', params: { status: 'failed', email: this.email, reason: 'Network Error', demoData: demoData } });
            });
        },

        popupoutsidecasmooc: function popupoutsidecasmooc(e) {
            this.mooccasVisible = false;
            this.popupclosecasmoocflag = 0;
        },
        popupoutsidecasent: function popupoutsidecasent(e) {
            this.entcasVisible = false;
            this.popupclosecasentflag = 0;
        },
        popupoutsidemodmooc: function popupoutsidemodmooc(e) {
            // console.log('close Modern mooc '+this.popupclosemodmoocflag);
            this.moocmodVisible = false;
            this.popupclosemodmoocflag = 0;
        },
        popupoutsidemodent: function popupoutsidemodent(e) {
            // console.log('close Modern Entertainment '+this.popupclosemodentflag);
            this.entmodVisible = false;
            this.popupclosemodentflag = 0;
        },
        demoAppDownload: function demoAppDownload(mode, template, platform) {
            var retrievedObject = localStorage.getItem('themeObject');
            var resobj = JSON.parse(retrievedObject);
            var theme = new Date(resobj.number);
            var ver = 'A';
            if (theme % 2 != 0) {
                ver = 'B';
            }

            // GTM Code starts
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'VLITE_DEMO_DOWNLOAD',
                'EventCategory': 'VLITE_DEMO',
                'EventAction': 'DemoDownload',
                'EventLabel': 'DEMO_DOWNLOAD',
                'EventValue': 1,
                'Mode': mode,
                'Template': template,
                'Platform': platform,
                'Version': ver
            });

            // End of GTM Code
            if (platform == 'IOS') {
                // this.enablepopupclose = false;
                // this.enablepopupcounter = 0;
                if (template == 'Entertainment') {
                    if (mode == 'Casual') {
                        this.entcasVisible = true;
                        // this.popupclosecasentflag++;

                        this.entmodVisible = false;
                        this.mooccasVisible = false;
                        this.moocmodVisible = false;

                        this.entcasVisiblecontent = true;
                        this.entcasVisiblesuccess = false;
                        this.entcasVisibleerror = false;
                    }
                    if (mode == 'Modern') {
                        this.entmodVisible = true;
                        this.entcasVisible = false;
                        this.mooccasVisible = false;
                        this.moocmodVisible = false;
                        // this.popupclosemodentflag++;

                        this.entmodVisiblecontent = true;
                        this.entmodVisiblesuccess = false;
                        this.entmodVisibleerror = false;
                    }
                }
                if (template == 'MOOC') {
                    if (mode == 'Casual') {
                        this.mooccasVisible = true;
                        // this.popupclosecasmoocflag++;

                        this.entcasVisible = false;
                        this.entmodVisible = false;
                        this.moocmodVisible = false;

                        this.mooccasVisiblecontent = true;
                        this.mooccasVisiblesuccess = false;
                        this.mooccasVisibleerror = false;
                    }
                    if (mode == 'Modern') {
                        this.moocmodVisible = true;
                        // this.popupclosemodmoocflag++;


                        this.entcasVisible = false;
                        this.entmodVisible = false;
                        this.mooccasVisible = false;

                        this.moocmodVisiblecontent = true;
                        this.moocmodVisiblesuccess = false;
                        this.moocmodVisibleerror = false;
                    }
                }
            }
        },
        closeiosbox: function closeiosbox(mode, template, platform) {
            if (platform == 'IOS') {
                if (template == 'Entertainment') {
                    if (mode == 'Casual') {
                        this.entcasVisible = false;
                        this.popupclosecasentflag = 0;
                    }
                    if (mode == 'Modern') {
                        this.entmodVisible = false;
                        this.popupclosemodentflag = 0;
                    }
                }

                if (template == 'MOOC') {
                    if (mode == 'Casual') {
                        this.mooccasVisible = false;
                        this.popupclosecasmoocflag = 0;
                    }
                    if (mode == 'Modern') {
                        this.moocmodVisible = false;
                        this.popupclosemodmoocflag = 0;
                    }
                }
            }
        },
        navigateToHomeWithDiv: function navigateToHomeWithDiv(divname) {
            this.$router.push({ name: 'Home', params: { divid: divname } });
        },
        openNewTab: function openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        },
        openSocialNewTab: function openSocialNewTab(surl) {
            window.open(surl, '_blank');
        },
        scroll: function scroll(element) {
            document.getElementById(element).scrollIntoView();
            //var ele = document.getElementById(element);
            //window.scrollTo(ele.offsetLeft,ele.offsetTop);
        },
        restoreData: function restoreData() {
            //console.log(this.demoData);
            if (Object.keys(this.demoData).length > 0) {
                this.name = this.demoData.name;
                this.email = this.demoData.email;
                this.mobile = this.demoData.mobile;
                var inputElements = document.getElementsByName("type");
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].value == this.demoData.tempmode) {
                        inputElements[i].checked = true;
                        break;
                    }
                }
                this.$scrollTo('#livedemo');
            }
        }
    },
    directives: {
        'click-outside': {
            bind: function bind(el, binding, vNode) {

                var bubble = binding.modifiers.bubble;
                var handler = function handler(e) {
                    if (bubble || !el.contains(e.target) && el !== e.target) {
                        binding.value(e);
                    }
                };
                el.__vueClickOutside__ = handler;

                // add Event Listeners
                document.addEventListener('click', handler);
            },

            unbind: function unbind(el, binding) {
                // Remove Event Listeners
                document.removeEventListener('click', el.__vueClickOutside__);
                el.__vueClickOutside__ = null;
            }
        }
    }
});

/***/ }),

/***/ "rR+j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/analyticsboard.bf5ec88.svg";

/***/ }),

/***/ "tbYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ua3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__ = __webpack_require__("b6pE");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40314160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__ = __webpack_require__("H2i2");
function injectStyle (ssrContext) {
  __webpack_require__("UhIG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40314160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vX6J":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "vgQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return Config; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Config = function () {
    function createToken() {
        _classCallCheck(this, createToken);

        var production = true;
        if (production) {
            this.apibaseurl = 'vlitevendor.mobiotics.com';
            this.vendorportalurl = 'vlite.mobiotics.com';
            this.stripelogo = 'vlite.mobiotics.com/largeimage/vLiteLogo.png';
            this.largeimage = 'vlite.mobiotics.com/largeimage';
        } else {
            this.apibaseurl = 'vlitetest.mobiotics.com';
            this.vendorportalurl = 'vlitetest.mobiotics.com/vendorui/ui';
            this.stripelogo = 'vliteprelaunchtest.mobiotics.com/largeimage/vLiteLogo.png';
            this.largeimage = 'vliteprelaunchtest.mobiotics.com/largeimage';
        }
    }

    _createClass(createToken, [{
        key: 'getApiUrl',
        value: function getApiUrl() {
            return window.location.protocol + '//' + this.apibaseurl;
        }
    }, {
        key: 'getPortalUrl',
        value: function getPortalUrl() {
            return window.location.protocol + '//' + this.vendorportalurl;
        }
    }, {
        key: 'getStripeLogo',
        value: function getStripeLogo() {
            return window.location.protocol + '//' + this.stripelogo;
        }
    }, {
        key: 'getlargeImgPath',
        value: function getlargeImgPath() {
            return window.location.protocol + '//' + this.largeimage;
        }
    }]);

    return createToken;
}();

/***/ }),

/***/ "vv/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "woOV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/modern-light.66651c3.png";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app'
});

/***/ }),

/***/ "zweM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Failed_vue__ = __webpack_require__("ZYGH");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a6a3efd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Failed_vue__ = __webpack_require__("kHVx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Failed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a6a3efd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Failed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2b00ee5a92f828f6214a.js